// Generated from Language.g4 by ANTLR 4.8
// jshint ignore: start
var antlr4 = require('antlr4/index');
var grammarFileName = "Language.g4";


var serializedATN = ["\u0003\u608b\ua72a\u8133\ub9ed\u417c\u3be7\u7786\u5964",
    "\u0003i\u03e1\u0004\u0002\t\u0002\u0004\u0003\t\u0003\u0004\u0004\t",
    "\u0004\u0004\u0005\t\u0005\u0004\u0006\t\u0006\u0004\u0007\t\u0007\u0004",
    "\b\t\b\u0004\t\t\t\u0004\n\t\n\u0004\u000b\t\u000b\u0004\f\t\f\u0004",
    "\r\t\r\u0004\u000e\t\u000e\u0004\u000f\t\u000f\u0004\u0010\t\u0010\u0004",
    "\u0011\t\u0011\u0004\u0012\t\u0012\u0004\u0013\t\u0013\u0004\u0014\t",
    "\u0014\u0004\u0015\t\u0015\u0004\u0016\t\u0016\u0004\u0017\t\u0017\u0004",
    "\u0018\t\u0018\u0004\u0019\t\u0019\u0004\u001a\t\u001a\u0004\u001b\t",
    "\u001b\u0004\u001c\t\u001c\u0004\u001d\t\u001d\u0004\u001e\t\u001e\u0004",
    "\u001f\t\u001f\u0004 \t \u0004!\t!\u0004\"\t\"\u0004#\t#\u0004$\t$\u0003",
    "\u0002\u0007\u0002J\n\u0002\f\u0002\u000e\u0002M\u000b\u0002\u0003\u0002",
    "\u0003\u0002\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003",
    "\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0003\u0005\u0003Z\n\u0003",
    "\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004\u0003\u0004",
    "\u0003\u0005\u0003\u0005\u0003\u0005\u0003\u0005\u0003\u0005\u0003\u0005",
    "\u0005\u0005h\n\u0005\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006",
    "\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006",
    "\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006",
    "\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006",
    "\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006\u0003\u0006",
    "\u0003\u0006\u0003\u0006\u0005\u0006\u0088\n\u0006\u0003\u0007\u0003",
    "\u0007\u0005\u0007\u008c\n\u0007\u0003\u0007\u0003\u0007\u0003\b\u0003",
    "\b\u0003\b\u0003\b\u0003\b\u0003\b\u0003\b\u0005\b\u0097\n\b\u0003\t",
    "\u0003\t\u0007\t\u009b\n\t\f\t\u000e\t\u009e\u000b\t\u0003\t\u0003\t",
    "\u0005\t\u00a2\n\t\u0003\n\u0003\n\u0003\n\u0003\n\u0003\n\u0003\n\u0003",
    "\n\u0003\n\u0003\n\u0003\n\u0003\n\u0003\n\u0003\n\u0003\n\u0005\n\u00b2",
    "\n\n\u0003\n\u0003\n\u0003\n\u0003\n\u0003\n\u0003\n\u0007\n\u00ba\n",
    "\n\f\n\u000e\n\u00bd\u000b\n\u0003\u000b\u0003\u000b\u0003\u000b\u0003",
    "\u000b\u0006\u000b\u00c3\n\u000b\r\u000b\u000e\u000b\u00c4\u0003\u000b",
    "\u0005\u000b\u00c8\n\u000b\u0003\u000b\u0003\u000b\u0003\f\u0003\f\u0003",
    "\f\u0003\f\u0003\f\u0006\f\u00d1\n\f\r\f\u000e\f\u00d2\u0003\f\u0003",
    "\f\u0003\f\u0005\f\u00d8\n\f\u0003\r\u0003\r\u0003\r\u0003\r\u0006\r",
    "\u00de\n\r\r\r\u000e\r\u00df\u0003\r\u0003\r\u0003\r\u0005\r\u00e5\n",
    "\r\u0003\u000e\u0003\u000e\u0003\u000e\u0003\u000e\u0003\u000e\u0003",
    "\u000e\u0003\u000e\u0003\u000e\u0003\u000e\u0003\u000e\u0005\u000e\u00f1",
    "\n\u000e\u0003\u000f\u0003\u000f\u0003\u0010\u0003\u0010\u0003\u0011",
    "\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0011\u0003\u0011\u0007\u0011",
    "\u00fd\n\u0011\f\u0011\u000e\u0011\u0100\u000b\u0011\u0003\u0011\u0003",
    "\u0011\u0003\u0012\u0003\u0012\u0003\u0012\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0005\u0013\u0135\n\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0005\u0013\u0142\n\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0005\u0013\u014d\n\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0005\u0013\u015a\n",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0005\u0013\u016c",
    "\n\u0013\u0003\u0013\u0003\u0013\u0005\u0013\u0170\n\u0013\u0003\u0013",
    "\u0003\u0013\u0005\u0013\u0174\n\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0005\u0013\u017f\n\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0005\u0013",
    "\u018f\n\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0005\u0013\u019f\n\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0005\u0013\u01af\n\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0005\u0013\u01bd",
    "\n\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0005\u0013",
    "\u01c9\n\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0006\u0013\u01d7\n\u0013\r\u0013\u000e\u0013\u01d8",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0007\u0013\u0215\n",
    "\u0013\f\u0013\u000e\u0013\u0218\u000b\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0007\u0013\u0231\n\u0013\f\u0013",
    "\u000e\u0013\u0234\u000b\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0007",
    "\u0013\u024b\n\u0013\f\u0013\u000e\u0013\u024e\u000b\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0007\u0013\u0265\n\u0013\f\u0013\u000e\u0013",
    "\u0268\u000b\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0007\u0013\u0281\n\u0013\f\u0013\u000e\u0013\u0284\u000b\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0007\u0013\u029b\n\u0013\f\u0013",
    "\u000e\u0013\u029e\u000b\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0005\u0013\u02fb\n\u0013",
    "\u0003\u0013\u0003\u0013\u0005\u0013\u02ff\n\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0005\u0013\u034c\n\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013",
    "\u0003\u0013\u0003\u0013\u0006\u0013\u035e\n\u0013\r\u0013\u000e\u0013",
    "\u035f\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0003",
    "\u0013\u0003\u0013\u0003\u0013\u0003\u0013\u0005\u0013\u036b\n\u0013",
    "\u0003\u0014\u0003\u0014\u0003\u0015\u0003\u0015\u0003\u0016\u0003\u0016",
    "\u0003\u0016\u0003\u0016\u0003\u0016\u0003\u0016\u0003\u0016\u0003\u0016",
    "\u0003\u0016\u0005\u0016\u037a\n\u0016\u0003\u0016\u0003\u0016\u0003",
    "\u0016\u0003\u0016\u0003\u0016\u0003\u0016\u0003\u0016\u0003\u0016\u0007",
    "\u0016\u0384\n\u0016\f\u0016\u000e\u0016\u0387\u000b\u0016\u0003\u0017",
    "\u0003\u0017\u0003\u0017\u0003\u0017\u0003\u0017\u0003\u0017\u0005\u0017",
    "\u038f\n\u0017\u0003\u0018\u0003\u0018\u0003\u0018\u0003\u0018\u0003",
    "\u0018\u0003\u0018\u0005\u0018\u0397\n\u0018\u0003\u0019\u0003\u0019",
    "\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019",
    "\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019\u0003\u0019",
    "\u0003\u0019\u0003\u0019\u0003\u0019\u0005\u0019\u03aa\n\u0019\u0003",
    "\u001a\u0003\u001a\u0003\u001a\u0003\u001a\u0003\u001b\u0003\u001b\u0003",
    "\u001b\u0003\u001b\u0003\u001c\u0003\u001c\u0003\u001c\u0003\u001c\u0003",
    "\u001c\u0003\u001c\u0003\u001c\u0003\u001d\u0003\u001d\u0003\u001d\u0003",
    "\u001d\u0003\u001d\u0003\u001d\u0003\u001d\u0003\u001d\u0003\u001d\u0003",
    "\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001e\u0003\u001f\u0003",
    "\u001f\u0003\u001f\u0003\u001f\u0003\u001f\u0003\u001f\u0005\u001f\u03cf",
    "\n\u001f\u0003 \u0003 \u0003 \u0003 \u0003 \u0003 \u0003 \u0003 \u0003",
    "!\u0003!\u0003\"\u0003\"\u0003#\u0003#\u0003$\u0003$\u0003$\u0002\u0004",
    "\u0012*%\u0002\u0004\u0006\b\n\f\u000e\u0010\u0012\u0014\u0016\u0018",
    "\u001a\u001c\u001e \"$&(*,.02468:<>@BDF\u0002\b\u0003\u0002KP\u0003",
    "\u0002TX\u0003\u0002GH\u0003\u0002IJ\u0003\u0002\u000f\u0010\u0003\u0002",
    "QS\u0002\u044c\u0002K\u0003\u0002\u0002\u0002\u0004Y\u0003\u0002\u0002",
    "\u0002\u0006[\u0003\u0002\u0002\u0002\bg\u0003\u0002\u0002\u0002\n\u0087",
    "\u0003\u0002\u0002\u0002\f\u0089\u0003\u0002\u0002\u0002\u000e\u008f",
    "\u0003\u0002\u0002\u0002\u0010\u00a1\u0003\u0002\u0002\u0002\u0012\u00b1",
    "\u0003\u0002\u0002\u0002\u0014\u00be\u0003\u0002\u0002\u0002\u0016\u00cb",
    "\u0003\u0002\u0002\u0002\u0018\u00d9\u0003\u0002\u0002\u0002\u001a\u00f0",
    "\u0003\u0002\u0002\u0002\u001c\u00f2\u0003\u0002\u0002\u0002\u001e\u00f4",
    "\u0003\u0002\u0002\u0002 \u00f6\u0003\u0002\u0002\u0002\"\u0103\u0003",
    "\u0002\u0002\u0002$\u036a\u0003\u0002\u0002\u0002&\u036c\u0003\u0002",
    "\u0002\u0002(\u036e\u0003\u0002\u0002\u0002*\u0379\u0003\u0002\u0002",
    "\u0002,\u038e\u0003\u0002\u0002\u0002.\u0396\u0003\u0002\u0002\u0002",
    "0\u03a9\u0003\u0002\u0002\u00022\u03ab\u0003\u0002\u0002\u00024\u03af",
    "\u0003\u0002\u0002\u00026\u03b3\u0003\u0002\u0002\u00028\u03ba\u0003",
    "\u0002\u0002\u0002:\u03c3\u0003\u0002\u0002\u0002<\u03c8\u0003\u0002",
    "\u0002\u0002>\u03d0\u0003\u0002\u0002\u0002@\u03d8\u0003\u0002\u0002",
    "\u0002B\u03da\u0003\u0002\u0002\u0002D\u03dc\u0003\u0002\u0002\u0002",
    "F\u03de\u0003\u0002\u0002\u0002HJ\u0005\u0004\u0003\u0002IH\u0003\u0002",
    "\u0002\u0002JM\u0003\u0002\u0002\u0002KI\u0003\u0002\u0002\u0002KL\u0003",
    "\u0002\u0002\u0002LN\u0003\u0002\u0002\u0002MK\u0003\u0002\u0002\u0002",
    "NO\u0005\f\u0007\u0002O\u0003\u0003\u0002\u0002\u0002PZ\u0005\u0006",
    "\u0004\u0002QZ\u0005\u0014\u000b\u0002RS\u0005*\u0016\u0002ST\u0007",
    "g\u0002\u0002TZ\u0003\u0002\u0002\u0002UZ\u0005\u000e\b\u0002VZ\u0005",
    " \u0011\u0002WZ\u0005\"\u0012\u0002XZ\u0005\n\u0006\u0002YP\u0003\u0002",
    "\u0002\u0002YQ\u0003\u0002\u0002\u0002YR\u0003\u0002\u0002\u0002YU\u0003",
    "\u0002\u0002\u0002YV\u0003\u0002\u0002\u0002YW\u0003\u0002\u0002\u0002",
    "YX\u0003\u0002\u0002\u0002Z\u0005\u0003\u0002\u0002\u0002[\\\u0007Z",
    "\u0002\u0002\\]\u0007d\u0002\u0002]^\u0007T\u0002\u0002^_\u0005\b\u0005",
    "\u0002_`\u0007g\u0002\u0002`\u0007\u0003\u0002\u0002\u0002ah\u0005*",
    "\u0016\u0002bh\u0005\u001a\u000e\u0002cd\u0007C\u0002\u0002dh\u0007",
    "D\u0002\u0002ef\u0007A\u0002\u0002fh\u0007B\u0002\u0002ga\u0003\u0002",
    "\u0002\u0002gb\u0003\u0002\u0002\u0002gc\u0003\u0002\u0002\u0002ge\u0003",
    "\u0002\u0002\u0002h\t\u0003\u0002\u0002\u0002ij\u0007d\u0002\u0002j",
    "k\u0005\u001e\u0010\u0002kl\u0005\b\u0005\u0002lm\u0007g\u0002\u0002",
    "m\u0088\u0003\u0002\u0002\u0002no\u0007d\u0002\u0002op\u0007_\u0002",
    "\u0002pq\u0007d\u0002\u0002qr\u0005\u001e\u0010\u0002rs\u0005\b\u0005",
    "\u0002st\u0007g\u0002\u0002t\u0088\u0003\u0002\u0002\u0002uv\u0007d",
    "\u0002\u0002vw\u0007A\u0002\u0002wx\u0005*\u0016\u0002xy\u0007B\u0002",
    "\u0002yz\u0005\u001e\u0010\u0002z{\u0005\b\u0005\u0002{|\u0007g\u0002",
    "\u0002|\u0088\u0003\u0002\u0002\u0002}~\u0007d\u0002\u0002~\u007f\u0007",
    "A\u0002\u0002\u007f\u0080\u0005*\u0016\u0002\u0080\u0081\u0007B\u0002",
    "\u0002\u0081\u0082\u0007_\u0002\u0002\u0082\u0083\u0007d\u0002\u0002",
    "\u0083\u0084\u0005\u001e\u0010\u0002\u0084\u0085\u0005\b\u0005\u0002",
    "\u0085\u0086\u0007g\u0002\u0002\u0086\u0088\u0003\u0002\u0002\u0002",
    "\u0087i\u0003\u0002\u0002\u0002\u0087n\u0003\u0002\u0002\u0002\u0087",
    "u\u0003\u0002\u0002\u0002\u0087}\u0003\u0002\u0002\u0002\u0088\u000b",
    "\u0003\u0002\u0002\u0002\u0089\u008b\u0007]\u0002\u0002\u008a\u008c",
    "\u0005*\u0016\u0002\u008b\u008a\u0003\u0002\u0002\u0002\u008b\u008c",
    "\u0003\u0002\u0002\u0002\u008c\u008d\u0003\u0002\u0002\u0002\u008d\u008e",
    "\u0007g\u0002\u0002\u008e\r\u0003\u0002\u0002\u0002\u008f\u0090\u0007",
    "\u0005\u0002\u0002\u0090\u0091\u0007E\u0002\u0002\u0091\u0092\u0005",
    "\u0012\n\u0002\u0092\u0093\u0007F\u0002\u0002\u0093\u0096\u0005\u0010",
    "\t\u0002\u0094\u0095\u0007\u0006\u0002\u0002\u0095\u0097\u0005\u0010",
    "\t\u0002\u0096\u0094\u0003\u0002\u0002\u0002\u0096\u0097\u0003\u0002",
    "\u0002\u0002\u0097\u000f\u0003\u0002\u0002\u0002\u0098\u009c\u0007C",
    "\u0002\u0002\u0099\u009b\u0005\u0004\u0003\u0002\u009a\u0099\u0003\u0002",
    "\u0002\u0002\u009b\u009e\u0003\u0002\u0002\u0002\u009c\u009a\u0003\u0002",
    "\u0002\u0002\u009c\u009d\u0003\u0002\u0002\u0002\u009d\u009f\u0003\u0002",
    "\u0002\u0002\u009e\u009c\u0003\u0002\u0002\u0002\u009f\u00a2\u0007D",
    "\u0002\u0002\u00a0\u00a2\u0005\u0004\u0003\u0002\u00a1\u0098\u0003\u0002",
    "\u0002\u0002\u00a1\u00a0\u0003\u0002\u0002\u0002\u00a2\u0011\u0003\u0002",
    "\u0002\u0002\u00a3\u00a4\b\n\u0001\u0002\u00a4\u00b2\u0005\u001a\u000e",
    "\u0002\u00a5\u00a6\u0007\u000e\u0002\u0002\u00a6\u00a7\u0007E\u0002",
    "\u0002\u00a7\u00a8\u0005\u0012\n\u0002\u00a8\u00a9\u0007F\u0002\u0002",
    "\u00a9\u00b2\u0003\u0002\u0002\u0002\u00aa\u00ab\u0007E\u0002\u0002",
    "\u00ab\u00ac\u0005\u0012\n\u0002\u00ac\u00ad\u0007F\u0002\u0002\u00ad",
    "\u00b2\u0003\u0002\u0002\u0002\u00ae\u00af\u0007\u000e\u0002\u0002\u00af",
    "\u00b2\u00050\u0019\u0002\u00b0\u00b2\u00050\u0019\u0002\u00b1\u00a3",
    "\u0003\u0002\u0002\u0002\u00b1\u00a5\u0003\u0002\u0002\u0002\u00b1\u00aa",
    "\u0003\u0002\u0002\u0002\u00b1\u00ae\u0003\u0002\u0002\u0002\u00b1\u00b0",
    "\u0003\u0002\u0002\u0002\u00b2\u00bb\u0003\u0002\u0002\u0002\u00b3\u00b4",
    "\f\t\u0002\u0002\u00b4\u00b5\u0007\f\u0002\u0002\u00b5\u00ba\u0005\u0012",
    "\n\n\u00b6\u00b7\f\b\u0002\u0002\u00b7\u00b8\u0007\r\u0002\u0002\u00b8",
    "\u00ba\u0005\u0012\n\t\u00b9\u00b3\u0003\u0002\u0002\u0002\u00b9\u00b6",
    "\u0003\u0002\u0002\u0002\u00ba\u00bd\u0003\u0002\u0002\u0002\u00bb\u00b9",
    "\u0003\u0002\u0002\u0002\u00bb\u00bc\u0003\u0002\u0002\u0002\u00bc\u0013",
    "\u0003\u0002\u0002\u0002\u00bd\u00bb\u0003\u0002\u0002\u0002\u00be\u00bf",
    "\u0007\u0007\u0002\u0002\u00bf\u00c0\u0005*\u0016\u0002\u00c0\u00c2",
    "\u0007C\u0002\u0002\u00c1\u00c3\u0005\u0016\f\u0002\u00c2\u00c1\u0003",
    "\u0002\u0002\u0002\u00c3\u00c4\u0003\u0002\u0002\u0002\u00c4\u00c2\u0003",
    "\u0002\u0002\u0002\u00c4\u00c5\u0003\u0002\u0002\u0002\u00c5\u00c7\u0003",
    "\u0002\u0002\u0002\u00c6\u00c8\u0005\u0018\r\u0002\u00c7\u00c6\u0003",
    "\u0002\u0002\u0002\u00c7\u00c8\u0003\u0002\u0002\u0002\u00c8\u00c9\u0003",
    "\u0002\u0002\u0002\u00c9\u00ca\u0007D\u0002\u0002\u00ca\u0015\u0003",
    "\u0002\u0002\u0002\u00cb\u00cc\u0007\b\u0002\u0002\u00cc\u00cd\u0005",
    "*\u0016\u0002\u00cd\u00d7\u0007h\u0002\u0002\u00ce\u00d0\u0007C\u0002",
    "\u0002\u00cf\u00d1\u0005\u0004\u0003\u0002\u00d0\u00cf\u0003\u0002\u0002",
    "\u0002\u00d1\u00d2\u0003\u0002\u0002\u0002\u00d2\u00d0\u0003\u0002\u0002",
    "\u0002\u00d2\u00d3\u0003\u0002\u0002\u0002\u00d3\u00d4\u0003\u0002\u0002",
    "\u0002\u00d4\u00d5\u0007D\u0002\u0002\u00d5\u00d8\u0003\u0002\u0002",
    "\u0002\u00d6\u00d8\u0005\u0004\u0003\u0002\u00d7\u00ce\u0003\u0002\u0002",
    "\u0002\u00d7\u00d6\u0003\u0002\u0002\u0002\u00d8\u0017\u0003\u0002\u0002",
    "\u0002\u00d9\u00da\u0007\t\u0002\u0002\u00da\u00e4\u0007h\u0002\u0002",
    "\u00db\u00dd\u0007C\u0002\u0002\u00dc\u00de\u0005\u0004\u0003\u0002",
    "\u00dd\u00dc\u0003\u0002\u0002\u0002\u00de\u00df\u0003\u0002\u0002\u0002",
    "\u00df\u00dd\u0003\u0002\u0002\u0002\u00df\u00e0\u0003\u0002\u0002\u0002",
    "\u00e0\u00e1\u0003\u0002\u0002\u0002\u00e1\u00e2\u0007D\u0002\u0002",
    "\u00e2\u00e5\u0003\u0002\u0002\u0002\u00e3\u00e5\u0005\u0004\u0003\u0002",
    "\u00e4\u00db\u0003\u0002\u0002\u0002\u00e4\u00e3\u0003\u0002\u0002\u0002",
    "\u00e5\u0019\u0003\u0002\u0002\u0002\u00e6\u00e7\u0005*\u0016\u0002",
    "\u00e7\u00e8\u0005\u001c\u000f\u0002\u00e8\u00e9\u0005*\u0016\u0002",
    "\u00e9\u00f1\u0003\u0002\u0002\u0002\u00ea\u00eb\u0007E\u0002\u0002",
    "\u00eb\u00ec\u0005\u001a\u000e\u0002\u00ec\u00ed\u0007F\u0002\u0002",
    "\u00ed\u00f1\u0003\u0002\u0002\u0002\u00ee\u00f1\u0005$\u0013\u0002",
    "\u00ef\u00f1\u00050\u0019\u0002\u00f0\u00e6\u0003\u0002\u0002\u0002",
    "\u00f0\u00ea\u0003\u0002\u0002\u0002\u00f0\u00ee\u0003\u0002\u0002\u0002",
    "\u00f0\u00ef\u0003\u0002\u0002\u0002\u00f1\u001b\u0003\u0002\u0002\u0002",
    "\u00f2\u00f3\t\u0002\u0002\u0002\u00f3\u001d\u0003\u0002\u0002\u0002",
    "\u00f4\u00f5\t\u0003\u0002\u0002\u00f5\u001f\u0003\u0002\u0002\u0002",
    "\u00f6\u00f7\u0007\n\u0002\u0002\u00f7\u00f8\u0007E\u0002\u0002\u00f8",
    "\u00f9\u0005\u0012\n\u0002\u00f9\u00fa\u0007F\u0002\u0002\u00fa\u00fe",
    "\u0007C\u0002\u0002\u00fb\u00fd\u0005\u0004\u0003\u0002\u00fc\u00fb",
    "\u0003\u0002\u0002\u0002\u00fd\u0100\u0003\u0002\u0002\u0002\u00fe\u00fc",
    "\u0003\u0002\u0002\u0002\u00fe\u00ff\u0003\u0002\u0002\u0002\u00ff\u0101",
    "\u0003\u0002\u0002\u0002\u0100\u00fe\u0003\u0002\u0002\u0002\u0101\u0102",
    "\u0007D\u0002\u0002\u0102!\u0003\u0002\u0002\u0002\u0103\u0104\u0007",
    "\u000b\u0002\u0002\u0104\u0105\u0007g\u0002\u0002\u0105#\u0003\u0002",
    "\u0002\u0002\u0106\u0107\u0007%\u0002\u0002\u0107\u0108\u0007E\u0002",
    "\u0002\u0108\u0109\u0005@!\u0002\u0109\u010a\u0007^\u0002\u0002\u010a",
    "\u010b\u0005*\u0016\u0002\u010b\u010c\u0007F\u0002\u0002\u010c\u036b",
    "\u0003\u0002\u0002\u0002\u010d\u010e\u0007\'\u0002\u0002\u010e\u010f",
    "\u0007E\u0002\u0002\u010f\u0110\u0005@!\u0002\u0110\u0111\u0007^\u0002",
    "\u0002\u0111\u0112\u0005@!\u0002\u0112\u0113\u0007^\u0002\u0002\u0113",
    "\u0114\u0005*\u0016\u0002\u0114\u0115\u0007F\u0002\u0002\u0115\u036b",
    "\u0003\u0002\u0002\u0002\u0116\u0117\u0007\'\u0002\u0002\u0117\u0118",
    "\u0007E\u0002\u0002\u0118\u0119\u0005@!\u0002\u0119\u011a\u0007^\u0002",
    "\u0002\u011a\u011b\u0005@!\u0002\u011b\u011c\u0007F\u0002\u0002\u011c",
    "\u036b\u0003\u0002\u0002\u0002\u011d\u011e\u0007&\u0002\u0002\u011e",
    "\u011f\u0007E\u0002\u0002\u011f\u0120\u0005@!\u0002\u0120\u0121\u0007",
    "^\u0002\u0002\u0121\u0122\u0005@!\u0002\u0122\u0123\u0007^\u0002\u0002",
    "\u0123\u0124\u0005*\u0016\u0002\u0124\u0125\u0007F\u0002\u0002\u0125",
    "\u036b\u0003\u0002\u0002\u0002\u0126\u0127\u0007&\u0002\u0002\u0127",
    "\u0128\u0007E\u0002\u0002\u0128\u0129\u0005@!\u0002\u0129\u012a\u0007",
    "^\u0002\u0002\u012a\u012b\u0005@!\u0002\u012b\u012c\u0007F\u0002\u0002",
    "\u012c\u036b\u0003\u0002\u0002\u0002\u012d\u012e\u0007(\u0002\u0002",
    "\u012e\u012f\u0007E\u0002\u0002\u012f\u0130\u0005*\u0016\u0002\u0130",
    "\u0131\u0007^\u0002\u0002\u0131\u0134\u0005*\u0016\u0002\u0132\u0133",
    "\u0007^\u0002\u0002\u0133\u0135\u0005*\u0016\u0002\u0134\u0132\u0003",
    "\u0002\u0002\u0002\u0134\u0135\u0003\u0002\u0002\u0002\u0135\u0136\u0003",
    "\u0002\u0002\u0002\u0136\u0137\u0007F\u0002\u0002\u0137\u036b\u0003",
    "\u0002\u0002\u0002\u0138\u0139\u0007)\u0002\u0002\u0139\u013a\u0007",
    "E\u0002\u0002\u013a\u013b\u0005*\u0016\u0002\u013b\u013c\u0007^\u0002",
    "\u0002\u013c\u013d\u0005*\u0016\u0002\u013d\u013e\u0007^\u0002\u0002",
    "\u013e\u0141\u0005*\u0016\u0002\u013f\u0140\u0007^\u0002\u0002\u0140",
    "\u0142\u0005*\u0016\u0002\u0141\u013f\u0003\u0002\u0002\u0002\u0141",
    "\u0142\u0003\u0002\u0002\u0002\u0142\u0143\u0003\u0002\u0002\u0002\u0143",
    "\u0144\u0007F\u0002\u0002\u0144\u036b\u0003\u0002\u0002\u0002\u0145",
    "\u0146\u0007*\u0002\u0002\u0146\u0147\u0007E\u0002\u0002\u0147\u0148",
    "\u0005*\u0016\u0002\u0148\u0149\u0007^\u0002\u0002\u0149\u014c\u0005",
    "*\u0016\u0002\u014a\u014b\u0007^\u0002\u0002\u014b\u014d\u0005*\u0016",
    "\u0002\u014c\u014a\u0003\u0002\u0002\u0002\u014c\u014d\u0003\u0002\u0002",
    "\u0002\u014d\u014e\u0003\u0002\u0002\u0002\u014e\u014f\u0007F\u0002",
    "\u0002\u014f\u036b\u0003\u0002\u0002\u0002\u0150\u0151\u0007+\u0002",
    "\u0002\u0151\u0152\u0007E\u0002\u0002\u0152\u0153\u0005*\u0016\u0002",
    "\u0153\u0154\u0007^\u0002\u0002\u0154\u0155\u0005*\u0016\u0002\u0155",
    "\u0156\u0007^\u0002\u0002\u0156\u0159\u0005*\u0016\u0002\u0157\u0158",
    "\u0007^\u0002\u0002\u0158\u015a\u0005*\u0016\u0002\u0159\u0157\u0003",
    "\u0002\u0002\u0002\u0159\u015a\u0003\u0002\u0002\u0002\u015a\u015b\u0003",
    "\u0002\u0002\u0002\u015b\u015c\u0007F\u0002\u0002\u015c\u036b\u0003",
    "\u0002\u0002\u0002\u015d\u015e\u0007-\u0002\u0002\u015e\u015f\u0007",
    "E\u0002\u0002\u015f\u0160\u0005*\u0016\u0002\u0160\u0161\u0007^\u0002",
    "\u0002\u0161\u0162\u0005*\u0016\u0002\u0162\u0163\u0007^\u0002\u0002",
    "\u0163\u0164\u0005*\u0016\u0002\u0164\u0165\u0007F\u0002\u0002\u0165",
    "\u036b\u0003\u0002\u0002\u0002\u0166\u0167\u0007,\u0002\u0002\u0167",
    "\u0168\u0007E\u0002\u0002\u0168\u016b\u0005*\u0016\u0002\u0169\u016a",
    "\u0007^\u0002\u0002\u016a\u016c\u0005*\u0016\u0002\u016b\u0169\u0003",
    "\u0002\u0002\u0002\u016b\u016c\u0003\u0002\u0002\u0002\u016c\u016f\u0003",
    "\u0002\u0002\u0002\u016d\u016e\u0007^\u0002\u0002\u016e\u0170\u0005",
    "*\u0016\u0002\u016f\u016d\u0003\u0002\u0002\u0002\u016f\u0170\u0003",
    "\u0002\u0002\u0002\u0170\u0173\u0003\u0002\u0002\u0002\u0171\u0172\u0007",
    "^\u0002\u0002\u0172\u0174\u0005*\u0016\u0002\u0173\u0171\u0003\u0002",
    "\u0002\u0002\u0173\u0174\u0003\u0002\u0002\u0002\u0174\u0175\u0003\u0002",
    "\u0002\u0002\u0175\u0176\u0007F\u0002\u0002\u0176\u036b\u0003\u0002",
    "\u0002\u0002\u0177\u0178\u0007\u001e\u0002\u0002\u0178\u0179\u0007E",
    "\u0002\u0002\u0179\u017a\u0007f\u0002\u0002\u017a\u017b\u0007_\u0002",
    "\u0002\u017b\u017e\u0007d\u0002\u0002\u017c\u017d\u0007_\u0002\u0002",
    "\u017d\u017f\u0007d\u0002\u0002\u017e\u017c\u0003\u0002\u0002\u0002",
    "\u017e\u017f\u0003\u0002\u0002\u0002\u017f\u0180\u0003\u0002\u0002\u0002",
    "\u0180\u036b\u0007F\u0002\u0002\u0181\u0182\u0007\u001e\u0002\u0002",
    "\u0182\u0183\u0007E\u0002\u0002\u0183\u0184\u0007d\u0002\u0002\u0184",
    "\u0185\u0007_\u0002\u0002\u0185\u0186\u0007d\u0002\u0002\u0186\u036b",
    "\u0007F\u0002\u0002\u0187\u0188\u0007\u001f\u0002\u0002\u0188\u0189",
    "\u0007E\u0002\u0002\u0189\u018a\u0007f\u0002\u0002\u018a\u018b\u0007",
    "_\u0002\u0002\u018b\u018e\u0007d\u0002\u0002\u018c\u018d\u0007_\u0002",
    "\u0002\u018d\u018f\u0007d\u0002\u0002\u018e\u018c\u0003\u0002\u0002",
    "\u0002\u018e\u018f\u0003\u0002\u0002\u0002\u018f\u0190\u0003\u0002\u0002",
    "\u0002\u0190\u036b\u0007F\u0002\u0002\u0191\u0192\u0007\u001f\u0002",
    "\u0002\u0192\u0193\u0007E\u0002\u0002\u0193\u0194\u0007d\u0002\u0002",
    "\u0194\u0195\u0007_\u0002\u0002\u0195\u0196\u0007d\u0002\u0002\u0196",
    "\u036b\u0007F\u0002\u0002\u0197\u0198\u0007 \u0002\u0002\u0198\u0199",
    "\u0007E\u0002\u0002\u0199\u019a\u0007f\u0002\u0002\u019a\u019b\u0007",
    "_\u0002\u0002\u019b\u019e\u0007d\u0002\u0002\u019c\u019d\u0007_\u0002",
    "\u0002\u019d\u019f\u0007d\u0002\u0002\u019e\u019c\u0003\u0002\u0002",
    "\u0002\u019e\u019f\u0003\u0002\u0002\u0002\u019f\u01a0\u0003\u0002\u0002",
    "\u0002\u01a0\u036b\u0007F\u0002\u0002\u01a1\u01a2\u0007 \u0002\u0002",
    "\u01a2\u01a3\u0007E\u0002\u0002\u01a3\u01a4\u0007d\u0002\u0002\u01a4",
    "\u01a5\u0007_\u0002\u0002\u01a5\u01a6\u0007d\u0002\u0002\u01a6\u036b",
    "\u0007F\u0002\u0002\u01a7\u01a8\u0007!\u0002\u0002\u01a8\u01a9\u0007",
    "E\u0002\u0002\u01a9\u01aa\u0007f\u0002\u0002\u01aa\u01ab\u0007_\u0002",
    "\u0002\u01ab\u01ae\u0007d\u0002\u0002\u01ac\u01ad\u0007_\u0002\u0002",
    "\u01ad\u01af\u0007d\u0002\u0002\u01ae\u01ac\u0003\u0002\u0002\u0002",
    "\u01ae\u01af\u0003\u0002\u0002\u0002\u01af\u01b0\u0003\u0002\u0002\u0002",
    "\u01b0\u036b\u0007F\u0002\u0002\u01b1\u01b2\u0007!\u0002\u0002\u01b2",
    "\u01b3\u0007E\u0002\u0002\u01b3\u01b4\u0007d\u0002\u0002\u01b4\u01b5",
    "\u0007_\u0002\u0002\u01b5\u01b6\u0007d\u0002\u0002\u01b6\u036b\u0007",
    "F\u0002\u0002\u01b7\u01b8\u0007\"\u0002\u0002\u01b8\u01b9\u0007E\u0002",
    "\u0002\u01b9\u01bc\u0007f\u0002\u0002\u01ba\u01bb\u0007_\u0002\u0002",
    "\u01bb\u01bd\u0007d\u0002\u0002\u01bc\u01ba\u0003\u0002\u0002\u0002",
    "\u01bc\u01bd\u0003\u0002\u0002\u0002\u01bd\u01be\u0003\u0002\u0002\u0002",
    "\u01be\u036b\u0007F\u0002\u0002\u01bf\u01c0\u0007\"\u0002\u0002\u01c0",
    "\u01c1\u0007E\u0002\u0002\u01c1\u01c2\u0007d\u0002\u0002\u01c2\u036b",
    "\u0007F\u0002\u0002\u01c3\u01c4\u0007.\u0002\u0002\u01c4\u01c5\u0007",
    "E\u0002\u0002\u01c5\u01c8\u0005*\u0016\u0002\u01c6\u01c7\u0007^\u0002",
    "\u0002\u01c7\u01c9\u0005*\u0016\u0002\u01c8\u01c6\u0003\u0002\u0002",
    "\u0002\u01c8\u01c9\u0003\u0002\u0002\u0002\u01c9\u01ca\u0003\u0002\u0002",
    "\u0002\u01ca\u01cb\u0007F\u0002\u0002\u01cb\u036b\u0003\u0002\u0002",
    "\u0002\u01cc\u01cd\u0007/\u0002\u0002\u01cd\u01ce\u0007E\u0002\u0002",
    "\u01ce\u01cf\u0005*\u0016\u0002\u01cf\u01d0\u0007F\u0002\u0002\u01d0",
    "\u036b\u0003\u0002\u0002\u0002\u01d1\u01d2\u0007#\u0002\u0002\u01d2",
    "\u01d3\u0007E\u0002\u0002\u01d3\u01d6\u0005*\u0016\u0002\u01d4\u01d5",
    "\u0007^\u0002\u0002\u01d5\u01d7\u0005*\u0016\u0002\u01d6\u01d4\u0003",
    "\u0002\u0002\u0002\u01d7\u01d8\u0003\u0002\u0002\u0002\u01d8\u01d6\u0003",
    "\u0002\u0002\u0002\u01d8\u01d9\u0003\u0002\u0002\u0002\u01d9\u01da\u0003",
    "\u0002\u0002\u0002\u01da\u01db\u0007F\u0002\u0002\u01db\u036b\u0003",
    "\u0002\u0002\u0002\u01dc\u01dd\u0007$\u0002\u0002\u01dd\u01de\u0007",
    "E\u0002\u0002\u01de\u01df\u0005\u001a\u000e\u0002\u01df\u01e0\u0007",
    "^\u0002\u0002\u01e0\u01e1\u0005*\u0016\u0002\u01e1\u01e2\u0007^\u0002",
    "\u0002\u01e2\u01e3\u0005*\u0016\u0002\u01e3\u01e4\u0007F\u0002\u0002",
    "\u01e4\u036b\u0003\u0002\u0002\u0002\u01e5\u01e6\u0007\u001d\u0002\u0002",
    "\u01e6\u01e7\u0007E\u0002\u0002\u01e7\u01e8\u0005*\u0016\u0002\u01e8",
    "\u01e9\u0007F\u0002\u0002\u01e9\u036b\u0003\u0002\u0002\u0002\u01ea",
    "\u01eb\u0007\u0019\u0002\u0002\u01eb\u01ec\u0007E\u0002\u0002\u01ec",
    "\u01ed\u0005*\u0016\u0002\u01ed\u01ee\u0007F\u0002\u0002\u01ee\u036b",
    "\u0003\u0002\u0002\u0002\u01ef\u01f0\u0007\u001a\u0002\u0002\u01f0\u01f1",
    "\u0007E\u0002\u0002\u01f1\u01f2\u0005*\u0016\u0002\u01f2\u01f3\u0007",
    "^\u0002\u0002\u01f3\u01f4\u0005*\u0016\u0002\u01f4\u01f5\u0007F\u0002",
    "\u0002\u01f5\u036b\u0003\u0002\u0002\u0002\u01f6\u01f7\u0007\u001b\u0002",
    "\u0002\u01f7\u01f8\u0007E\u0002\u0002\u01f8\u01f9\u0005*\u0016\u0002",
    "\u01f9\u01fa\u0007^\u0002\u0002\u01fa\u01fb\u0005*\u0016\u0002\u01fb",
    "\u01fc\u0007F\u0002\u0002\u01fc\u036b\u0003\u0002\u0002\u0002\u01fd",
    "\u01fe\u0007\u001c\u0002\u0002\u01fe\u01ff\u0007E\u0002\u0002\u01ff",
    "\u0200\u0005*\u0016\u0002\u0200\u0201\u0007F\u0002\u0002\u0201\u036b",
    "\u0003\u0002\u0002\u0002\u0202\u0203\u0007\u0015\u0002\u0002\u0203\u0204",
    "\u0007E\u0002\u0002\u0204\u0205\u0007f\u0002\u0002\u0205\u0206\u0007",
    "^\u0002\u0002\u0206\u0207\u0007d\u0002\u0002\u0207\u0208\u0007Y\u0002",
    "\u0002\u0208\u0209\u0005\u0012\n\u0002\u0209\u020a\u0007^\u0002\u0002",
    "\u020a\u020b\u0007d\u0002\u0002\u020b\u020c\u0007Y\u0002\u0002\u020c",
    "\u020d\u0007C\u0002\u0002\u020d\u020e\u0007d\u0002\u0002\u020e\u020f",
    "\u0007_\u0002\u0002\u020f\u0216\u0007d\u0002\u0002\u0210\u0211\u0007",
    "^\u0002\u0002\u0211\u0212\u0007d\u0002\u0002\u0212\u0213\u0007_\u0002",
    "\u0002\u0213\u0215\u0007d\u0002\u0002\u0214\u0210\u0003\u0002\u0002",
    "\u0002\u0215\u0218\u0003\u0002\u0002\u0002\u0216\u0214\u0003\u0002\u0002",
    "\u0002\u0216\u0217\u0003\u0002\u0002\u0002\u0217\u0219\u0003\u0002\u0002",
    "\u0002\u0218\u0216\u0003\u0002\u0002\u0002\u0219\u021a\u0007D\u0002",
    "\u0002\u021a\u021b\u0007F\u0002\u0002\u021b\u036b\u0003\u0002\u0002",
    "\u0002\u021c\u021d\u0007\u0015\u0002\u0002\u021d\u021e\u0007E\u0002",
    "\u0002\u021e\u021f\u0007f\u0002\u0002\u021f\u0220\u0007_\u0002\u0002",
    "\u0220\u0221\u0007d\u0002\u0002\u0221\u0222\u0007^\u0002\u0002\u0222",
    "\u0223\u0007d\u0002\u0002\u0223\u0224\u0007Y\u0002\u0002\u0224\u0225",
    "\u0005\u0012\n\u0002\u0225\u0226\u0007^\u0002\u0002\u0226\u0227\u0007",
    "d\u0002\u0002\u0227\u0228\u0007Y\u0002\u0002\u0228\u0229\u0007C\u0002",
    "\u0002\u0229\u022a\u0007d\u0002\u0002\u022a\u022b\u0007_\u0002\u0002",
    "\u022b\u0232\u0007d\u0002\u0002\u022c\u022d\u0007^\u0002\u0002\u022d",
    "\u022e\u0007d\u0002\u0002\u022e\u022f\u0007_\u0002\u0002\u022f\u0231",
    "\u0007d\u0002\u0002\u0230\u022c\u0003\u0002\u0002\u0002\u0231\u0234",
    "\u0003\u0002\u0002\u0002\u0232\u0230\u0003\u0002\u0002\u0002\u0232\u0233",
    "\u0003\u0002\u0002\u0002\u0233\u0235\u0003\u0002\u0002\u0002\u0234\u0232",
    "\u0003\u0002\u0002\u0002\u0235\u0236\u0007D\u0002\u0002\u0236\u0237",
    "\u0007F\u0002\u0002\u0237\u036b\u0003\u0002\u0002\u0002\u0238\u0239",
    "\u0007\u0015\u0002\u0002\u0239\u023a\u0007E\u0002\u0002\u023a\u023b",
    "\u0007d\u0002\u0002\u023b\u023c\u0007^\u0002\u0002\u023c\u023d\u0007",
    "d\u0002\u0002\u023d\u023e\u0007Y\u0002\u0002\u023e\u023f\u0005\u0012",
    "\n\u0002\u023f\u0240\u0007^\u0002\u0002\u0240\u0241\u0007d\u0002\u0002",
    "\u0241\u0242\u0007Y\u0002\u0002\u0242\u0243\u0007C\u0002\u0002\u0243",
    "\u0244\u0007d\u0002\u0002\u0244\u0245\u0007_\u0002\u0002\u0245\u024c",
    "\u0007d\u0002\u0002\u0246\u0247\u0007^\u0002\u0002\u0247\u0248\u0007",
    "d\u0002\u0002\u0248\u0249\u0007_\u0002\u0002\u0249\u024b\u0007d\u0002",
    "\u0002\u024a\u0246\u0003\u0002\u0002\u0002\u024b\u024e\u0003\u0002\u0002",
    "\u0002\u024c\u024a\u0003\u0002\u0002\u0002\u024c\u024d\u0003\u0002\u0002",
    "\u0002\u024d\u024f\u0003\u0002\u0002\u0002\u024e\u024c\u0003\u0002\u0002",
    "\u0002\u024f\u0250\u0007D\u0002\u0002\u0250\u0251\u0007F\u0002\u0002",
    "\u0251\u036b\u0003\u0002\u0002\u0002\u0252\u0253\u0007\u0016\u0002\u0002",
    "\u0253\u0254\u0007E\u0002\u0002\u0254\u0255\u0007f\u0002\u0002\u0255",
    "\u0256\u0007^\u0002\u0002\u0256\u0257\u0007d\u0002\u0002\u0257\u0258",
    "\u0007Y\u0002\u0002\u0258\u0259\u0005\u0012\n\u0002\u0259\u025a\u0007",
    "^\u0002\u0002\u025a\u025b\u0007d\u0002\u0002\u025b\u025c\u0007Y\u0002",
    "\u0002\u025c\u025d\u0007C\u0002\u0002\u025d\u025e\u0007d\u0002\u0002",
    "\u025e\u025f\u0007_\u0002\u0002\u025f\u0266\u0007d\u0002\u0002\u0260",
    "\u0261\u0007^\u0002\u0002\u0261\u0262\u0007d\u0002\u0002\u0262\u0263",
    "\u0007_\u0002\u0002\u0263\u0265\u0007d\u0002\u0002\u0264\u0260\u0003",
    "\u0002\u0002\u0002\u0265\u0268\u0003\u0002\u0002\u0002\u0266\u0264\u0003",
    "\u0002\u0002\u0002\u0266\u0267\u0003\u0002\u0002\u0002\u0267\u0269\u0003",
    "\u0002\u0002\u0002\u0268\u0266\u0003\u0002\u0002\u0002\u0269\u026a\u0007",
    "D\u0002\u0002\u026a\u026b\u0007F\u0002\u0002\u026b\u036b\u0003\u0002",
    "\u0002\u0002\u026c\u026d\u0007\u0016\u0002\u0002\u026d\u026e\u0007E",
    "\u0002\u0002\u026e\u026f\u0007f\u0002\u0002\u026f\u0270\u0007_\u0002",
    "\u0002\u0270\u0271\u0007d\u0002\u0002\u0271\u0272\u0007^\u0002\u0002",
    "\u0272\u0273\u0007d\u0002\u0002\u0273\u0274\u0007Y\u0002\u0002\u0274",
    "\u0275\u0005\u0012\n\u0002\u0275\u0276\u0007^\u0002\u0002\u0276\u0277",
    "\u0007d\u0002\u0002\u0277\u0278\u0007Y\u0002\u0002\u0278\u0279\u0007",
    "C\u0002\u0002\u0279\u027a\u0007d\u0002\u0002\u027a\u027b\u0007_\u0002",
    "\u0002\u027b\u0282\u0007d\u0002\u0002\u027c\u027d\u0007^\u0002\u0002",
    "\u027d\u027e\u0007d\u0002\u0002\u027e\u027f\u0007_\u0002\u0002\u027f",
    "\u0281\u0007d\u0002\u0002\u0280\u027c\u0003\u0002\u0002\u0002\u0281",
    "\u0284\u0003\u0002\u0002\u0002\u0282\u0280\u0003\u0002\u0002\u0002\u0282",
    "\u0283\u0003\u0002\u0002\u0002\u0283\u0285\u0003\u0002\u0002\u0002\u0284",
    "\u0282\u0003\u0002\u0002\u0002\u0285\u0286\u0007D\u0002\u0002\u0286",
    "\u0287\u0007F\u0002\u0002\u0287\u036b\u0003\u0002\u0002\u0002\u0288",
    "\u0289\u0007\u0016\u0002\u0002\u0289\u028a\u0007E\u0002\u0002\u028a",
    "\u028b\u0007d\u0002\u0002\u028b\u028c\u0007^\u0002\u0002\u028c\u028d",
    "\u0007d\u0002\u0002\u028d\u028e\u0007Y\u0002\u0002\u028e\u028f\u0005",
    "\u0012\n\u0002\u028f\u0290\u0007^\u0002\u0002\u0290\u0291\u0007d\u0002",
    "\u0002\u0291\u0292\u0007Y\u0002\u0002\u0292\u0293\u0007C\u0002\u0002",
    "\u0293\u0294\u0007d\u0002\u0002\u0294\u0295\u0007_\u0002\u0002\u0295",
    "\u029c\u0007d\u0002\u0002\u0296\u0297\u0007^\u0002\u0002\u0297\u0298",
    "\u0007d\u0002\u0002\u0298\u0299\u0007_\u0002\u0002\u0299\u029b\u0007",
    "d\u0002\u0002\u029a\u0296\u0003\u0002\u0002\u0002\u029b\u029e\u0003",
    "\u0002\u0002\u0002\u029c\u029a\u0003\u0002\u0002\u0002\u029c\u029d\u0003",
    "\u0002\u0002\u0002\u029d\u029f\u0003\u0002\u0002\u0002\u029e\u029c\u0003",
    "\u0002\u0002\u0002\u029f\u02a0\u0007D\u0002\u0002\u02a0\u02a1\u0007",
    "F\u0002\u0002\u02a1\u036b\u0003\u0002\u0002\u0002\u02a2\u02a3\u0007",
    "\u0017\u0002\u0002\u02a3\u02a4\u0007E\u0002\u0002\u02a4\u02a5\u0007",
    "f\u0002\u0002\u02a5\u02a6\u0007_\u0002\u0002\u02a6\u02a7\u0007d\u0002",
    "\u0002\u02a7\u02a8\u0007^\u0002\u0002\u02a8\u02a9\u0007d\u0002\u0002",
    "\u02a9\u02aa\u0007Y\u0002\u0002\u02aa\u02ab\u0005\u0012\n\u0002\u02ab",
    "\u02ac\u0007F\u0002\u0002\u02ac\u036b\u0003\u0002\u0002\u0002\u02ad",
    "\u02ae\u0007\u0017\u0002\u0002\u02ae\u02af\u0007E\u0002\u0002\u02af",
    "\u02b0\u0007f\u0002\u0002\u02b0\u02b1\u0007_\u0002\u0002\u02b1\u02b2",
    "\u0007d\u0002\u0002\u02b2\u02b3\u0007_\u0002\u0002\u02b3\u02b4\u0007",
    "d\u0002\u0002\u02b4\u02b5\u0007^\u0002\u0002\u02b5\u02b6\u0007d\u0002",
    "\u0002\u02b6\u02b7\u0007Y\u0002\u0002\u02b7\u02b8\u0005\u0012\n\u0002",
    "\u02b8\u02b9\u0007F\u0002\u0002\u02b9\u036b\u0003\u0002\u0002\u0002",
    "\u02ba\u02bb\u0007\u0017\u0002\u0002\u02bb\u02bc\u0007E\u0002\u0002",
    "\u02bc\u02bd\u0007d\u0002\u0002\u02bd\u02be\u0007_\u0002\u0002\u02be",
    "\u02bf\u0007d\u0002\u0002\u02bf\u02c0\u0007^\u0002\u0002\u02c0\u02c1",
    "\u0007d\u0002\u0002\u02c1\u02c2\u0007Y\u0002\u0002\u02c2\u02c3\u0005",
    "\u0012\n\u0002\u02c3\u02c4\u0007F\u0002\u0002\u02c4\u036b\u0003\u0002",
    "\u0002\u0002\u02c5\u02c6\u0007\u0018\u0002\u0002\u02c6\u02c7\u0007E",
    "\u0002\u0002\u02c7\u02c8\u0007f\u0002\u0002\u02c8\u02c9\u0007^\u0002",
    "\u0002\u02c9\u02ca\u0007d\u0002\u0002\u02ca\u02cb\u0007Y\u0002\u0002",
    "\u02cb\u02cc\u0005\u0012\n\u0002\u02cc\u02cd\u0007F\u0002\u0002\u02cd",
    "\u036b\u0003\u0002\u0002\u0002\u02ce\u02cf\u0007\u0018\u0002\u0002\u02cf",
    "\u02d0\u0007E\u0002\u0002\u02d0\u02d1\u0007f\u0002\u0002\u02d1\u02d2",
    "\u0007_\u0002\u0002\u02d2\u02d3\u0007d\u0002\u0002\u02d3\u02d4\u0007",
    "^\u0002\u0002\u02d4\u02d5\u0007d\u0002\u0002\u02d5\u02d6\u0007Y\u0002",
    "\u0002\u02d6\u02d7\u0005\u0012\n\u0002\u02d7\u02d8\u0007F\u0002\u0002",
    "\u02d8\u036b\u0003\u0002\u0002\u0002\u02d9\u02da\u0007\u0018\u0002\u0002",
    "\u02da\u02db\u0007E\u0002\u0002\u02db\u02dc\u0007d\u0002\u0002\u02dc",
    "\u02dd\u0007^\u0002\u0002\u02dd\u02de\u0007d\u0002\u0002\u02de\u02df",
    "\u0007Y\u0002\u0002\u02df\u02e0\u0005\u0012\n\u0002\u02e0\u02e1\u0007",
    "F\u0002\u0002\u02e1\u036b\u0003\u0002\u0002\u0002\u02e2\u02e3\u0007",
    "\u0012\u0002\u0002\u02e3\u02e4\u0007E\u0002\u0002\u02e4\u02e5\u0005",
    "*\u0016\u0002\u02e5\u02e6\u0007F\u0002\u0002\u02e6\u036b\u0003\u0002",
    "\u0002\u0002\u02e7\u02e8\u0007\u0014\u0002\u0002\u02e8\u02e9\u0007E",
    "\u0002\u0002\u02e9\u02ea\u0005*\u0016\u0002\u02ea\u02eb\u0007F\u0002",
    "\u0002\u02eb\u036b\u0003\u0002\u0002\u0002\u02ec\u02ed\u0007\u0013\u0002",
    "\u0002\u02ed\u02ee\u0007E\u0002\u0002\u02ee\u02ef\u0005*\u0016\u0002",
    "\u02ef\u02f0\u0007F\u0002\u0002\u02f0\u036b\u0003\u0002\u0002\u0002",
    "\u02f1\u02f2\u00070\u0002\u0002\u02f2\u02f3\u0007E\u0002\u0002\u02f3",
    "\u02f4\u0005*\u0016\u0002\u02f4\u02f5\u0007^\u0002\u0002\u02f5\u02f6",
    "\u0005*\u0016\u0002\u02f6\u02f7\u0007^\u0002\u0002\u02f7\u02fa\u0005",
    "*\u0016\u0002\u02f8\u02f9\u0007^\u0002\u0002\u02f9\u02fb\u0005*\u0016",
    "\u0002\u02fa\u02f8\u0003\u0002\u0002\u0002\u02fa\u02fb\u0003\u0002\u0002",
    "\u0002\u02fb\u02fe\u0003\u0002\u0002\u0002\u02fc\u02fd\u0007^\u0002",
    "\u0002\u02fd\u02ff\u0005*\u0016\u0002\u02fe\u02fc\u0003\u0002\u0002",
    "\u0002\u02fe\u02ff\u0003\u0002\u0002\u0002\u02ff\u0300\u0003\u0002\u0002",
    "\u0002\u0300\u0301\u0007F\u0002\u0002\u0301\u036b\u0003\u0002\u0002",
    "\u0002\u0302\u0303\u00071\u0002\u0002\u0303\u0304\u0007E\u0002\u0002",
    "\u0304\u036b\u0007F\u0002\u0002\u0305\u0306\u00072\u0002\u0002\u0306",
    "\u0307\u0007E\u0002\u0002\u0307\u036b\u0007F\u0002\u0002\u0308\u0309",
    "\u00073\u0002\u0002\u0309\u030a\u0007E\u0002\u0002\u030a\u030b\u0005",
    "*\u0016\u0002\u030b\u030c\u0007^\u0002\u0002\u030c\u030d\u0005*\u0016",
    "\u0002\u030d\u030e\u0007^\u0002\u0002\u030e\u030f\u0005F$\u0002\u030f",
    "\u0310\u0007F\u0002\u0002\u0310\u036b\u0003\u0002\u0002\u0002\u0311",
    "\u0312\u00074\u0002\u0002\u0312\u0313\u0007E\u0002\u0002\u0313\u0314",
    "\u0005*\u0016\u0002\u0314\u0315\u0007F\u0002\u0002\u0315\u036b\u0003",
    "\u0002\u0002\u0002\u0316\u0317\u00075\u0002\u0002\u0317\u0318\u0007",
    "E\u0002\u0002\u0318\u0319\u0005*\u0016\u0002\u0319\u031a\u0007F\u0002",
    "\u0002\u031a\u036b\u0003\u0002\u0002\u0002\u031b\u031c\u00076\u0002",
    "\u0002\u031c\u031d\u0007E\u0002\u0002\u031d\u031e\u0005*\u0016\u0002",
    "\u031e\u031f\u0007F\u0002\u0002\u031f\u036b\u0003\u0002\u0002\u0002",
    "\u0320\u0321\u00077\u0002\u0002\u0321\u0322\u0007E\u0002\u0002\u0322",
    "\u0323\u0005*\u0016\u0002\u0323\u0324\u0007F\u0002\u0002\u0324\u036b",
    "\u0003\u0002\u0002\u0002\u0325\u0326\u00078\u0002\u0002\u0326\u0327",
    "\u0007E\u0002\u0002\u0327\u0328\u0005*\u0016\u0002\u0328\u0329\u0007",
    "F\u0002\u0002\u0329\u036b\u0003\u0002\u0002\u0002\u032a\u032b\u0007",
    ";\u0002\u0002\u032b\u032c\u0007E\u0002\u0002\u032c\u032d\u0005*\u0016",
    "\u0002\u032d\u032e\u0007^\u0002\u0002\u032e\u032f\u0005*\u0016\u0002",
    "\u032f\u0330\u0007F\u0002\u0002\u0330\u036b\u0003\u0002\u0002\u0002",
    "\u0331\u0332\u0007:\u0002\u0002\u0332\u0333\u0007E\u0002\u0002\u0333",
    "\u0334\u0005*\u0016\u0002\u0334\u0335\u0007^\u0002\u0002\u0335\u0336",
    "\u0005*\u0016\u0002\u0336\u0337\u0007F\u0002\u0002\u0337\u036b\u0003",
    "\u0002\u0002\u0002\u0338\u0339\u00079\u0002\u0002\u0339\u033a\u0007",
    "E\u0002\u0002\u033a\u033b\u0005*\u0016\u0002\u033b\u033c\u0007^\u0002",
    "\u0002\u033c\u033d\u0005*\u0016\u0002\u033d\u033e\u0007F\u0002\u0002",
    "\u033e\u036b\u0003\u0002\u0002\u0002\u033f\u0340\u0007<\u0002\u0002",
    "\u0340\u0341\u0007E\u0002\u0002\u0341\u0342\u0005*\u0016\u0002\u0342",
    "\u0343\u0007F\u0002\u0002\u0343\u036b\u0003\u0002\u0002\u0002\u0344",
    "\u0345\u0007=\u0002\u0002\u0345\u0346\u0007E\u0002\u0002\u0346\u0347",
    "\u0005*\u0016\u0002\u0347\u0348\u0007^\u0002\u0002\u0348\u034b\u0005",
    "*\u0016\u0002\u0349\u034a\u0007^\u0002\u0002\u034a\u034c\u0005*\u0016",
    "\u0002\u034b\u0349\u0003\u0002\u0002\u0002\u034b\u034c\u0003\u0002\u0002",
    "\u0002\u034c\u034d\u0003\u0002\u0002\u0002\u034d\u034e\u0007F\u0002",
    "\u0002\u034e\u036b\u0003\u0002\u0002\u0002\u034f\u0350\u0007>\u0002",
    "\u0002\u0350\u0351\u0007E\u0002\u0002\u0351\u0352\u0005*\u0016\u0002",
    "\u0352\u0353\u0007^\u0002\u0002\u0353\u0354\u0005*\u0016\u0002\u0354",
    "\u0355\u0007^\u0002\u0002\u0355\u0356\u0005*\u0016\u0002\u0356\u0357",
    "\u0007F\u0002\u0002\u0357\u036b\u0003\u0002\u0002\u0002\u0358\u0359",
    "\u0007?\u0002\u0002\u0359\u035a\u0007E\u0002\u0002\u035a\u035d\u0005",
    "*\u0016\u0002\u035b\u035c\u0007^\u0002\u0002\u035c\u035e\u0005*\u0016",
    "\u0002\u035d\u035b\u0003\u0002\u0002\u0002\u035e\u035f\u0003\u0002\u0002",
    "\u0002\u035f\u035d\u0003\u0002\u0002\u0002\u035f\u0360\u0003\u0002\u0002",
    "\u0002\u0360\u0361\u0003\u0002\u0002\u0002\u0361\u0362\u0007F\u0002",
    "\u0002\u0362\u036b\u0003\u0002\u0002\u0002\u0363\u0364\u0007@\u0002",
    "\u0002\u0364\u0365\u0007E\u0002\u0002\u0365\u0366\u0005*\u0016\u0002",
    "\u0366\u0367\u0007^\u0002\u0002\u0367\u0368\u0005*\u0016\u0002\u0368",
    "\u0369\u0007F\u0002\u0002\u0369\u036b\u0003\u0002\u0002\u0002\u036a",
    "\u0106\u0003\u0002\u0002\u0002\u036a\u010d\u0003\u0002\u0002\u0002\u036a",
    "\u0116\u0003\u0002\u0002\u0002\u036a\u011d\u0003\u0002\u0002\u0002\u036a",
    "\u0126\u0003\u0002\u0002\u0002\u036a\u012d\u0003\u0002\u0002\u0002\u036a",
    "\u0138\u0003\u0002\u0002\u0002\u036a\u0145\u0003\u0002\u0002\u0002\u036a",
    "\u0150\u0003\u0002\u0002\u0002\u036a\u015d\u0003\u0002\u0002\u0002\u036a",
    "\u0166\u0003\u0002\u0002\u0002\u036a\u0177\u0003\u0002\u0002\u0002\u036a",
    "\u0181\u0003\u0002\u0002\u0002\u036a\u0187\u0003\u0002\u0002\u0002\u036a",
    "\u0191\u0003\u0002\u0002\u0002\u036a\u0197\u0003\u0002\u0002\u0002\u036a",
    "\u01a1\u0003\u0002\u0002\u0002\u036a\u01a7\u0003\u0002\u0002\u0002\u036a",
    "\u01b1\u0003\u0002\u0002\u0002\u036a\u01b7\u0003\u0002\u0002\u0002\u036a",
    "\u01bf\u0003\u0002\u0002\u0002\u036a\u01c3\u0003\u0002\u0002\u0002\u036a",
    "\u01cc\u0003\u0002\u0002\u0002\u036a\u01d1\u0003\u0002\u0002\u0002\u036a",
    "\u01dc\u0003\u0002\u0002\u0002\u036a\u01e5\u0003\u0002\u0002\u0002\u036a",
    "\u01ea\u0003\u0002\u0002\u0002\u036a\u01ef\u0003\u0002\u0002\u0002\u036a",
    "\u01f6\u0003\u0002\u0002\u0002\u036a\u01fd\u0003\u0002\u0002\u0002\u036a",
    "\u0202\u0003\u0002\u0002\u0002\u036a\u021c\u0003\u0002\u0002\u0002\u036a",
    "\u0238\u0003\u0002\u0002\u0002\u036a\u0252\u0003\u0002\u0002\u0002\u036a",
    "\u026c\u0003\u0002\u0002\u0002\u036a\u0288\u0003\u0002\u0002\u0002\u036a",
    "\u02a2\u0003\u0002\u0002\u0002\u036a\u02ad\u0003\u0002\u0002\u0002\u036a",
    "\u02ba\u0003\u0002\u0002\u0002\u036a\u02c5\u0003\u0002\u0002\u0002\u036a",
    "\u02ce\u0003\u0002\u0002\u0002\u036a\u02d9\u0003\u0002\u0002\u0002\u036a",
    "\u02e2\u0003\u0002\u0002\u0002\u036a\u02e7\u0003\u0002\u0002\u0002\u036a",
    "\u02ec\u0003\u0002\u0002\u0002\u036a\u02f1\u0003\u0002\u0002\u0002\u036a",
    "\u0302\u0003\u0002\u0002\u0002\u036a\u0305\u0003\u0002\u0002\u0002\u036a",
    "\u0308\u0003\u0002\u0002\u0002\u036a\u0311\u0003\u0002\u0002\u0002\u036a",
    "\u0316\u0003\u0002\u0002\u0002\u036a\u031b\u0003\u0002\u0002\u0002\u036a",
    "\u0320\u0003\u0002\u0002\u0002\u036a\u0325\u0003\u0002\u0002\u0002\u036a",
    "\u032a\u0003\u0002\u0002\u0002\u036a\u0331\u0003\u0002\u0002\u0002\u036a",
    "\u0338\u0003\u0002\u0002\u0002\u036a\u033f\u0003\u0002\u0002\u0002\u036a",
    "\u0344\u0003\u0002\u0002\u0002\u036a\u034f\u0003\u0002\u0002\u0002\u036a",
    "\u0358\u0003\u0002\u0002\u0002\u036a\u0363\u0003\u0002\u0002\u0002\u036b",
    "%\u0003\u0002\u0002\u0002\u036c\u036d\t\u0004\u0002\u0002\u036d\'\u0003",
    "\u0002\u0002\u0002\u036e\u036f\t\u0005\u0002\u0002\u036f)\u0003\u0002",
    "\u0002\u0002\u0370\u0371\b\u0016\u0001\u0002\u0371\u0372\u0007E\u0002",
    "\u0002\u0372\u0373\u0005*\u0016\u0002\u0373\u0374\u0007F\u0002\u0002",
    "\u0374\u037a\u0003\u0002\u0002\u0002\u0375\u037a\u0005$\u0013\u0002",
    "\u0376\u037a\u0005,\u0017\u0002\u0377\u037a\u0005.\u0018\u0002\u0378",
    "\u037a\u00050\u0019\u0002\u0379\u0370\u0003\u0002\u0002\u0002\u0379",
    "\u0375\u0003\u0002\u0002\u0002\u0379\u0376\u0003\u0002\u0002\u0002\u0379",
    "\u0377\u0003\u0002\u0002\u0002\u0379\u0378\u0003\u0002\u0002\u0002\u037a",
    "\u0385\u0003\u0002\u0002\u0002\u037b\u037c\f\t\u0002\u0002\u037c\u037d",
    "\u0005&\u0014\u0002\u037d\u037e\u0005*\u0016\n\u037e\u0384\u0003\u0002",
    "\u0002\u0002\u037f\u0380\f\b\u0002\u0002\u0380\u0381\u0005(\u0015\u0002",
    "\u0381\u0382\u0005*\u0016\t\u0382\u0384\u0003\u0002\u0002\u0002\u0383",
    "\u037b\u0003\u0002\u0002\u0002\u0383\u037f\u0003\u0002\u0002\u0002\u0384",
    "\u0387\u0003\u0002\u0002\u0002\u0385\u0383\u0003\u0002\u0002\u0002\u0385",
    "\u0386\u0003\u0002\u0002\u0002\u0386+\u0003\u0002\u0002\u0002\u0387",
    "\u0385\u0003\u0002\u0002\u0002\u0388\u0389\u0007d\u0002\u0002\u0389",
    "\u038a\u0007I\u0002\u0002\u038a\u038f\u0007I\u0002\u0002\u038b\u038c",
    "\u0007I\u0002\u0002\u038c\u038d\u0007I\u0002\u0002\u038d\u038f\u0007",
    "d\u0002\u0002\u038e\u0388\u0003\u0002\u0002\u0002\u038e\u038b\u0003",
    "\u0002\u0002\u0002\u038f-\u0003\u0002\u0002\u0002\u0390\u0391\u0007",
    "d\u0002\u0002\u0391\u0392\u0007J\u0002\u0002\u0392\u0397\u0007J\u0002",
    "\u0002\u0393\u0394\u0007J\u0002\u0002\u0394\u0395\u0007J\u0002\u0002",
    "\u0395\u0397\u0007d\u0002\u0002\u0396\u0390\u0003\u0002\u0002\u0002",
    "\u0396\u0393\u0003\u0002\u0002\u0002\u0397/\u0003\u0002\u0002\u0002",
    "\u0398\u03aa\t\u0006\u0002\u0002\u0399\u03aa\u0007[\u0002\u0002\u039a",
    "\u03aa\u0007\\\u0002\u0002\u039b\u03aa\u0005D#\u0002\u039c\u03aa\u0005",
    "B\"\u0002\u039d\u03aa\u0005@!\u0002\u039e\u03aa\u0007c\u0002\u0002\u039f",
    "\u03aa\u0007d\u0002\u0002\u03a0\u03aa\u0005:\u001e\u0002\u03a1\u03aa",
    "\u0005<\u001f\u0002\u03a2\u03aa\u0005> \u0002\u03a3\u03aa\u0007f\u0002",
    "\u0002\u03a4\u03aa\u00052\u001a\u0002\u03a5\u03aa\u00058\u001d\u0002",
    "\u03a6\u03aa\u00056\u001c\u0002\u03a7\u03aa\u00054\u001b\u0002\u03a8",
    "\u03aa\u0007\u0011\u0002\u0002\u03a9\u0398\u0003\u0002\u0002\u0002\u03a9",
    "\u0399\u0003\u0002\u0002\u0002\u03a9\u039a\u0003\u0002\u0002\u0002\u03a9",
    "\u039b\u0003\u0002\u0002\u0002\u03a9\u039c\u0003\u0002\u0002\u0002\u03a9",
    "\u039d\u0003\u0002\u0002\u0002\u03a9\u039e\u0003\u0002\u0002\u0002\u03a9",
    "\u039f\u0003\u0002\u0002\u0002\u03a9\u03a0\u0003\u0002\u0002\u0002\u03a9",
    "\u03a1\u0003\u0002\u0002\u0002\u03a9\u03a2\u0003\u0002\u0002\u0002\u03a9",
    "\u03a3\u0003\u0002\u0002\u0002\u03a9\u03a4\u0003\u0002\u0002\u0002\u03a9",
    "\u03a5\u0003\u0002\u0002\u0002\u03a9\u03a6\u0003\u0002\u0002\u0002\u03a9",
    "\u03a7\u0003\u0002\u0002\u0002\u03a9\u03a8\u0003\u0002\u0002\u0002\u03aa",
    "1\u0003\u0002\u0002\u0002\u03ab\u03ac\u0007f\u0002\u0002\u03ac\u03ad",
    "\u0007_\u0002\u0002\u03ad\u03ae\u0007d\u0002\u0002\u03ae3\u0003\u0002",
    "\u0002\u0002\u03af\u03b0\u0007d\u0002\u0002\u03b0\u03b1\u0007_\u0002",
    "\u0002\u03b1\u03b2\u0007d\u0002\u0002\u03b25\u0003\u0002\u0002\u0002",
    "\u03b3\u03b4\u0007f\u0002\u0002\u03b4\u03b5\u0007A\u0002\u0002\u03b5",
    "\u03b6\u0005*\u0016\u0002\u03b6\u03b7\u0007B\u0002\u0002\u03b7\u03b8",
    "\u0007_\u0002\u0002\u03b8\u03b9\u0007d\u0002\u0002\u03b97\u0003\u0002",
    "\u0002\u0002\u03ba\u03bb\u0007f\u0002\u0002\u03bb\u03bc\u0007_\u0002",
    "\u0002\u03bc\u03bd\u0007d\u0002\u0002\u03bd\u03be\u0007A\u0002\u0002",
    "\u03be\u03bf\u0005*\u0016\u0002\u03bf\u03c0\u0007B\u0002\u0002\u03c0",
    "\u03c1\u0007_\u0002\u0002\u03c1\u03c2\u0007d\u0002\u0002\u03c29\u0003",
    "\u0002\u0002\u0002\u03c3\u03c4\u0007d\u0002\u0002\u03c4\u03c5\u0007",
    "A\u0002\u0002\u03c5\u03c6\u0005@!\u0002\u03c6\u03c7\u0007B\u0002\u0002",
    "\u03c7;\u0003\u0002\u0002\u0002\u03c8\u03c9\u0007d\u0002\u0002\u03c9",
    "\u03ca\u0007A\u0002\u0002\u03ca\u03cb\u0005*\u0016\u0002\u03cb\u03ce",
    "\u0007B\u0002\u0002\u03cc\u03cd\u0007_\u0002\u0002\u03cd\u03cf\u0007",
    "d\u0002\u0002\u03ce\u03cc\u0003\u0002\u0002\u0002\u03ce\u03cf\u0003",
    "\u0002\u0002\u0002\u03cf=\u0003\u0002\u0002\u0002\u03d0\u03d1\u0007",
    "d\u0002\u0002\u03d1\u03d2\u0007A\u0002\u0002\u03d2\u03d3\u0005*\u0016",
    "\u0002\u03d3\u03d4\u0007B\u0002\u0002\u03d4\u03d5\u0007A\u0002\u0002",
    "\u03d5\u03d6\u0005*\u0016\u0002\u03d6\u03d7\u0007B\u0002\u0002\u03d7",
    "?\u0003\u0002\u0002\u0002\u03d8\u03d9\u0007e\u0002\u0002\u03d9A\u0003",
    "\u0002\u0002\u0002\u03da\u03db\u0007a\u0002\u0002\u03dbC\u0003\u0002",
    "\u0002\u0002\u03dc\u03dd\u0007b\u0002\u0002\u03ddE\u0003\u0002\u0002",
    "\u0002\u03de\u03df\t\u0007\u0002\u0002\u03dfG\u0003\u0002\u0002\u0002",
    "5KYg\u0087\u008b\u0096\u009c\u00a1\u00b1\u00b9\u00bb\u00c4\u00c7\u00d2",
    "\u00d7\u00df\u00e4\u00f0\u00fe\u0134\u0141\u014c\u0159\u016b\u016f\u0173",
    "\u017e\u018e\u019e\u01ae\u01bc\u01c8\u01d8\u0216\u0232\u024c\u0266\u0282",
    "\u029c\u02fa\u02fe\u034b\u035f\u036a\u0379\u0383\u0385\u038e\u0396\u03a9",
    "\u03ce"].join("");


var atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

var decisionsToDFA = atn.decisionToState.map( function(ds, index) { return new antlr4.dfa.DFA(ds, index); });

var sharedContextCache = new antlr4.PredictionContextCache();

var literalNames = [ null, null, null, "'se'", "'senao'", "'parametro'", 
                     "'caso'", "'padrao'", "'enquanto'", "'parar'", "'&&'", 
                     "'||'", "'!'", "'verdadeiro'", "'falso'", "'nulo'", 
                     "'_LISTA'", "'_NULO'", "'_NUMERO'", "'_FILTRAR'", "'_PRIMEIRO'", 
                     "'_SOMASE'", "'_CONTSE'", "'_ABS'", "'_MOD'", "'_POTENCIA'", 
                     "'_FATORIAL'", "'_RAIZ'", "'_SOMA'", "'_MAXIMO'", "'_MINIMO'", 
                     "'_MEDIA'", "'_CONT'", "'_COALESCE'", "'_TERNARIO'", 
                     "'_RETORNOVALOR'", "'_CARACTERISTICATABELA'", "'_ATIVIDADETABELA'", 
                     "'_CARACTERISTICA'", "'_CARACTERISTICA_CODIGO'", "'_PARAMETRO'", 
                     "'_PARAMETRO_CODIGO'", "'_ISENCAO'", "'_MOEDA'", "'_ARREDONDAR'", 
                     "'_TRUNCAR'", "'_DATA'", "'_HOJE'", "'_AGORA'", "'_DATADIF'", 
                     "'_ANO'", "'_MES'", "'_DIA'", "'_HORA'", "'_MINUTO'", 
                     "'_DIA_ADICIONAR'", "'_MES_ADICIONAR'", "'_ANO_ADICIONAR'", 
                     "'_ARRUMAR'", "'_SUBTEXTO'", "'_SUBSTITUIR'", "'_CONCATENAR'", 
                     "'_PROCURAR'", "'['", "']'", "'{'", "'}'", "'('", "')'", 
                     "'*'", "'/'", "'+'", "'-'", "'>'", "'>='", "'<'", "'<='", 
                     "'=='", "'!='", "'ANO'", "'MES'", "'DIA'", "'='", "'+='", 
                     "'-='", "'*='", "'/='", "'=>'", "'var'", "'@Exercicio'", 
                     "'@DataCalculo'", "'retorno'", "','", "'.'", "'\"'", 
                     null, null, null, null, null, null, "';'", "':'" ];

var symbolicNames = [ null, "COMMENT", "WS", "IF", "ELSE", "SWITCH", "CASE", 
                      "DEFAULT", "WHILE", "BREAK", "AND", "OR", "NOT", "TRUE", 
                      "FALSE", "NULL", "ISARRAY", "ISNULL", "ISNUMBER", 
                      "FILTER", "FIRST", "SUM_IF", "COUNT_IF", "ABS", "MOD", 
                      "POW", "FACTORIAL", "SQRT", "SUM", "MAX", "MIN", "AVERAGE", 
                      "LENGTH", "COALESCE", "TERNARY", "RETORNO_VALOR", 
                      "CARACTERISTICA_TABELA", "ATIVIDADE_TABELA", "CARACTERISTICA", 
                      "CARACTERISTICA_CODIGO", "PARAMETRO", "PARAMETRO_CODIGO", 
                      "ISENCAO", "MOEDA", "ROUND", "TRUNCATE", "DATE_FUNCTION", 
                      "TODAY", "NOW", "DATE_DIF", "GET_YEAR", "GET_MONTH", 
                      "GET_DAY", "GET_HOUR", "GET_MINUTE", "ADD_DAY", "ADD_MONTH", 
                      "ADD_YEAR", "TRIM", "SUBSTRING", "SUBSTITUTE", "CONCATENATE", 
                      "SEARCH", "LBRACKET", "RBRACKET", "LBRACE", "RBRACE", 
                      "LPAREN", "RPAREN", "MULT", "DIV", "PLUS", "MINUS", 
                      "GT", "GE", "LT", "LE", "EQ", "NEQ", "YEAR", "MONTH", 
                      "DAY", "ATRIB", "PLUS_ASSIGNMENT", "MINUS_ASSIGNMENT", 
                      "MULT_ASSIGNMENT", "DIV_ASSIGNMENT", "LAMBDA_SIGN", 
                      "VAR", "EXERCICIO", "DATA_CALCULO", "RETURN", "COMMA", 
                      "DOT", "QUOTE", "NUMBER", "DECIMAL", "DATE", "IDENTIFIER", 
                      "TEXT", "VAR_PRIMARY", "SEMI", "COLON", "ERRORCHAR" ];

var ruleNames =  [ "rule_set", "rule_block", "variable_declaration", "assignment_expression", 
                   "assignment", "return_value", "conditional", "statement_block", 
                   "if_expression", "switch_expression", "case_statement", 
                   "default_statement", "comparison_expression", "comparison_operator", 
                   "assignment_operator", "loop", "break_statement", "function_signature", 
                   "high_precedence_operator", "low_precedence_operator", 
                   "arithmetic_expression", "increment", "decrement", "entity", 
                   "varMemory", "object_value", "listMemoryGlobal", "listMemory", 
                   "object_dictionary", "list", "list_dictionary", "text", 
                   "number_integer", "number_decimal", "date_unit" ];

function LanguageParser (input) {
	antlr4.Parser.call(this, input);
    this._interp = new antlr4.atn.ParserATNSimulator(this, atn, decisionsToDFA, sharedContextCache);
    this.ruleNames = ruleNames;
    this.literalNames = literalNames;
    this.symbolicNames = symbolicNames;
    return this;
}

LanguageParser.prototype = Object.create(antlr4.Parser.prototype);
LanguageParser.prototype.constructor = LanguageParser;

Object.defineProperty(LanguageParser.prototype, "atn", {
	get : function() {
		return atn;
	}
});

LanguageParser.EOF = antlr4.Token.EOF;
LanguageParser.COMMENT = 1;
LanguageParser.WS = 2;
LanguageParser.IF = 3;
LanguageParser.ELSE = 4;
LanguageParser.SWITCH = 5;
LanguageParser.CASE = 6;
LanguageParser.DEFAULT = 7;
LanguageParser.WHILE = 8;
LanguageParser.BREAK = 9;
LanguageParser.AND = 10;
LanguageParser.OR = 11;
LanguageParser.NOT = 12;
LanguageParser.TRUE = 13;
LanguageParser.FALSE = 14;
LanguageParser.NULL = 15;
LanguageParser.ISARRAY = 16;
LanguageParser.ISNULL = 17;
LanguageParser.ISNUMBER = 18;
LanguageParser.FILTER = 19;
LanguageParser.FIRST = 20;
LanguageParser.SUM_IF = 21;
LanguageParser.COUNT_IF = 22;
LanguageParser.ABS = 23;
LanguageParser.MOD = 24;
LanguageParser.POW = 25;
LanguageParser.FACTORIAL = 26;
LanguageParser.SQRT = 27;
LanguageParser.SUM = 28;
LanguageParser.MAX = 29;
LanguageParser.MIN = 30;
LanguageParser.AVERAGE = 31;
LanguageParser.LENGTH = 32;
LanguageParser.COALESCE = 33;
LanguageParser.TERNARY = 34;
LanguageParser.RETORNO_VALOR = 35;
LanguageParser.CARACTERISTICA_TABELA = 36;
LanguageParser.ATIVIDADE_TABELA = 37;
LanguageParser.CARACTERISTICA = 38;
LanguageParser.CARACTERISTICA_CODIGO = 39;
LanguageParser.PARAMETRO = 40;
LanguageParser.PARAMETRO_CODIGO = 41;
LanguageParser.ISENCAO = 42;
LanguageParser.MOEDA = 43;
LanguageParser.ROUND = 44;
LanguageParser.TRUNCATE = 45;
LanguageParser.DATE_FUNCTION = 46;
LanguageParser.TODAY = 47;
LanguageParser.NOW = 48;
LanguageParser.DATE_DIF = 49;
LanguageParser.GET_YEAR = 50;
LanguageParser.GET_MONTH = 51;
LanguageParser.GET_DAY = 52;
LanguageParser.GET_HOUR = 53;
LanguageParser.GET_MINUTE = 54;
LanguageParser.ADD_DAY = 55;
LanguageParser.ADD_MONTH = 56;
LanguageParser.ADD_YEAR = 57;
LanguageParser.TRIM = 58;
LanguageParser.SUBSTRING = 59;
LanguageParser.SUBSTITUTE = 60;
LanguageParser.CONCATENATE = 61;
LanguageParser.SEARCH = 62;
LanguageParser.LBRACKET = 63;
LanguageParser.RBRACKET = 64;
LanguageParser.LBRACE = 65;
LanguageParser.RBRACE = 66;
LanguageParser.LPAREN = 67;
LanguageParser.RPAREN = 68;
LanguageParser.MULT = 69;
LanguageParser.DIV = 70;
LanguageParser.PLUS = 71;
LanguageParser.MINUS = 72;
LanguageParser.GT = 73;
LanguageParser.GE = 74;
LanguageParser.LT = 75;
LanguageParser.LE = 76;
LanguageParser.EQ = 77;
LanguageParser.NEQ = 78;
LanguageParser.YEAR = 79;
LanguageParser.MONTH = 80;
LanguageParser.DAY = 81;
LanguageParser.ATRIB = 82;
LanguageParser.PLUS_ASSIGNMENT = 83;
LanguageParser.MINUS_ASSIGNMENT = 84;
LanguageParser.MULT_ASSIGNMENT = 85;
LanguageParser.DIV_ASSIGNMENT = 86;
LanguageParser.LAMBDA_SIGN = 87;
LanguageParser.VAR = 88;
LanguageParser.EXERCICIO = 89;
LanguageParser.DATA_CALCULO = 90;
LanguageParser.RETURN = 91;
LanguageParser.COMMA = 92;
LanguageParser.DOT = 93;
LanguageParser.QUOTE = 94;
LanguageParser.NUMBER = 95;
LanguageParser.DECIMAL = 96;
LanguageParser.DATE = 97;
LanguageParser.IDENTIFIER = 98;
LanguageParser.TEXT = 99;
LanguageParser.VAR_PRIMARY = 100;
LanguageParser.SEMI = 101;
LanguageParser.COLON = 102;
LanguageParser.ERRORCHAR = 103;

LanguageParser.RULE_rule_set = 0;
LanguageParser.RULE_rule_block = 1;
LanguageParser.RULE_variable_declaration = 2;
LanguageParser.RULE_assignment_expression = 3;
LanguageParser.RULE_assignment = 4;
LanguageParser.RULE_return_value = 5;
LanguageParser.RULE_conditional = 6;
LanguageParser.RULE_statement_block = 7;
LanguageParser.RULE_if_expression = 8;
LanguageParser.RULE_switch_expression = 9;
LanguageParser.RULE_case_statement = 10;
LanguageParser.RULE_default_statement = 11;
LanguageParser.RULE_comparison_expression = 12;
LanguageParser.RULE_comparison_operator = 13;
LanguageParser.RULE_assignment_operator = 14;
LanguageParser.RULE_loop = 15;
LanguageParser.RULE_break_statement = 16;
LanguageParser.RULE_function_signature = 17;
LanguageParser.RULE_high_precedence_operator = 18;
LanguageParser.RULE_low_precedence_operator = 19;
LanguageParser.RULE_arithmetic_expression = 20;
LanguageParser.RULE_increment = 21;
LanguageParser.RULE_decrement = 22;
LanguageParser.RULE_entity = 23;
LanguageParser.RULE_varMemory = 24;
LanguageParser.RULE_object_value = 25;
LanguageParser.RULE_listMemoryGlobal = 26;
LanguageParser.RULE_listMemory = 27;
LanguageParser.RULE_object_dictionary = 28;
LanguageParser.RULE_list = 29;
LanguageParser.RULE_list_dictionary = 30;
LanguageParser.RULE_text = 31;
LanguageParser.RULE_number_integer = 32;
LanguageParser.RULE_number_decimal = 33;
LanguageParser.RULE_date_unit = 34;


function Rule_setContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_rule_set;
    return this;
}

Rule_setContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Rule_setContext.prototype.constructor = Rule_setContext;

Rule_setContext.prototype.return_value = function() {
    return this.getTypedRuleContext(Return_valueContext,0);
};

Rule_setContext.prototype.rule_block = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Rule_blockContext);
    } else {
        return this.getTypedRuleContext(Rule_blockContext,i);
    }
};




LanguageParser.Rule_setContext = Rule_setContext;

LanguageParser.prototype.rule_set = function() {

    var localctx = new Rule_setContext(this, this._ctx, this.state);
    this.enterRule(localctx, 0, LanguageParser.RULE_rule_set);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 73;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LanguageParser.IF) | (1 << LanguageParser.SWITCH) | (1 << LanguageParser.WHILE) | (1 << LanguageParser.BREAK) | (1 << LanguageParser.TRUE) | (1 << LanguageParser.FALSE) | (1 << LanguageParser.NULL) | (1 << LanguageParser.ISARRAY) | (1 << LanguageParser.ISNULL) | (1 << LanguageParser.ISNUMBER) | (1 << LanguageParser.FILTER) | (1 << LanguageParser.FIRST) | (1 << LanguageParser.SUM_IF) | (1 << LanguageParser.COUNT_IF) | (1 << LanguageParser.ABS) | (1 << LanguageParser.MOD) | (1 << LanguageParser.POW) | (1 << LanguageParser.FACTORIAL) | (1 << LanguageParser.SQRT) | (1 << LanguageParser.SUM) | (1 << LanguageParser.MAX) | (1 << LanguageParser.MIN) | (1 << LanguageParser.AVERAGE))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (LanguageParser.LENGTH - 32)) | (1 << (LanguageParser.COALESCE - 32)) | (1 << (LanguageParser.TERNARY - 32)) | (1 << (LanguageParser.RETORNO_VALOR - 32)) | (1 << (LanguageParser.CARACTERISTICA_TABELA - 32)) | (1 << (LanguageParser.ATIVIDADE_TABELA - 32)) | (1 << (LanguageParser.CARACTERISTICA - 32)) | (1 << (LanguageParser.CARACTERISTICA_CODIGO - 32)) | (1 << (LanguageParser.PARAMETRO - 32)) | (1 << (LanguageParser.PARAMETRO_CODIGO - 32)) | (1 << (LanguageParser.ISENCAO - 32)) | (1 << (LanguageParser.MOEDA - 32)) | (1 << (LanguageParser.ROUND - 32)) | (1 << (LanguageParser.TRUNCATE - 32)) | (1 << (LanguageParser.DATE_FUNCTION - 32)) | (1 << (LanguageParser.TODAY - 32)) | (1 << (LanguageParser.NOW - 32)) | (1 << (LanguageParser.DATE_DIF - 32)) | (1 << (LanguageParser.GET_YEAR - 32)) | (1 << (LanguageParser.GET_MONTH - 32)) | (1 << (LanguageParser.GET_DAY - 32)) | (1 << (LanguageParser.GET_HOUR - 32)) | (1 << (LanguageParser.GET_MINUTE - 32)) | (1 << (LanguageParser.ADD_DAY - 32)) | (1 << (LanguageParser.ADD_MONTH - 32)) | (1 << (LanguageParser.ADD_YEAR - 32)) | (1 << (LanguageParser.TRIM - 32)) | (1 << (LanguageParser.SUBSTRING - 32)) | (1 << (LanguageParser.SUBSTITUTE - 32)) | (1 << (LanguageParser.CONCATENATE - 32)) | (1 << (LanguageParser.SEARCH - 32)))) !== 0) || ((((_la - 67)) & ~0x1f) == 0 && ((1 << (_la - 67)) & ((1 << (LanguageParser.LPAREN - 67)) | (1 << (LanguageParser.PLUS - 67)) | (1 << (LanguageParser.MINUS - 67)) | (1 << (LanguageParser.VAR - 67)) | (1 << (LanguageParser.EXERCICIO - 67)) | (1 << (LanguageParser.DATA_CALCULO - 67)) | (1 << (LanguageParser.NUMBER - 67)) | (1 << (LanguageParser.DECIMAL - 67)) | (1 << (LanguageParser.DATE - 67)) | (1 << (LanguageParser.IDENTIFIER - 67)))) !== 0) || _la===LanguageParser.TEXT || _la===LanguageParser.VAR_PRIMARY) {
            this.state = 70;
            this.rule_block();
            this.state = 75;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
        this.state = 76;
        this.return_value();
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Rule_blockContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_rule_block;
    return this;
}

Rule_blockContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Rule_blockContext.prototype.constructor = Rule_blockContext;

Rule_blockContext.prototype.variable_declaration = function() {
    return this.getTypedRuleContext(Variable_declarationContext,0);
};

Rule_blockContext.prototype.switch_expression = function() {
    return this.getTypedRuleContext(Switch_expressionContext,0);
};

Rule_blockContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

Rule_blockContext.prototype.SEMI = function() {
    return this.getToken(LanguageParser.SEMI, 0);
};

Rule_blockContext.prototype.conditional = function() {
    return this.getTypedRuleContext(ConditionalContext,0);
};

Rule_blockContext.prototype.loop = function() {
    return this.getTypedRuleContext(LoopContext,0);
};

Rule_blockContext.prototype.break_statement = function() {
    return this.getTypedRuleContext(Break_statementContext,0);
};

Rule_blockContext.prototype.assignment = function() {
    return this.getTypedRuleContext(AssignmentContext,0);
};




LanguageParser.Rule_blockContext = Rule_blockContext;

LanguageParser.prototype.rule_block = function() {

    var localctx = new Rule_blockContext(this, this._ctx, this.state);
    this.enterRule(localctx, 2, LanguageParser.RULE_rule_block);
    try {
        this.state = 87;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,1,this._ctx);
        switch(la_) {
        case 1:
            this.enterOuterAlt(localctx, 1);
            this.state = 78;
            this.variable_declaration();
            break;

        case 2:
            this.enterOuterAlt(localctx, 2);
            this.state = 79;
            this.switch_expression();
            break;

        case 3:
            this.enterOuterAlt(localctx, 3);
            this.state = 80;
            this.arithmetic_expression(0);
            this.state = 81;
            this.match(LanguageParser.SEMI);
            break;

        case 4:
            this.enterOuterAlt(localctx, 4);
            this.state = 83;
            this.conditional();
            break;

        case 5:
            this.enterOuterAlt(localctx, 5);
            this.state = 84;
            this.loop();
            break;

        case 6:
            this.enterOuterAlt(localctx, 6);
            this.state = 85;
            this.break_statement();
            break;

        case 7:
            this.enterOuterAlt(localctx, 7);
            this.state = 86;
            this.assignment();
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Variable_declarationContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_variable_declaration;
    return this;
}

Variable_declarationContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Variable_declarationContext.prototype.constructor = Variable_declarationContext;


 
Variable_declarationContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function VariableDeclarationContext(parser, ctx) {
	Variable_declarationContext.call(this, parser);
    Variable_declarationContext.prototype.copyFrom.call(this, ctx);
    return this;
}

VariableDeclarationContext.prototype = Object.create(Variable_declarationContext.prototype);
VariableDeclarationContext.prototype.constructor = VariableDeclarationContext;

LanguageParser.VariableDeclarationContext = VariableDeclarationContext;

VariableDeclarationContext.prototype.VAR = function() {
    return this.getToken(LanguageParser.VAR, 0);
};

VariableDeclarationContext.prototype.IDENTIFIER = function() {
    return this.getToken(LanguageParser.IDENTIFIER, 0);
};

VariableDeclarationContext.prototype.ATRIB = function() {
    return this.getToken(LanguageParser.ATRIB, 0);
};

VariableDeclarationContext.prototype.assignment_expression = function() {
    return this.getTypedRuleContext(Assignment_expressionContext,0);
};

VariableDeclarationContext.prototype.SEMI = function() {
    return this.getToken(LanguageParser.SEMI, 0);
};


LanguageParser.Variable_declarationContext = Variable_declarationContext;

LanguageParser.prototype.variable_declaration = function() {

    var localctx = new Variable_declarationContext(this, this._ctx, this.state);
    this.enterRule(localctx, 4, LanguageParser.RULE_variable_declaration);
    try {
        localctx = new VariableDeclarationContext(this, localctx);
        this.enterOuterAlt(localctx, 1);
        this.state = 89;
        this.match(LanguageParser.VAR);
        this.state = 90;
        this.match(LanguageParser.IDENTIFIER);
        this.state = 91;
        this.match(LanguageParser.ATRIB);
        this.state = 92;
        this.assignment_expression();
        this.state = 93;
        this.match(LanguageParser.SEMI);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Assignment_expressionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_assignment_expression;
    return this;
}

Assignment_expressionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Assignment_expressionContext.prototype.constructor = Assignment_expressionContext;


 
Assignment_expressionContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function ComparisonAssignmentExpressionContext(parser, ctx) {
	Assignment_expressionContext.call(this, parser);
    Assignment_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ComparisonAssignmentExpressionContext.prototype = Object.create(Assignment_expressionContext.prototype);
ComparisonAssignmentExpressionContext.prototype.constructor = ComparisonAssignmentExpressionContext;

LanguageParser.ComparisonAssignmentExpressionContext = ComparisonAssignmentExpressionContext;

ComparisonAssignmentExpressionContext.prototype.comparison_expression = function() {
    return this.getTypedRuleContext(Comparison_expressionContext,0);
};

function ArithmeticAssignmentExpressionContext(parser, ctx) {
	Assignment_expressionContext.call(this, parser);
    Assignment_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ArithmeticAssignmentExpressionContext.prototype = Object.create(Assignment_expressionContext.prototype);
ArithmeticAssignmentExpressionContext.prototype.constructor = ArithmeticAssignmentExpressionContext;

LanguageParser.ArithmeticAssignmentExpressionContext = ArithmeticAssignmentExpressionContext;

ArithmeticAssignmentExpressionContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

function ObjectAssignmentExpressionContext(parser, ctx) {
	Assignment_expressionContext.call(this, parser);
    Assignment_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ObjectAssignmentExpressionContext.prototype = Object.create(Assignment_expressionContext.prototype);
ObjectAssignmentExpressionContext.prototype.constructor = ObjectAssignmentExpressionContext;

LanguageParser.ObjectAssignmentExpressionContext = ObjectAssignmentExpressionContext;

ObjectAssignmentExpressionContext.prototype.LBRACE = function() {
    return this.getToken(LanguageParser.LBRACE, 0);
};

ObjectAssignmentExpressionContext.prototype.RBRACE = function() {
    return this.getToken(LanguageParser.RBRACE, 0);
};

function ListAssignmentExpressionContext(parser, ctx) {
	Assignment_expressionContext.call(this, parser);
    Assignment_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ListAssignmentExpressionContext.prototype = Object.create(Assignment_expressionContext.prototype);
ListAssignmentExpressionContext.prototype.constructor = ListAssignmentExpressionContext;

LanguageParser.ListAssignmentExpressionContext = ListAssignmentExpressionContext;

ListAssignmentExpressionContext.prototype.LBRACKET = function() {
    return this.getToken(LanguageParser.LBRACKET, 0);
};

ListAssignmentExpressionContext.prototype.RBRACKET = function() {
    return this.getToken(LanguageParser.RBRACKET, 0);
};


LanguageParser.Assignment_expressionContext = Assignment_expressionContext;

LanguageParser.prototype.assignment_expression = function() {

    var localctx = new Assignment_expressionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 6, LanguageParser.RULE_assignment_expression);
    try {
        this.state = 101;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,2,this._ctx);
        switch(la_) {
        case 1:
            localctx = new ArithmeticAssignmentExpressionContext(this, localctx);
            this.enterOuterAlt(localctx, 1);
            this.state = 95;
            this.arithmetic_expression(0);
            break;

        case 2:
            localctx = new ComparisonAssignmentExpressionContext(this, localctx);
            this.enterOuterAlt(localctx, 2);
            this.state = 96;
            this.comparison_expression();
            break;

        case 3:
            localctx = new ObjectAssignmentExpressionContext(this, localctx);
            this.enterOuterAlt(localctx, 3);
            this.state = 97;
            this.match(LanguageParser.LBRACE);
            this.state = 98;
            this.match(LanguageParser.RBRACE);
            break;

        case 4:
            localctx = new ListAssignmentExpressionContext(this, localctx);
            this.enterOuterAlt(localctx, 4);
            this.state = 99;
            this.match(LanguageParser.LBRACKET);
            this.state = 100;
            this.match(LanguageParser.RBRACKET);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function AssignmentContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_assignment;
    return this;
}

AssignmentContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
AssignmentContext.prototype.constructor = AssignmentContext;


 
AssignmentContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function ListAssignmentContext(parser, ctx) {
	AssignmentContext.call(this, parser);
    AssignmentContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ListAssignmentContext.prototype = Object.create(AssignmentContext.prototype);
ListAssignmentContext.prototype.constructor = ListAssignmentContext;

LanguageParser.ListAssignmentContext = ListAssignmentContext;

ListAssignmentContext.prototype.IDENTIFIER = function() {
    return this.getToken(LanguageParser.IDENTIFIER, 0);
};

ListAssignmentContext.prototype.LBRACKET = function() {
    return this.getToken(LanguageParser.LBRACKET, 0);
};

ListAssignmentContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

ListAssignmentContext.prototype.RBRACKET = function() {
    return this.getToken(LanguageParser.RBRACKET, 0);
};

ListAssignmentContext.prototype.assignment_operator = function() {
    return this.getTypedRuleContext(Assignment_operatorContext,0);
};

ListAssignmentContext.prototype.assignment_expression = function() {
    return this.getTypedRuleContext(Assignment_expressionContext,0);
};

ListAssignmentContext.prototype.SEMI = function() {
    return this.getToken(LanguageParser.SEMI, 0);
};

function LiteralAssignmentContext(parser, ctx) {
	AssignmentContext.call(this, parser);
    AssignmentContext.prototype.copyFrom.call(this, ctx);
    return this;
}

LiteralAssignmentContext.prototype = Object.create(AssignmentContext.prototype);
LiteralAssignmentContext.prototype.constructor = LiteralAssignmentContext;

LanguageParser.LiteralAssignmentContext = LiteralAssignmentContext;

LiteralAssignmentContext.prototype.IDENTIFIER = function() {
    return this.getToken(LanguageParser.IDENTIFIER, 0);
};

LiteralAssignmentContext.prototype.assignment_operator = function() {
    return this.getTypedRuleContext(Assignment_operatorContext,0);
};

LiteralAssignmentContext.prototype.assignment_expression = function() {
    return this.getTypedRuleContext(Assignment_expressionContext,0);
};

LiteralAssignmentContext.prototype.SEMI = function() {
    return this.getToken(LanguageParser.SEMI, 0);
};

function ObjectAssignmentContext(parser, ctx) {
	AssignmentContext.call(this, parser);
    AssignmentContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ObjectAssignmentContext.prototype = Object.create(AssignmentContext.prototype);
ObjectAssignmentContext.prototype.constructor = ObjectAssignmentContext;

LanguageParser.ObjectAssignmentContext = ObjectAssignmentContext;

ObjectAssignmentContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


ObjectAssignmentContext.prototype.DOT = function() {
    return this.getToken(LanguageParser.DOT, 0);
};

ObjectAssignmentContext.prototype.assignment_operator = function() {
    return this.getTypedRuleContext(Assignment_operatorContext,0);
};

ObjectAssignmentContext.prototype.assignment_expression = function() {
    return this.getTypedRuleContext(Assignment_expressionContext,0);
};

ObjectAssignmentContext.prototype.SEMI = function() {
    return this.getToken(LanguageParser.SEMI, 0);
};

function ListObjectAssignmentContext(parser, ctx) {
	AssignmentContext.call(this, parser);
    AssignmentContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ListObjectAssignmentContext.prototype = Object.create(AssignmentContext.prototype);
ListObjectAssignmentContext.prototype.constructor = ListObjectAssignmentContext;

LanguageParser.ListObjectAssignmentContext = ListObjectAssignmentContext;

ListObjectAssignmentContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


ListObjectAssignmentContext.prototype.LBRACKET = function() {
    return this.getToken(LanguageParser.LBRACKET, 0);
};

ListObjectAssignmentContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

ListObjectAssignmentContext.prototype.RBRACKET = function() {
    return this.getToken(LanguageParser.RBRACKET, 0);
};

ListObjectAssignmentContext.prototype.DOT = function() {
    return this.getToken(LanguageParser.DOT, 0);
};

ListObjectAssignmentContext.prototype.assignment_operator = function() {
    return this.getTypedRuleContext(Assignment_operatorContext,0);
};

ListObjectAssignmentContext.prototype.assignment_expression = function() {
    return this.getTypedRuleContext(Assignment_expressionContext,0);
};

ListObjectAssignmentContext.prototype.SEMI = function() {
    return this.getToken(LanguageParser.SEMI, 0);
};


LanguageParser.AssignmentContext = AssignmentContext;

LanguageParser.prototype.assignment = function() {

    var localctx = new AssignmentContext(this, this._ctx, this.state);
    this.enterRule(localctx, 8, LanguageParser.RULE_assignment);
    try {
        this.state = 133;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,3,this._ctx);
        switch(la_) {
        case 1:
            localctx = new LiteralAssignmentContext(this, localctx);
            this.enterOuterAlt(localctx, 1);
            this.state = 103;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 104;
            this.assignment_operator();
            this.state = 105;
            this.assignment_expression();
            this.state = 106;
            this.match(LanguageParser.SEMI);
            break;

        case 2:
            localctx = new ObjectAssignmentContext(this, localctx);
            this.enterOuterAlt(localctx, 2);
            this.state = 108;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 109;
            this.match(LanguageParser.DOT);
            this.state = 110;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 111;
            this.assignment_operator();
            this.state = 112;
            this.assignment_expression();
            this.state = 113;
            this.match(LanguageParser.SEMI);
            break;

        case 3:
            localctx = new ListAssignmentContext(this, localctx);
            this.enterOuterAlt(localctx, 3);
            this.state = 115;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 116;
            this.match(LanguageParser.LBRACKET);
            this.state = 117;
            this.arithmetic_expression(0);
            this.state = 118;
            this.match(LanguageParser.RBRACKET);
            this.state = 119;
            this.assignment_operator();
            this.state = 120;
            this.assignment_expression();
            this.state = 121;
            this.match(LanguageParser.SEMI);
            break;

        case 4:
            localctx = new ListObjectAssignmentContext(this, localctx);
            this.enterOuterAlt(localctx, 4);
            this.state = 123;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 124;
            this.match(LanguageParser.LBRACKET);
            this.state = 125;
            this.arithmetic_expression(0);
            this.state = 126;
            this.match(LanguageParser.RBRACKET);
            this.state = 127;
            this.match(LanguageParser.DOT);
            this.state = 128;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 129;
            this.assignment_operator();
            this.state = 130;
            this.assignment_expression();
            this.state = 131;
            this.match(LanguageParser.SEMI);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Return_valueContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_return_value;
    return this;
}

Return_valueContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Return_valueContext.prototype.constructor = Return_valueContext;


 
Return_valueContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function ReturnValueContext(parser, ctx) {
	Return_valueContext.call(this, parser);
    Return_valueContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ReturnValueContext.prototype = Object.create(Return_valueContext.prototype);
ReturnValueContext.prototype.constructor = ReturnValueContext;

LanguageParser.ReturnValueContext = ReturnValueContext;

ReturnValueContext.prototype.RETURN = function() {
    return this.getToken(LanguageParser.RETURN, 0);
};

ReturnValueContext.prototype.SEMI = function() {
    return this.getToken(LanguageParser.SEMI, 0);
};

ReturnValueContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};


LanguageParser.Return_valueContext = Return_valueContext;

LanguageParser.prototype.return_value = function() {

    var localctx = new Return_valueContext(this, this._ctx, this.state);
    this.enterRule(localctx, 10, LanguageParser.RULE_return_value);
    var _la = 0; // Token type
    try {
        localctx = new ReturnValueContext(this, localctx);
        this.enterOuterAlt(localctx, 1);
        this.state = 135;
        this.match(LanguageParser.RETURN);
        this.state = 137;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(((((_la - 13)) & ~0x1f) == 0 && ((1 << (_la - 13)) & ((1 << (LanguageParser.TRUE - 13)) | (1 << (LanguageParser.FALSE - 13)) | (1 << (LanguageParser.NULL - 13)) | (1 << (LanguageParser.ISARRAY - 13)) | (1 << (LanguageParser.ISNULL - 13)) | (1 << (LanguageParser.ISNUMBER - 13)) | (1 << (LanguageParser.FILTER - 13)) | (1 << (LanguageParser.FIRST - 13)) | (1 << (LanguageParser.SUM_IF - 13)) | (1 << (LanguageParser.COUNT_IF - 13)) | (1 << (LanguageParser.ABS - 13)) | (1 << (LanguageParser.MOD - 13)) | (1 << (LanguageParser.POW - 13)) | (1 << (LanguageParser.FACTORIAL - 13)) | (1 << (LanguageParser.SQRT - 13)) | (1 << (LanguageParser.SUM - 13)) | (1 << (LanguageParser.MAX - 13)) | (1 << (LanguageParser.MIN - 13)) | (1 << (LanguageParser.AVERAGE - 13)) | (1 << (LanguageParser.LENGTH - 13)) | (1 << (LanguageParser.COALESCE - 13)) | (1 << (LanguageParser.TERNARY - 13)) | (1 << (LanguageParser.RETORNO_VALOR - 13)) | (1 << (LanguageParser.CARACTERISTICA_TABELA - 13)) | (1 << (LanguageParser.ATIVIDADE_TABELA - 13)) | (1 << (LanguageParser.CARACTERISTICA - 13)) | (1 << (LanguageParser.CARACTERISTICA_CODIGO - 13)) | (1 << (LanguageParser.PARAMETRO - 13)) | (1 << (LanguageParser.PARAMETRO_CODIGO - 13)) | (1 << (LanguageParser.ISENCAO - 13)) | (1 << (LanguageParser.MOEDA - 13)) | (1 << (LanguageParser.ROUND - 13)))) !== 0) || ((((_la - 45)) & ~0x1f) == 0 && ((1 << (_la - 45)) & ((1 << (LanguageParser.TRUNCATE - 45)) | (1 << (LanguageParser.DATE_FUNCTION - 45)) | (1 << (LanguageParser.TODAY - 45)) | (1 << (LanguageParser.NOW - 45)) | (1 << (LanguageParser.DATE_DIF - 45)) | (1 << (LanguageParser.GET_YEAR - 45)) | (1 << (LanguageParser.GET_MONTH - 45)) | (1 << (LanguageParser.GET_DAY - 45)) | (1 << (LanguageParser.GET_HOUR - 45)) | (1 << (LanguageParser.GET_MINUTE - 45)) | (1 << (LanguageParser.ADD_DAY - 45)) | (1 << (LanguageParser.ADD_MONTH - 45)) | (1 << (LanguageParser.ADD_YEAR - 45)) | (1 << (LanguageParser.TRIM - 45)) | (1 << (LanguageParser.SUBSTRING - 45)) | (1 << (LanguageParser.SUBSTITUTE - 45)) | (1 << (LanguageParser.CONCATENATE - 45)) | (1 << (LanguageParser.SEARCH - 45)) | (1 << (LanguageParser.LPAREN - 45)) | (1 << (LanguageParser.PLUS - 45)) | (1 << (LanguageParser.MINUS - 45)))) !== 0) || ((((_la - 89)) & ~0x1f) == 0 && ((1 << (_la - 89)) & ((1 << (LanguageParser.EXERCICIO - 89)) | (1 << (LanguageParser.DATA_CALCULO - 89)) | (1 << (LanguageParser.NUMBER - 89)) | (1 << (LanguageParser.DECIMAL - 89)) | (1 << (LanguageParser.DATE - 89)) | (1 << (LanguageParser.IDENTIFIER - 89)) | (1 << (LanguageParser.TEXT - 89)) | (1 << (LanguageParser.VAR_PRIMARY - 89)))) !== 0)) {
            this.state = 136;
            this.arithmetic_expression(0);
        }

        this.state = 139;
        this.match(LanguageParser.SEMI);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function ConditionalContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_conditional;
    return this;
}

ConditionalContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ConditionalContext.prototype.constructor = ConditionalContext;


 
ConditionalContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function IfStatementContext(parser, ctx) {
	ConditionalContext.call(this, parser);
    ConditionalContext.prototype.copyFrom.call(this, ctx);
    return this;
}

IfStatementContext.prototype = Object.create(ConditionalContext.prototype);
IfStatementContext.prototype.constructor = IfStatementContext;

LanguageParser.IfStatementContext = IfStatementContext;

IfStatementContext.prototype.IF = function() {
    return this.getToken(LanguageParser.IF, 0);
};

IfStatementContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

IfStatementContext.prototype.if_expression = function() {
    return this.getTypedRuleContext(If_expressionContext,0);
};

IfStatementContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

IfStatementContext.prototype.statement_block = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Statement_blockContext);
    } else {
        return this.getTypedRuleContext(Statement_blockContext,i);
    }
};

IfStatementContext.prototype.ELSE = function() {
    return this.getToken(LanguageParser.ELSE, 0);
};


LanguageParser.ConditionalContext = ConditionalContext;

LanguageParser.prototype.conditional = function() {

    var localctx = new ConditionalContext(this, this._ctx, this.state);
    this.enterRule(localctx, 12, LanguageParser.RULE_conditional);
    try {
        localctx = new IfStatementContext(this, localctx);
        this.enterOuterAlt(localctx, 1);
        this.state = 141;
        this.match(LanguageParser.IF);
        this.state = 142;
        this.match(LanguageParser.LPAREN);
        this.state = 143;
        this.if_expression(0);
        this.state = 144;
        this.match(LanguageParser.RPAREN);
        this.state = 145;
        this.statement_block();
        this.state = 148;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,5,this._ctx);
        if(la_===1) {
            this.state = 146;
            this.match(LanguageParser.ELSE);
            this.state = 147;
            this.statement_block();

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Statement_blockContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_statement_block;
    return this;
}

Statement_blockContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Statement_blockContext.prototype.constructor = Statement_blockContext;


 
Statement_blockContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function StatementRuleBlockContext(parser, ctx) {
	Statement_blockContext.call(this, parser);
    Statement_blockContext.prototype.copyFrom.call(this, ctx);
    return this;
}

StatementRuleBlockContext.prototype = Object.create(Statement_blockContext.prototype);
StatementRuleBlockContext.prototype.constructor = StatementRuleBlockContext;

LanguageParser.StatementRuleBlockContext = StatementRuleBlockContext;

StatementRuleBlockContext.prototype.rule_block = function() {
    return this.getTypedRuleContext(Rule_blockContext,0);
};

function StatementBraceBlockContext(parser, ctx) {
	Statement_blockContext.call(this, parser);
    Statement_blockContext.prototype.copyFrom.call(this, ctx);
    return this;
}

StatementBraceBlockContext.prototype = Object.create(Statement_blockContext.prototype);
StatementBraceBlockContext.prototype.constructor = StatementBraceBlockContext;

LanguageParser.StatementBraceBlockContext = StatementBraceBlockContext;

StatementBraceBlockContext.prototype.LBRACE = function() {
    return this.getToken(LanguageParser.LBRACE, 0);
};

StatementBraceBlockContext.prototype.RBRACE = function() {
    return this.getToken(LanguageParser.RBRACE, 0);
};

StatementBraceBlockContext.prototype.rule_block = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Rule_blockContext);
    } else {
        return this.getTypedRuleContext(Rule_blockContext,i);
    }
};


LanguageParser.Statement_blockContext = Statement_blockContext;

LanguageParser.prototype.statement_block = function() {

    var localctx = new Statement_blockContext(this, this._ctx, this.state);
    this.enterRule(localctx, 14, LanguageParser.RULE_statement_block);
    var _la = 0; // Token type
    try {
        this.state = 159;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case LanguageParser.LBRACE:
            localctx = new StatementBraceBlockContext(this, localctx);
            this.enterOuterAlt(localctx, 1);
            this.state = 150;
            this.match(LanguageParser.LBRACE);
            this.state = 154;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LanguageParser.IF) | (1 << LanguageParser.SWITCH) | (1 << LanguageParser.WHILE) | (1 << LanguageParser.BREAK) | (1 << LanguageParser.TRUE) | (1 << LanguageParser.FALSE) | (1 << LanguageParser.NULL) | (1 << LanguageParser.ISARRAY) | (1 << LanguageParser.ISNULL) | (1 << LanguageParser.ISNUMBER) | (1 << LanguageParser.FILTER) | (1 << LanguageParser.FIRST) | (1 << LanguageParser.SUM_IF) | (1 << LanguageParser.COUNT_IF) | (1 << LanguageParser.ABS) | (1 << LanguageParser.MOD) | (1 << LanguageParser.POW) | (1 << LanguageParser.FACTORIAL) | (1 << LanguageParser.SQRT) | (1 << LanguageParser.SUM) | (1 << LanguageParser.MAX) | (1 << LanguageParser.MIN) | (1 << LanguageParser.AVERAGE))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (LanguageParser.LENGTH - 32)) | (1 << (LanguageParser.COALESCE - 32)) | (1 << (LanguageParser.TERNARY - 32)) | (1 << (LanguageParser.RETORNO_VALOR - 32)) | (1 << (LanguageParser.CARACTERISTICA_TABELA - 32)) | (1 << (LanguageParser.ATIVIDADE_TABELA - 32)) | (1 << (LanguageParser.CARACTERISTICA - 32)) | (1 << (LanguageParser.CARACTERISTICA_CODIGO - 32)) | (1 << (LanguageParser.PARAMETRO - 32)) | (1 << (LanguageParser.PARAMETRO_CODIGO - 32)) | (1 << (LanguageParser.ISENCAO - 32)) | (1 << (LanguageParser.MOEDA - 32)) | (1 << (LanguageParser.ROUND - 32)) | (1 << (LanguageParser.TRUNCATE - 32)) | (1 << (LanguageParser.DATE_FUNCTION - 32)) | (1 << (LanguageParser.TODAY - 32)) | (1 << (LanguageParser.NOW - 32)) | (1 << (LanguageParser.DATE_DIF - 32)) | (1 << (LanguageParser.GET_YEAR - 32)) | (1 << (LanguageParser.GET_MONTH - 32)) | (1 << (LanguageParser.GET_DAY - 32)) | (1 << (LanguageParser.GET_HOUR - 32)) | (1 << (LanguageParser.GET_MINUTE - 32)) | (1 << (LanguageParser.ADD_DAY - 32)) | (1 << (LanguageParser.ADD_MONTH - 32)) | (1 << (LanguageParser.ADD_YEAR - 32)) | (1 << (LanguageParser.TRIM - 32)) | (1 << (LanguageParser.SUBSTRING - 32)) | (1 << (LanguageParser.SUBSTITUTE - 32)) | (1 << (LanguageParser.CONCATENATE - 32)) | (1 << (LanguageParser.SEARCH - 32)))) !== 0) || ((((_la - 67)) & ~0x1f) == 0 && ((1 << (_la - 67)) & ((1 << (LanguageParser.LPAREN - 67)) | (1 << (LanguageParser.PLUS - 67)) | (1 << (LanguageParser.MINUS - 67)) | (1 << (LanguageParser.VAR - 67)) | (1 << (LanguageParser.EXERCICIO - 67)) | (1 << (LanguageParser.DATA_CALCULO - 67)) | (1 << (LanguageParser.NUMBER - 67)) | (1 << (LanguageParser.DECIMAL - 67)) | (1 << (LanguageParser.DATE - 67)) | (1 << (LanguageParser.IDENTIFIER - 67)))) !== 0) || _la===LanguageParser.TEXT || _la===LanguageParser.VAR_PRIMARY) {
                this.state = 151;
                this.rule_block();
                this.state = 156;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 157;
            this.match(LanguageParser.RBRACE);
            break;
        case LanguageParser.IF:
        case LanguageParser.SWITCH:
        case LanguageParser.WHILE:
        case LanguageParser.BREAK:
        case LanguageParser.TRUE:
        case LanguageParser.FALSE:
        case LanguageParser.NULL:
        case LanguageParser.ISARRAY:
        case LanguageParser.ISNULL:
        case LanguageParser.ISNUMBER:
        case LanguageParser.FILTER:
        case LanguageParser.FIRST:
        case LanguageParser.SUM_IF:
        case LanguageParser.COUNT_IF:
        case LanguageParser.ABS:
        case LanguageParser.MOD:
        case LanguageParser.POW:
        case LanguageParser.FACTORIAL:
        case LanguageParser.SQRT:
        case LanguageParser.SUM:
        case LanguageParser.MAX:
        case LanguageParser.MIN:
        case LanguageParser.AVERAGE:
        case LanguageParser.LENGTH:
        case LanguageParser.COALESCE:
        case LanguageParser.TERNARY:
        case LanguageParser.RETORNO_VALOR:
        case LanguageParser.CARACTERISTICA_TABELA:
        case LanguageParser.ATIVIDADE_TABELA:
        case LanguageParser.CARACTERISTICA:
        case LanguageParser.CARACTERISTICA_CODIGO:
        case LanguageParser.PARAMETRO:
        case LanguageParser.PARAMETRO_CODIGO:
        case LanguageParser.ISENCAO:
        case LanguageParser.MOEDA:
        case LanguageParser.ROUND:
        case LanguageParser.TRUNCATE:
        case LanguageParser.DATE_FUNCTION:
        case LanguageParser.TODAY:
        case LanguageParser.NOW:
        case LanguageParser.DATE_DIF:
        case LanguageParser.GET_YEAR:
        case LanguageParser.GET_MONTH:
        case LanguageParser.GET_DAY:
        case LanguageParser.GET_HOUR:
        case LanguageParser.GET_MINUTE:
        case LanguageParser.ADD_DAY:
        case LanguageParser.ADD_MONTH:
        case LanguageParser.ADD_YEAR:
        case LanguageParser.TRIM:
        case LanguageParser.SUBSTRING:
        case LanguageParser.SUBSTITUTE:
        case LanguageParser.CONCATENATE:
        case LanguageParser.SEARCH:
        case LanguageParser.LPAREN:
        case LanguageParser.PLUS:
        case LanguageParser.MINUS:
        case LanguageParser.VAR:
        case LanguageParser.EXERCICIO:
        case LanguageParser.DATA_CALCULO:
        case LanguageParser.NUMBER:
        case LanguageParser.DECIMAL:
        case LanguageParser.DATE:
        case LanguageParser.IDENTIFIER:
        case LanguageParser.TEXT:
        case LanguageParser.VAR_PRIMARY:
            localctx = new StatementRuleBlockContext(this, localctx);
            this.enterOuterAlt(localctx, 2);
            this.state = 158;
            this.rule_block();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function If_expressionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_if_expression;
    return this;
}

If_expressionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
If_expressionContext.prototype.constructor = If_expressionContext;


 
If_expressionContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};

function NotIfEntityContext(parser, ctx) {
	If_expressionContext.call(this, parser);
    If_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

NotIfEntityContext.prototype = Object.create(If_expressionContext.prototype);
NotIfEntityContext.prototype.constructor = NotIfEntityContext;

LanguageParser.NotIfEntityContext = NotIfEntityContext;

NotIfEntityContext.prototype.NOT = function() {
    return this.getToken(LanguageParser.NOT, 0);
};

NotIfEntityContext.prototype.entity = function() {
    return this.getTypedRuleContext(EntityContext,0);
};

function OrExpressionContext(parser, ctx) {
	If_expressionContext.call(this, parser);
    If_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

OrExpressionContext.prototype = Object.create(If_expressionContext.prototype);
OrExpressionContext.prototype.constructor = OrExpressionContext;

LanguageParser.OrExpressionContext = OrExpressionContext;

OrExpressionContext.prototype.if_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(If_expressionContext);
    } else {
        return this.getTypedRuleContext(If_expressionContext,i);
    }
};

OrExpressionContext.prototype.OR = function() {
    return this.getToken(LanguageParser.OR, 0);
};

function IfComparisonExpressionContext(parser, ctx) {
	If_expressionContext.call(this, parser);
    If_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

IfComparisonExpressionContext.prototype = Object.create(If_expressionContext.prototype);
IfComparisonExpressionContext.prototype.constructor = IfComparisonExpressionContext;

LanguageParser.IfComparisonExpressionContext = IfComparisonExpressionContext;

IfComparisonExpressionContext.prototype.comparison_expression = function() {
    return this.getTypedRuleContext(Comparison_expressionContext,0);
};

function AndExpressionContext(parser, ctx) {
	If_expressionContext.call(this, parser);
    If_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

AndExpressionContext.prototype = Object.create(If_expressionContext.prototype);
AndExpressionContext.prototype.constructor = AndExpressionContext;

LanguageParser.AndExpressionContext = AndExpressionContext;

AndExpressionContext.prototype.if_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(If_expressionContext);
    } else {
        return this.getTypedRuleContext(If_expressionContext,i);
    }
};

AndExpressionContext.prototype.AND = function() {
    return this.getToken(LanguageParser.AND, 0);
};

function ParenthesisIfExpressionContext(parser, ctx) {
	If_expressionContext.call(this, parser);
    If_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ParenthesisIfExpressionContext.prototype = Object.create(If_expressionContext.prototype);
ParenthesisIfExpressionContext.prototype.constructor = ParenthesisIfExpressionContext;

LanguageParser.ParenthesisIfExpressionContext = ParenthesisIfExpressionContext;

ParenthesisIfExpressionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

ParenthesisIfExpressionContext.prototype.if_expression = function() {
    return this.getTypedRuleContext(If_expressionContext,0);
};

ParenthesisIfExpressionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function IfEntityContext(parser, ctx) {
	If_expressionContext.call(this, parser);
    If_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

IfEntityContext.prototype = Object.create(If_expressionContext.prototype);
IfEntityContext.prototype.constructor = IfEntityContext;

LanguageParser.IfEntityContext = IfEntityContext;

IfEntityContext.prototype.entity = function() {
    return this.getTypedRuleContext(EntityContext,0);
};

function NotParenthesisIfExpressionContext(parser, ctx) {
	If_expressionContext.call(this, parser);
    If_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

NotParenthesisIfExpressionContext.prototype = Object.create(If_expressionContext.prototype);
NotParenthesisIfExpressionContext.prototype.constructor = NotParenthesisIfExpressionContext;

LanguageParser.NotParenthesisIfExpressionContext = NotParenthesisIfExpressionContext;

NotParenthesisIfExpressionContext.prototype.NOT = function() {
    return this.getToken(LanguageParser.NOT, 0);
};

NotParenthesisIfExpressionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

NotParenthesisIfExpressionContext.prototype.if_expression = function() {
    return this.getTypedRuleContext(If_expressionContext,0);
};

NotParenthesisIfExpressionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};


LanguageParser.prototype.if_expression = function(_p) {
	if(_p===undefined) {
	    _p = 0;
	}
    var _parentctx = this._ctx;
    var _parentState = this.state;
    var localctx = new If_expressionContext(this, this._ctx, _parentState);
    var _prevctx = localctx;
    var _startState = 16;
    this.enterRecursionRule(localctx, 16, LanguageParser.RULE_if_expression, _p);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 175;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,8,this._ctx);
        switch(la_) {
        case 1:
            localctx = new IfComparisonExpressionContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;

            this.state = 162;
            this.comparison_expression();
            break;

        case 2:
            localctx = new NotParenthesisIfExpressionContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 163;
            this.match(LanguageParser.NOT);
            this.state = 164;
            this.match(LanguageParser.LPAREN);
            this.state = 165;
            this.if_expression(0);
            this.state = 166;
            this.match(LanguageParser.RPAREN);
            break;

        case 3:
            localctx = new ParenthesisIfExpressionContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 168;
            this.match(LanguageParser.LPAREN);
            this.state = 169;
            this.if_expression(0);
            this.state = 170;
            this.match(LanguageParser.RPAREN);
            break;

        case 4:
            localctx = new NotIfEntityContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 172;
            this.match(LanguageParser.NOT);
            this.state = 173;
            this.entity();
            break;

        case 5:
            localctx = new IfEntityContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 174;
            this.entity();
            break;

        }
        this._ctx.stop = this._input.LT(-1);
        this.state = 185;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input,10,this._ctx)
        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
            if(_alt===1) {
                if(this._parseListeners!==null) {
                    this.triggerExitRuleEvent();
                }
                _prevctx = localctx;
                this.state = 183;
                this._errHandler.sync(this);
                var la_ = this._interp.adaptivePredict(this._input,9,this._ctx);
                switch(la_) {
                case 1:
                    localctx = new AndExpressionContext(this, new If_expressionContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, LanguageParser.RULE_if_expression);
                    this.state = 177;
                    if (!( this.precpred(this._ctx, 7))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 7)");
                    }
                    this.state = 178;
                    this.match(LanguageParser.AND);
                    this.state = 179;
                    this.if_expression(8);
                    break;

                case 2:
                    localctx = new OrExpressionContext(this, new If_expressionContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, LanguageParser.RULE_if_expression);
                    this.state = 180;
                    if (!( this.precpred(this._ctx, 6))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 6)");
                    }
                    this.state = 181;
                    this.match(LanguageParser.OR);
                    this.state = 182;
                    this.if_expression(7);
                    break;

                } 
            }
            this.state = 187;
            this._errHandler.sync(this);
            _alt = this._interp.adaptivePredict(this._input,10,this._ctx);
        }

    } catch( error) {
        if(error instanceof antlr4.error.RecognitionException) {
	        localctx.exception = error;
	        this._errHandler.reportError(this, error);
	        this._errHandler.recover(this, error);
	    } else {
	    	throw error;
	    }
    } finally {
        this.unrollRecursionContexts(_parentctx)
    }
    return localctx;
};


function Switch_expressionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_switch_expression;
    return this;
}

Switch_expressionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Switch_expressionContext.prototype.constructor = Switch_expressionContext;


 
Switch_expressionContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function SwitchExpressionContext(parser, ctx) {
	Switch_expressionContext.call(this, parser);
    Switch_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

SwitchExpressionContext.prototype = Object.create(Switch_expressionContext.prototype);
SwitchExpressionContext.prototype.constructor = SwitchExpressionContext;

LanguageParser.SwitchExpressionContext = SwitchExpressionContext;

SwitchExpressionContext.prototype.SWITCH = function() {
    return this.getToken(LanguageParser.SWITCH, 0);
};

SwitchExpressionContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

SwitchExpressionContext.prototype.LBRACE = function() {
    return this.getToken(LanguageParser.LBRACE, 0);
};

SwitchExpressionContext.prototype.RBRACE = function() {
    return this.getToken(LanguageParser.RBRACE, 0);
};

SwitchExpressionContext.prototype.case_statement = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Case_statementContext);
    } else {
        return this.getTypedRuleContext(Case_statementContext,i);
    }
};

SwitchExpressionContext.prototype.default_statement = function() {
    return this.getTypedRuleContext(Default_statementContext,0);
};


LanguageParser.Switch_expressionContext = Switch_expressionContext;

LanguageParser.prototype.switch_expression = function() {

    var localctx = new Switch_expressionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 18, LanguageParser.RULE_switch_expression);
    var _la = 0; // Token type
    try {
        localctx = new SwitchExpressionContext(this, localctx);
        this.enterOuterAlt(localctx, 1);
        this.state = 188;
        this.match(LanguageParser.SWITCH);
        this.state = 189;
        this.arithmetic_expression(0);
        this.state = 190;
        this.match(LanguageParser.LBRACE);
        this.state = 192; 
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        do {
            this.state = 191;
            this.case_statement();
            this.state = 194; 
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        } while(_la===LanguageParser.CASE);
        this.state = 197;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        if(_la===LanguageParser.DEFAULT) {
            this.state = 196;
            this.default_statement();
        }

        this.state = 199;
        this.match(LanguageParser.RBRACE);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Case_statementContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_case_statement;
    return this;
}

Case_statementContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Case_statementContext.prototype.constructor = Case_statementContext;


 
Case_statementContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function CaseStatementContext(parser, ctx) {
	Case_statementContext.call(this, parser);
    Case_statementContext.prototype.copyFrom.call(this, ctx);
    return this;
}

CaseStatementContext.prototype = Object.create(Case_statementContext.prototype);
CaseStatementContext.prototype.constructor = CaseStatementContext;

LanguageParser.CaseStatementContext = CaseStatementContext;

CaseStatementContext.prototype.CASE = function() {
    return this.getToken(LanguageParser.CASE, 0);
};

CaseStatementContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

CaseStatementContext.prototype.COLON = function() {
    return this.getToken(LanguageParser.COLON, 0);
};

CaseStatementContext.prototype.LBRACE = function() {
    return this.getToken(LanguageParser.LBRACE, 0);
};

CaseStatementContext.prototype.RBRACE = function() {
    return this.getToken(LanguageParser.RBRACE, 0);
};

CaseStatementContext.prototype.rule_block = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Rule_blockContext);
    } else {
        return this.getTypedRuleContext(Rule_blockContext,i);
    }
};


LanguageParser.Case_statementContext = Case_statementContext;

LanguageParser.prototype.case_statement = function() {

    var localctx = new Case_statementContext(this, this._ctx, this.state);
    this.enterRule(localctx, 20, LanguageParser.RULE_case_statement);
    var _la = 0; // Token type
    try {
        localctx = new CaseStatementContext(this, localctx);
        this.enterOuterAlt(localctx, 1);
        this.state = 201;
        this.match(LanguageParser.CASE);
        this.state = 202;
        this.arithmetic_expression(0);
        this.state = 203;
        this.match(LanguageParser.COLON);
        this.state = 213;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case LanguageParser.LBRACE:
            this.state = 204;
            this.match(LanguageParser.LBRACE);
            this.state = 206; 
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            do {
                this.state = 205;
                this.rule_block();
                this.state = 208; 
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            } while((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LanguageParser.IF) | (1 << LanguageParser.SWITCH) | (1 << LanguageParser.WHILE) | (1 << LanguageParser.BREAK) | (1 << LanguageParser.TRUE) | (1 << LanguageParser.FALSE) | (1 << LanguageParser.NULL) | (1 << LanguageParser.ISARRAY) | (1 << LanguageParser.ISNULL) | (1 << LanguageParser.ISNUMBER) | (1 << LanguageParser.FILTER) | (1 << LanguageParser.FIRST) | (1 << LanguageParser.SUM_IF) | (1 << LanguageParser.COUNT_IF) | (1 << LanguageParser.ABS) | (1 << LanguageParser.MOD) | (1 << LanguageParser.POW) | (1 << LanguageParser.FACTORIAL) | (1 << LanguageParser.SQRT) | (1 << LanguageParser.SUM) | (1 << LanguageParser.MAX) | (1 << LanguageParser.MIN) | (1 << LanguageParser.AVERAGE))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (LanguageParser.LENGTH - 32)) | (1 << (LanguageParser.COALESCE - 32)) | (1 << (LanguageParser.TERNARY - 32)) | (1 << (LanguageParser.RETORNO_VALOR - 32)) | (1 << (LanguageParser.CARACTERISTICA_TABELA - 32)) | (1 << (LanguageParser.ATIVIDADE_TABELA - 32)) | (1 << (LanguageParser.CARACTERISTICA - 32)) | (1 << (LanguageParser.CARACTERISTICA_CODIGO - 32)) | (1 << (LanguageParser.PARAMETRO - 32)) | (1 << (LanguageParser.PARAMETRO_CODIGO - 32)) | (1 << (LanguageParser.ISENCAO - 32)) | (1 << (LanguageParser.MOEDA - 32)) | (1 << (LanguageParser.ROUND - 32)) | (1 << (LanguageParser.TRUNCATE - 32)) | (1 << (LanguageParser.DATE_FUNCTION - 32)) | (1 << (LanguageParser.TODAY - 32)) | (1 << (LanguageParser.NOW - 32)) | (1 << (LanguageParser.DATE_DIF - 32)) | (1 << (LanguageParser.GET_YEAR - 32)) | (1 << (LanguageParser.GET_MONTH - 32)) | (1 << (LanguageParser.GET_DAY - 32)) | (1 << (LanguageParser.GET_HOUR - 32)) | (1 << (LanguageParser.GET_MINUTE - 32)) | (1 << (LanguageParser.ADD_DAY - 32)) | (1 << (LanguageParser.ADD_MONTH - 32)) | (1 << (LanguageParser.ADD_YEAR - 32)) | (1 << (LanguageParser.TRIM - 32)) | (1 << (LanguageParser.SUBSTRING - 32)) | (1 << (LanguageParser.SUBSTITUTE - 32)) | (1 << (LanguageParser.CONCATENATE - 32)) | (1 << (LanguageParser.SEARCH - 32)))) !== 0) || ((((_la - 67)) & ~0x1f) == 0 && ((1 << (_la - 67)) & ((1 << (LanguageParser.LPAREN - 67)) | (1 << (LanguageParser.PLUS - 67)) | (1 << (LanguageParser.MINUS - 67)) | (1 << (LanguageParser.VAR - 67)) | (1 << (LanguageParser.EXERCICIO - 67)) | (1 << (LanguageParser.DATA_CALCULO - 67)) | (1 << (LanguageParser.NUMBER - 67)) | (1 << (LanguageParser.DECIMAL - 67)) | (1 << (LanguageParser.DATE - 67)) | (1 << (LanguageParser.IDENTIFIER - 67)))) !== 0) || _la===LanguageParser.TEXT || _la===LanguageParser.VAR_PRIMARY);
            this.state = 210;
            this.match(LanguageParser.RBRACE);
            break;
        case LanguageParser.IF:
        case LanguageParser.SWITCH:
        case LanguageParser.WHILE:
        case LanguageParser.BREAK:
        case LanguageParser.TRUE:
        case LanguageParser.FALSE:
        case LanguageParser.NULL:
        case LanguageParser.ISARRAY:
        case LanguageParser.ISNULL:
        case LanguageParser.ISNUMBER:
        case LanguageParser.FILTER:
        case LanguageParser.FIRST:
        case LanguageParser.SUM_IF:
        case LanguageParser.COUNT_IF:
        case LanguageParser.ABS:
        case LanguageParser.MOD:
        case LanguageParser.POW:
        case LanguageParser.FACTORIAL:
        case LanguageParser.SQRT:
        case LanguageParser.SUM:
        case LanguageParser.MAX:
        case LanguageParser.MIN:
        case LanguageParser.AVERAGE:
        case LanguageParser.LENGTH:
        case LanguageParser.COALESCE:
        case LanguageParser.TERNARY:
        case LanguageParser.RETORNO_VALOR:
        case LanguageParser.CARACTERISTICA_TABELA:
        case LanguageParser.ATIVIDADE_TABELA:
        case LanguageParser.CARACTERISTICA:
        case LanguageParser.CARACTERISTICA_CODIGO:
        case LanguageParser.PARAMETRO:
        case LanguageParser.PARAMETRO_CODIGO:
        case LanguageParser.ISENCAO:
        case LanguageParser.MOEDA:
        case LanguageParser.ROUND:
        case LanguageParser.TRUNCATE:
        case LanguageParser.DATE_FUNCTION:
        case LanguageParser.TODAY:
        case LanguageParser.NOW:
        case LanguageParser.DATE_DIF:
        case LanguageParser.GET_YEAR:
        case LanguageParser.GET_MONTH:
        case LanguageParser.GET_DAY:
        case LanguageParser.GET_HOUR:
        case LanguageParser.GET_MINUTE:
        case LanguageParser.ADD_DAY:
        case LanguageParser.ADD_MONTH:
        case LanguageParser.ADD_YEAR:
        case LanguageParser.TRIM:
        case LanguageParser.SUBSTRING:
        case LanguageParser.SUBSTITUTE:
        case LanguageParser.CONCATENATE:
        case LanguageParser.SEARCH:
        case LanguageParser.LPAREN:
        case LanguageParser.PLUS:
        case LanguageParser.MINUS:
        case LanguageParser.VAR:
        case LanguageParser.EXERCICIO:
        case LanguageParser.DATA_CALCULO:
        case LanguageParser.NUMBER:
        case LanguageParser.DECIMAL:
        case LanguageParser.DATE:
        case LanguageParser.IDENTIFIER:
        case LanguageParser.TEXT:
        case LanguageParser.VAR_PRIMARY:
            this.state = 212;
            this.rule_block();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Default_statementContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_default_statement;
    return this;
}

Default_statementContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Default_statementContext.prototype.constructor = Default_statementContext;


 
Default_statementContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function DefaultStatementContext(parser, ctx) {
	Default_statementContext.call(this, parser);
    Default_statementContext.prototype.copyFrom.call(this, ctx);
    return this;
}

DefaultStatementContext.prototype = Object.create(Default_statementContext.prototype);
DefaultStatementContext.prototype.constructor = DefaultStatementContext;

LanguageParser.DefaultStatementContext = DefaultStatementContext;

DefaultStatementContext.prototype.DEFAULT = function() {
    return this.getToken(LanguageParser.DEFAULT, 0);
};

DefaultStatementContext.prototype.COLON = function() {
    return this.getToken(LanguageParser.COLON, 0);
};

DefaultStatementContext.prototype.LBRACE = function() {
    return this.getToken(LanguageParser.LBRACE, 0);
};

DefaultStatementContext.prototype.RBRACE = function() {
    return this.getToken(LanguageParser.RBRACE, 0);
};

DefaultStatementContext.prototype.rule_block = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Rule_blockContext);
    } else {
        return this.getTypedRuleContext(Rule_blockContext,i);
    }
};


LanguageParser.Default_statementContext = Default_statementContext;

LanguageParser.prototype.default_statement = function() {

    var localctx = new Default_statementContext(this, this._ctx, this.state);
    this.enterRule(localctx, 22, LanguageParser.RULE_default_statement);
    var _la = 0; // Token type
    try {
        localctx = new DefaultStatementContext(this, localctx);
        this.enterOuterAlt(localctx, 1);
        this.state = 215;
        this.match(LanguageParser.DEFAULT);
        this.state = 216;
        this.match(LanguageParser.COLON);
        this.state = 226;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case LanguageParser.LBRACE:
            this.state = 217;
            this.match(LanguageParser.LBRACE);
            this.state = 219; 
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            do {
                this.state = 218;
                this.rule_block();
                this.state = 221; 
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            } while((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LanguageParser.IF) | (1 << LanguageParser.SWITCH) | (1 << LanguageParser.WHILE) | (1 << LanguageParser.BREAK) | (1 << LanguageParser.TRUE) | (1 << LanguageParser.FALSE) | (1 << LanguageParser.NULL) | (1 << LanguageParser.ISARRAY) | (1 << LanguageParser.ISNULL) | (1 << LanguageParser.ISNUMBER) | (1 << LanguageParser.FILTER) | (1 << LanguageParser.FIRST) | (1 << LanguageParser.SUM_IF) | (1 << LanguageParser.COUNT_IF) | (1 << LanguageParser.ABS) | (1 << LanguageParser.MOD) | (1 << LanguageParser.POW) | (1 << LanguageParser.FACTORIAL) | (1 << LanguageParser.SQRT) | (1 << LanguageParser.SUM) | (1 << LanguageParser.MAX) | (1 << LanguageParser.MIN) | (1 << LanguageParser.AVERAGE))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (LanguageParser.LENGTH - 32)) | (1 << (LanguageParser.COALESCE - 32)) | (1 << (LanguageParser.TERNARY - 32)) | (1 << (LanguageParser.RETORNO_VALOR - 32)) | (1 << (LanguageParser.CARACTERISTICA_TABELA - 32)) | (1 << (LanguageParser.ATIVIDADE_TABELA - 32)) | (1 << (LanguageParser.CARACTERISTICA - 32)) | (1 << (LanguageParser.CARACTERISTICA_CODIGO - 32)) | (1 << (LanguageParser.PARAMETRO - 32)) | (1 << (LanguageParser.PARAMETRO_CODIGO - 32)) | (1 << (LanguageParser.ISENCAO - 32)) | (1 << (LanguageParser.MOEDA - 32)) | (1 << (LanguageParser.ROUND - 32)) | (1 << (LanguageParser.TRUNCATE - 32)) | (1 << (LanguageParser.DATE_FUNCTION - 32)) | (1 << (LanguageParser.TODAY - 32)) | (1 << (LanguageParser.NOW - 32)) | (1 << (LanguageParser.DATE_DIF - 32)) | (1 << (LanguageParser.GET_YEAR - 32)) | (1 << (LanguageParser.GET_MONTH - 32)) | (1 << (LanguageParser.GET_DAY - 32)) | (1 << (LanguageParser.GET_HOUR - 32)) | (1 << (LanguageParser.GET_MINUTE - 32)) | (1 << (LanguageParser.ADD_DAY - 32)) | (1 << (LanguageParser.ADD_MONTH - 32)) | (1 << (LanguageParser.ADD_YEAR - 32)) | (1 << (LanguageParser.TRIM - 32)) | (1 << (LanguageParser.SUBSTRING - 32)) | (1 << (LanguageParser.SUBSTITUTE - 32)) | (1 << (LanguageParser.CONCATENATE - 32)) | (1 << (LanguageParser.SEARCH - 32)))) !== 0) || ((((_la - 67)) & ~0x1f) == 0 && ((1 << (_la - 67)) & ((1 << (LanguageParser.LPAREN - 67)) | (1 << (LanguageParser.PLUS - 67)) | (1 << (LanguageParser.MINUS - 67)) | (1 << (LanguageParser.VAR - 67)) | (1 << (LanguageParser.EXERCICIO - 67)) | (1 << (LanguageParser.DATA_CALCULO - 67)) | (1 << (LanguageParser.NUMBER - 67)) | (1 << (LanguageParser.DECIMAL - 67)) | (1 << (LanguageParser.DATE - 67)) | (1 << (LanguageParser.IDENTIFIER - 67)))) !== 0) || _la===LanguageParser.TEXT || _la===LanguageParser.VAR_PRIMARY);
            this.state = 223;
            this.match(LanguageParser.RBRACE);
            break;
        case LanguageParser.IF:
        case LanguageParser.SWITCH:
        case LanguageParser.WHILE:
        case LanguageParser.BREAK:
        case LanguageParser.TRUE:
        case LanguageParser.FALSE:
        case LanguageParser.NULL:
        case LanguageParser.ISARRAY:
        case LanguageParser.ISNULL:
        case LanguageParser.ISNUMBER:
        case LanguageParser.FILTER:
        case LanguageParser.FIRST:
        case LanguageParser.SUM_IF:
        case LanguageParser.COUNT_IF:
        case LanguageParser.ABS:
        case LanguageParser.MOD:
        case LanguageParser.POW:
        case LanguageParser.FACTORIAL:
        case LanguageParser.SQRT:
        case LanguageParser.SUM:
        case LanguageParser.MAX:
        case LanguageParser.MIN:
        case LanguageParser.AVERAGE:
        case LanguageParser.LENGTH:
        case LanguageParser.COALESCE:
        case LanguageParser.TERNARY:
        case LanguageParser.RETORNO_VALOR:
        case LanguageParser.CARACTERISTICA_TABELA:
        case LanguageParser.ATIVIDADE_TABELA:
        case LanguageParser.CARACTERISTICA:
        case LanguageParser.CARACTERISTICA_CODIGO:
        case LanguageParser.PARAMETRO:
        case LanguageParser.PARAMETRO_CODIGO:
        case LanguageParser.ISENCAO:
        case LanguageParser.MOEDA:
        case LanguageParser.ROUND:
        case LanguageParser.TRUNCATE:
        case LanguageParser.DATE_FUNCTION:
        case LanguageParser.TODAY:
        case LanguageParser.NOW:
        case LanguageParser.DATE_DIF:
        case LanguageParser.GET_YEAR:
        case LanguageParser.GET_MONTH:
        case LanguageParser.GET_DAY:
        case LanguageParser.GET_HOUR:
        case LanguageParser.GET_MINUTE:
        case LanguageParser.ADD_DAY:
        case LanguageParser.ADD_MONTH:
        case LanguageParser.ADD_YEAR:
        case LanguageParser.TRIM:
        case LanguageParser.SUBSTRING:
        case LanguageParser.SUBSTITUTE:
        case LanguageParser.CONCATENATE:
        case LanguageParser.SEARCH:
        case LanguageParser.LPAREN:
        case LanguageParser.PLUS:
        case LanguageParser.MINUS:
        case LanguageParser.VAR:
        case LanguageParser.EXERCICIO:
        case LanguageParser.DATA_CALCULO:
        case LanguageParser.NUMBER:
        case LanguageParser.DECIMAL:
        case LanguageParser.DATE:
        case LanguageParser.IDENTIFIER:
        case LanguageParser.TEXT:
        case LanguageParser.VAR_PRIMARY:
            this.state = 225;
            this.rule_block();
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Comparison_expressionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_comparison_expression;
    return this;
}

Comparison_expressionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Comparison_expressionContext.prototype.constructor = Comparison_expressionContext;


 
Comparison_expressionContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function ParenthesisComparisonExpressionContext(parser, ctx) {
	Comparison_expressionContext.call(this, parser);
    Comparison_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ParenthesisComparisonExpressionContext.prototype = Object.create(Comparison_expressionContext.prototype);
ParenthesisComparisonExpressionContext.prototype.constructor = ParenthesisComparisonExpressionContext;

LanguageParser.ParenthesisComparisonExpressionContext = ParenthesisComparisonExpressionContext;

ParenthesisComparisonExpressionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

ParenthesisComparisonExpressionContext.prototype.comparison_expression = function() {
    return this.getTypedRuleContext(Comparison_expressionContext,0);
};

ParenthesisComparisonExpressionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function EntityComparisonExpressionContext(parser, ctx) {
	Comparison_expressionContext.call(this, parser);
    Comparison_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

EntityComparisonExpressionContext.prototype = Object.create(Comparison_expressionContext.prototype);
EntityComparisonExpressionContext.prototype.constructor = EntityComparisonExpressionContext;

LanguageParser.EntityComparisonExpressionContext = EntityComparisonExpressionContext;

EntityComparisonExpressionContext.prototype.entity = function() {
    return this.getTypedRuleContext(EntityContext,0);
};

function ComparisonExpressionContext(parser, ctx) {
	Comparison_expressionContext.call(this, parser);
    Comparison_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ComparisonExpressionContext.prototype = Object.create(Comparison_expressionContext.prototype);
ComparisonExpressionContext.prototype.constructor = ComparisonExpressionContext;

LanguageParser.ComparisonExpressionContext = ComparisonExpressionContext;

ComparisonExpressionContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

ComparisonExpressionContext.prototype.comparison_operator = function() {
    return this.getTypedRuleContext(Comparison_operatorContext,0);
};

function FunctionComparisonExpressionContext(parser, ctx) {
	Comparison_expressionContext.call(this, parser);
    Comparison_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

FunctionComparisonExpressionContext.prototype = Object.create(Comparison_expressionContext.prototype);
FunctionComparisonExpressionContext.prototype.constructor = FunctionComparisonExpressionContext;

LanguageParser.FunctionComparisonExpressionContext = FunctionComparisonExpressionContext;

FunctionComparisonExpressionContext.prototype.function_signature = function() {
    return this.getTypedRuleContext(Function_signatureContext,0);
};


LanguageParser.Comparison_expressionContext = Comparison_expressionContext;

LanguageParser.prototype.comparison_expression = function() {

    var localctx = new Comparison_expressionContext(this, this._ctx, this.state);
    this.enterRule(localctx, 24, LanguageParser.RULE_comparison_expression);
    try {
        this.state = 238;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,17,this._ctx);
        switch(la_) {
        case 1:
            localctx = new ComparisonExpressionContext(this, localctx);
            this.enterOuterAlt(localctx, 1);
            this.state = 228;
            this.arithmetic_expression(0);
            this.state = 229;
            this.comparison_operator();
            this.state = 230;
            this.arithmetic_expression(0);
            break;

        case 2:
            localctx = new ParenthesisComparisonExpressionContext(this, localctx);
            this.enterOuterAlt(localctx, 2);
            this.state = 232;
            this.match(LanguageParser.LPAREN);
            this.state = 233;
            this.comparison_expression();
            this.state = 234;
            this.match(LanguageParser.RPAREN);
            break;

        case 3:
            localctx = new FunctionComparisonExpressionContext(this, localctx);
            this.enterOuterAlt(localctx, 3);
            this.state = 236;
            this.function_signature();
            break;

        case 4:
            localctx = new EntityComparisonExpressionContext(this, localctx);
            this.enterOuterAlt(localctx, 4);
            this.state = 237;
            this.entity();
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Comparison_operatorContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_comparison_operator;
    return this;
}

Comparison_operatorContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Comparison_operatorContext.prototype.constructor = Comparison_operatorContext;

Comparison_operatorContext.prototype.GT = function() {
    return this.getToken(LanguageParser.GT, 0);
};

Comparison_operatorContext.prototype.GE = function() {
    return this.getToken(LanguageParser.GE, 0);
};

Comparison_operatorContext.prototype.LT = function() {
    return this.getToken(LanguageParser.LT, 0);
};

Comparison_operatorContext.prototype.LE = function() {
    return this.getToken(LanguageParser.LE, 0);
};

Comparison_operatorContext.prototype.EQ = function() {
    return this.getToken(LanguageParser.EQ, 0);
};

Comparison_operatorContext.prototype.NEQ = function() {
    return this.getToken(LanguageParser.NEQ, 0);
};




LanguageParser.Comparison_operatorContext = Comparison_operatorContext;

LanguageParser.prototype.comparison_operator = function() {

    var localctx = new Comparison_operatorContext(this, this._ctx, this.state);
    this.enterRule(localctx, 26, LanguageParser.RULE_comparison_operator);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 240;
        _la = this._input.LA(1);
        if(!(((((_la - 73)) & ~0x1f) == 0 && ((1 << (_la - 73)) & ((1 << (LanguageParser.GT - 73)) | (1 << (LanguageParser.GE - 73)) | (1 << (LanguageParser.LT - 73)) | (1 << (LanguageParser.LE - 73)) | (1 << (LanguageParser.EQ - 73)) | (1 << (LanguageParser.NEQ - 73)))) !== 0))) {
        this._errHandler.recoverInline(this);
        }
        else {
        	this._errHandler.reportMatch(this);
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Assignment_operatorContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_assignment_operator;
    return this;
}

Assignment_operatorContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Assignment_operatorContext.prototype.constructor = Assignment_operatorContext;

Assignment_operatorContext.prototype.ATRIB = function() {
    return this.getToken(LanguageParser.ATRIB, 0);
};

Assignment_operatorContext.prototype.PLUS_ASSIGNMENT = function() {
    return this.getToken(LanguageParser.PLUS_ASSIGNMENT, 0);
};

Assignment_operatorContext.prototype.MINUS_ASSIGNMENT = function() {
    return this.getToken(LanguageParser.MINUS_ASSIGNMENT, 0);
};

Assignment_operatorContext.prototype.MULT_ASSIGNMENT = function() {
    return this.getToken(LanguageParser.MULT_ASSIGNMENT, 0);
};

Assignment_operatorContext.prototype.DIV_ASSIGNMENT = function() {
    return this.getToken(LanguageParser.DIV_ASSIGNMENT, 0);
};




LanguageParser.Assignment_operatorContext = Assignment_operatorContext;

LanguageParser.prototype.assignment_operator = function() {

    var localctx = new Assignment_operatorContext(this, this._ctx, this.state);
    this.enterRule(localctx, 28, LanguageParser.RULE_assignment_operator);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 242;
        _la = this._input.LA(1);
        if(!(((((_la - 82)) & ~0x1f) == 0 && ((1 << (_la - 82)) & ((1 << (LanguageParser.ATRIB - 82)) | (1 << (LanguageParser.PLUS_ASSIGNMENT - 82)) | (1 << (LanguageParser.MINUS_ASSIGNMENT - 82)) | (1 << (LanguageParser.MULT_ASSIGNMENT - 82)) | (1 << (LanguageParser.DIV_ASSIGNMENT - 82)))) !== 0))) {
        this._errHandler.recoverInline(this);
        }
        else {
        	this._errHandler.reportMatch(this);
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function LoopContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_loop;
    return this;
}

LoopContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
LoopContext.prototype.constructor = LoopContext;


 
LoopContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function WhileExpressionContext(parser, ctx) {
	LoopContext.call(this, parser);
    LoopContext.prototype.copyFrom.call(this, ctx);
    return this;
}

WhileExpressionContext.prototype = Object.create(LoopContext.prototype);
WhileExpressionContext.prototype.constructor = WhileExpressionContext;

LanguageParser.WhileExpressionContext = WhileExpressionContext;

WhileExpressionContext.prototype.WHILE = function() {
    return this.getToken(LanguageParser.WHILE, 0);
};

WhileExpressionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

WhileExpressionContext.prototype.if_expression = function() {
    return this.getTypedRuleContext(If_expressionContext,0);
};

WhileExpressionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

WhileExpressionContext.prototype.LBRACE = function() {
    return this.getToken(LanguageParser.LBRACE, 0);
};

WhileExpressionContext.prototype.RBRACE = function() {
    return this.getToken(LanguageParser.RBRACE, 0);
};

WhileExpressionContext.prototype.rule_block = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Rule_blockContext);
    } else {
        return this.getTypedRuleContext(Rule_blockContext,i);
    }
};


LanguageParser.LoopContext = LoopContext;

LanguageParser.prototype.loop = function() {

    var localctx = new LoopContext(this, this._ctx, this.state);
    this.enterRule(localctx, 30, LanguageParser.RULE_loop);
    var _la = 0; // Token type
    try {
        localctx = new WhileExpressionContext(this, localctx);
        this.enterOuterAlt(localctx, 1);
        this.state = 244;
        this.match(LanguageParser.WHILE);
        this.state = 245;
        this.match(LanguageParser.LPAREN);
        this.state = 246;
        this.if_expression(0);
        this.state = 247;
        this.match(LanguageParser.RPAREN);
        this.state = 248;
        this.match(LanguageParser.LBRACE);
        this.state = 252;
        this._errHandler.sync(this);
        _la = this._input.LA(1);
        while((((_la) & ~0x1f) == 0 && ((1 << _la) & ((1 << LanguageParser.IF) | (1 << LanguageParser.SWITCH) | (1 << LanguageParser.WHILE) | (1 << LanguageParser.BREAK) | (1 << LanguageParser.TRUE) | (1 << LanguageParser.FALSE) | (1 << LanguageParser.NULL) | (1 << LanguageParser.ISARRAY) | (1 << LanguageParser.ISNULL) | (1 << LanguageParser.ISNUMBER) | (1 << LanguageParser.FILTER) | (1 << LanguageParser.FIRST) | (1 << LanguageParser.SUM_IF) | (1 << LanguageParser.COUNT_IF) | (1 << LanguageParser.ABS) | (1 << LanguageParser.MOD) | (1 << LanguageParser.POW) | (1 << LanguageParser.FACTORIAL) | (1 << LanguageParser.SQRT) | (1 << LanguageParser.SUM) | (1 << LanguageParser.MAX) | (1 << LanguageParser.MIN) | (1 << LanguageParser.AVERAGE))) !== 0) || ((((_la - 32)) & ~0x1f) == 0 && ((1 << (_la - 32)) & ((1 << (LanguageParser.LENGTH - 32)) | (1 << (LanguageParser.COALESCE - 32)) | (1 << (LanguageParser.TERNARY - 32)) | (1 << (LanguageParser.RETORNO_VALOR - 32)) | (1 << (LanguageParser.CARACTERISTICA_TABELA - 32)) | (1 << (LanguageParser.ATIVIDADE_TABELA - 32)) | (1 << (LanguageParser.CARACTERISTICA - 32)) | (1 << (LanguageParser.CARACTERISTICA_CODIGO - 32)) | (1 << (LanguageParser.PARAMETRO - 32)) | (1 << (LanguageParser.PARAMETRO_CODIGO - 32)) | (1 << (LanguageParser.ISENCAO - 32)) | (1 << (LanguageParser.MOEDA - 32)) | (1 << (LanguageParser.ROUND - 32)) | (1 << (LanguageParser.TRUNCATE - 32)) | (1 << (LanguageParser.DATE_FUNCTION - 32)) | (1 << (LanguageParser.TODAY - 32)) | (1 << (LanguageParser.NOW - 32)) | (1 << (LanguageParser.DATE_DIF - 32)) | (1 << (LanguageParser.GET_YEAR - 32)) | (1 << (LanguageParser.GET_MONTH - 32)) | (1 << (LanguageParser.GET_DAY - 32)) | (1 << (LanguageParser.GET_HOUR - 32)) | (1 << (LanguageParser.GET_MINUTE - 32)) | (1 << (LanguageParser.ADD_DAY - 32)) | (1 << (LanguageParser.ADD_MONTH - 32)) | (1 << (LanguageParser.ADD_YEAR - 32)) | (1 << (LanguageParser.TRIM - 32)) | (1 << (LanguageParser.SUBSTRING - 32)) | (1 << (LanguageParser.SUBSTITUTE - 32)) | (1 << (LanguageParser.CONCATENATE - 32)) | (1 << (LanguageParser.SEARCH - 32)))) !== 0) || ((((_la - 67)) & ~0x1f) == 0 && ((1 << (_la - 67)) & ((1 << (LanguageParser.LPAREN - 67)) | (1 << (LanguageParser.PLUS - 67)) | (1 << (LanguageParser.MINUS - 67)) | (1 << (LanguageParser.VAR - 67)) | (1 << (LanguageParser.EXERCICIO - 67)) | (1 << (LanguageParser.DATA_CALCULO - 67)) | (1 << (LanguageParser.NUMBER - 67)) | (1 << (LanguageParser.DECIMAL - 67)) | (1 << (LanguageParser.DATE - 67)) | (1 << (LanguageParser.IDENTIFIER - 67)))) !== 0) || _la===LanguageParser.TEXT || _la===LanguageParser.VAR_PRIMARY) {
            this.state = 249;
            this.rule_block();
            this.state = 254;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
        }
        this.state = 255;
        this.match(LanguageParser.RBRACE);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Break_statementContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_break_statement;
    return this;
}

Break_statementContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Break_statementContext.prototype.constructor = Break_statementContext;

Break_statementContext.prototype.BREAK = function() {
    return this.getToken(LanguageParser.BREAK, 0);
};

Break_statementContext.prototype.SEMI = function() {
    return this.getToken(LanguageParser.SEMI, 0);
};




LanguageParser.Break_statementContext = Break_statementContext;

LanguageParser.prototype.break_statement = function() {

    var localctx = new Break_statementContext(this, this._ctx, this.state);
    this.enterRule(localctx, 32, LanguageParser.RULE_break_statement);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 257;
        this.match(LanguageParser.BREAK);
        this.state = 258;
        this.match(LanguageParser.SEMI);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Function_signatureContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_function_signature;
    return this;
}

Function_signatureContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Function_signatureContext.prototype.constructor = Function_signatureContext;


 
Function_signatureContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function AddDayFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

AddDayFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
AddDayFunctionContext.prototype.constructor = AddDayFunctionContext;

LanguageParser.AddDayFunctionContext = AddDayFunctionContext;

AddDayFunctionContext.prototype.ADD_DAY = function() {
    return this.getToken(LanguageParser.ADD_DAY, 0);
};

AddDayFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

AddDayFunctionContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

AddDayFunctionContext.prototype.COMMA = function() {
    return this.getToken(LanguageParser.COMMA, 0);
};

AddDayFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function FirstListContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

FirstListContext.prototype = Object.create(Function_signatureContext.prototype);
FirstListContext.prototype.constructor = FirstListContext;

LanguageParser.FirstListContext = FirstListContext;

FirstListContext.prototype.FIRST = function() {
    return this.getToken(LanguageParser.FIRST, 0);
};

FirstListContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

FirstListContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


FirstListContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


FirstListContext.prototype.LAMBDA_SIGN = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.LAMBDA_SIGN);
    } else {
        return this.getToken(LanguageParser.LAMBDA_SIGN, i);
    }
};


FirstListContext.prototype.if_expression = function() {
    return this.getTypedRuleContext(If_expressionContext,0);
};

FirstListContext.prototype.LBRACE = function() {
    return this.getToken(LanguageParser.LBRACE, 0);
};

FirstListContext.prototype.DOT = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.DOT);
    } else {
        return this.getToken(LanguageParser.DOT, i);
    }
};


FirstListContext.prototype.RBRACE = function() {
    return this.getToken(LanguageParser.RBRACE, 0);
};

FirstListContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function CaracteristicaTabelaExercicioContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

CaracteristicaTabelaExercicioContext.prototype = Object.create(Function_signatureContext.prototype);
CaracteristicaTabelaExercicioContext.prototype.constructor = CaracteristicaTabelaExercicioContext;

LanguageParser.CaracteristicaTabelaExercicioContext = CaracteristicaTabelaExercicioContext;

CaracteristicaTabelaExercicioContext.prototype.CARACTERISTICA_TABELA = function() {
    return this.getToken(LanguageParser.CARACTERISTICA_TABELA, 0);
};

CaracteristicaTabelaExercicioContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

CaracteristicaTabelaExercicioContext.prototype.text = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(TextContext);
    } else {
        return this.getTypedRuleContext(TextContext,i);
    }
};

CaracteristicaTabelaExercicioContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


CaracteristicaTabelaExercicioContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

CaracteristicaTabelaExercicioContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function MinDatabaseContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

MinDatabaseContext.prototype = Object.create(Function_signatureContext.prototype);
MinDatabaseContext.prototype.constructor = MinDatabaseContext;

LanguageParser.MinDatabaseContext = MinDatabaseContext;

MinDatabaseContext.prototype.MIN = function() {
    return this.getToken(LanguageParser.MIN, 0);
};

MinDatabaseContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

MinDatabaseContext.prototype.VAR_PRIMARY = function() {
    return this.getToken(LanguageParser.VAR_PRIMARY, 0);
};

MinDatabaseContext.prototype.DOT = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.DOT);
    } else {
        return this.getToken(LanguageParser.DOT, i);
    }
};


MinDatabaseContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


MinDatabaseContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function SumIfListLocalContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

SumIfListLocalContext.prototype = Object.create(Function_signatureContext.prototype);
SumIfListLocalContext.prototype.constructor = SumIfListLocalContext;

LanguageParser.SumIfListLocalContext = SumIfListLocalContext;

SumIfListLocalContext.prototype.SUM_IF = function() {
    return this.getToken(LanguageParser.SUM_IF, 0);
};

SumIfListLocalContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

SumIfListLocalContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


SumIfListLocalContext.prototype.DOT = function() {
    return this.getToken(LanguageParser.DOT, 0);
};

SumIfListLocalContext.prototype.COMMA = function() {
    return this.getToken(LanguageParser.COMMA, 0);
};

SumIfListLocalContext.prototype.LAMBDA_SIGN = function() {
    return this.getToken(LanguageParser.LAMBDA_SIGN, 0);
};

SumIfListLocalContext.prototype.if_expression = function() {
    return this.getTypedRuleContext(If_expressionContext,0);
};

SumIfListLocalContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function SumIfFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

SumIfFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
SumIfFunctionContext.prototype.constructor = SumIfFunctionContext;

LanguageParser.SumIfFunctionContext = SumIfFunctionContext;

SumIfFunctionContext.prototype.SUM_IF = function() {
    return this.getToken(LanguageParser.SUM_IF, 0);
};

SumIfFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

SumIfFunctionContext.prototype.VAR_PRIMARY = function() {
    return this.getToken(LanguageParser.VAR_PRIMARY, 0);
};

SumIfFunctionContext.prototype.DOT = function() {
    return this.getToken(LanguageParser.DOT, 0);
};

SumIfFunctionContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


SumIfFunctionContext.prototype.COMMA = function() {
    return this.getToken(LanguageParser.COMMA, 0);
};

SumIfFunctionContext.prototype.LAMBDA_SIGN = function() {
    return this.getToken(LanguageParser.LAMBDA_SIGN, 0);
};

SumIfFunctionContext.prototype.if_expression = function() {
    return this.getTypedRuleContext(If_expressionContext,0);
};

SumIfFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function LengthVariableContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

LengthVariableContext.prototype = Object.create(Function_signatureContext.prototype);
LengthVariableContext.prototype.constructor = LengthVariableContext;

LanguageParser.LengthVariableContext = LengthVariableContext;

LengthVariableContext.prototype.LENGTH = function() {
    return this.getToken(LanguageParser.LENGTH, 0);
};

LengthVariableContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

LengthVariableContext.prototype.IDENTIFIER = function() {
    return this.getToken(LanguageParser.IDENTIFIER, 0);
};

LengthVariableContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function GetMinuteFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

GetMinuteFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
GetMinuteFunctionContext.prototype.constructor = GetMinuteFunctionContext;

LanguageParser.GetMinuteFunctionContext = GetMinuteFunctionContext;

GetMinuteFunctionContext.prototype.GET_MINUTE = function() {
    return this.getToken(LanguageParser.GET_MINUTE, 0);
};

GetMinuteFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

GetMinuteFunctionContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

GetMinuteFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function PowFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

PowFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
PowFunctionContext.prototype.constructor = PowFunctionContext;

LanguageParser.PowFunctionContext = PowFunctionContext;

PowFunctionContext.prototype.POW = function() {
    return this.getToken(LanguageParser.POW, 0);
};

PowFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

PowFunctionContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

PowFunctionContext.prototype.COMMA = function() {
    return this.getToken(LanguageParser.COMMA, 0);
};

PowFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function SumDatabaseContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

SumDatabaseContext.prototype = Object.create(Function_signatureContext.prototype);
SumDatabaseContext.prototype.constructor = SumDatabaseContext;

LanguageParser.SumDatabaseContext = SumDatabaseContext;

SumDatabaseContext.prototype.SUM = function() {
    return this.getToken(LanguageParser.SUM, 0);
};

SumDatabaseContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

SumDatabaseContext.prototype.VAR_PRIMARY = function() {
    return this.getToken(LanguageParser.VAR_PRIMARY, 0);
};

SumDatabaseContext.prototype.DOT = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.DOT);
    } else {
        return this.getToken(LanguageParser.DOT, i);
    }
};


SumDatabaseContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


SumDatabaseContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function AtividadeTabelaContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

AtividadeTabelaContext.prototype = Object.create(Function_signatureContext.prototype);
AtividadeTabelaContext.prototype.constructor = AtividadeTabelaContext;

LanguageParser.AtividadeTabelaContext = AtividadeTabelaContext;

AtividadeTabelaContext.prototype.ATIVIDADE_TABELA = function() {
    return this.getToken(LanguageParser.ATIVIDADE_TABELA, 0);
};

AtividadeTabelaContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

AtividadeTabelaContext.prototype.text = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(TextContext);
    } else {
        return this.getTypedRuleContext(TextContext,i);
    }
};

AtividadeTabelaContext.prototype.COMMA = function() {
    return this.getToken(LanguageParser.COMMA, 0);
};

AtividadeTabelaContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function FirstRoteiroFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

FirstRoteiroFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
FirstRoteiroFunctionContext.prototype.constructor = FirstRoteiroFunctionContext;

LanguageParser.FirstRoteiroFunctionContext = FirstRoteiroFunctionContext;

FirstRoteiroFunctionContext.prototype.FIRST = function() {
    return this.getToken(LanguageParser.FIRST, 0);
};

FirstRoteiroFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

FirstRoteiroFunctionContext.prototype.VAR_PRIMARY = function() {
    return this.getToken(LanguageParser.VAR_PRIMARY, 0);
};

FirstRoteiroFunctionContext.prototype.DOT = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.DOT);
    } else {
        return this.getToken(LanguageParser.DOT, i);
    }
};


FirstRoteiroFunctionContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


FirstRoteiroFunctionContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


FirstRoteiroFunctionContext.prototype.LAMBDA_SIGN = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.LAMBDA_SIGN);
    } else {
        return this.getToken(LanguageParser.LAMBDA_SIGN, i);
    }
};


FirstRoteiroFunctionContext.prototype.if_expression = function() {
    return this.getTypedRuleContext(If_expressionContext,0);
};

FirstRoteiroFunctionContext.prototype.LBRACE = function() {
    return this.getToken(LanguageParser.LBRACE, 0);
};

FirstRoteiroFunctionContext.prototype.RBRACE = function() {
    return this.getToken(LanguageParser.RBRACE, 0);
};

FirstRoteiroFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function CountIfRoteiroFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

CountIfRoteiroFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
CountIfRoteiroFunctionContext.prototype.constructor = CountIfRoteiroFunctionContext;

LanguageParser.CountIfRoteiroFunctionContext = CountIfRoteiroFunctionContext;

CountIfRoteiroFunctionContext.prototype.COUNT_IF = function() {
    return this.getToken(LanguageParser.COUNT_IF, 0);
};

CountIfRoteiroFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

CountIfRoteiroFunctionContext.prototype.VAR_PRIMARY = function() {
    return this.getToken(LanguageParser.VAR_PRIMARY, 0);
};

CountIfRoteiroFunctionContext.prototype.DOT = function() {
    return this.getToken(LanguageParser.DOT, 0);
};

CountIfRoteiroFunctionContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


CountIfRoteiroFunctionContext.prototype.COMMA = function() {
    return this.getToken(LanguageParser.COMMA, 0);
};

CountIfRoteiroFunctionContext.prototype.LAMBDA_SIGN = function() {
    return this.getToken(LanguageParser.LAMBDA_SIGN, 0);
};

CountIfRoteiroFunctionContext.prototype.if_expression = function() {
    return this.getTypedRuleContext(If_expressionContext,0);
};

CountIfRoteiroFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function TruncateFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

TruncateFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
TruncateFunctionContext.prototype.constructor = TruncateFunctionContext;

LanguageParser.TruncateFunctionContext = TruncateFunctionContext;

TruncateFunctionContext.prototype.TRUNCATE = function() {
    return this.getToken(LanguageParser.TRUNCATE, 0);
};

TruncateFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

TruncateFunctionContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

TruncateFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function AddYearFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

AddYearFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
AddYearFunctionContext.prototype.constructor = AddYearFunctionContext;

LanguageParser.AddYearFunctionContext = AddYearFunctionContext;

AddYearFunctionContext.prototype.ADD_YEAR = function() {
    return this.getToken(LanguageParser.ADD_YEAR, 0);
};

AddYearFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

AddYearFunctionContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

AddYearFunctionContext.prototype.COMMA = function() {
    return this.getToken(LanguageParser.COMMA, 0);
};

AddYearFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function FilterRoteiroFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

FilterRoteiroFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
FilterRoteiroFunctionContext.prototype.constructor = FilterRoteiroFunctionContext;

LanguageParser.FilterRoteiroFunctionContext = FilterRoteiroFunctionContext;

FilterRoteiroFunctionContext.prototype.FILTER = function() {
    return this.getToken(LanguageParser.FILTER, 0);
};

FilterRoteiroFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

FilterRoteiroFunctionContext.prototype.VAR_PRIMARY = function() {
    return this.getToken(LanguageParser.VAR_PRIMARY, 0);
};

FilterRoteiroFunctionContext.prototype.DOT = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.DOT);
    } else {
        return this.getToken(LanguageParser.DOT, i);
    }
};


FilterRoteiroFunctionContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


FilterRoteiroFunctionContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


FilterRoteiroFunctionContext.prototype.LAMBDA_SIGN = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.LAMBDA_SIGN);
    } else {
        return this.getToken(LanguageParser.LAMBDA_SIGN, i);
    }
};


FilterRoteiroFunctionContext.prototype.if_expression = function() {
    return this.getTypedRuleContext(If_expressionContext,0);
};

FilterRoteiroFunctionContext.prototype.LBRACE = function() {
    return this.getToken(LanguageParser.LBRACE, 0);
};

FilterRoteiroFunctionContext.prototype.RBRACE = function() {
    return this.getToken(LanguageParser.RBRACE, 0);
};

FilterRoteiroFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function CoalesceFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

CoalesceFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
CoalesceFunctionContext.prototype.constructor = CoalesceFunctionContext;

LanguageParser.CoalesceFunctionContext = CoalesceFunctionContext;

CoalesceFunctionContext.prototype.COALESCE = function() {
    return this.getToken(LanguageParser.COALESCE, 0);
};

CoalesceFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

CoalesceFunctionContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

CoalesceFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

CoalesceFunctionContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


function CaracteristicaTabelaContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

CaracteristicaTabelaContext.prototype = Object.create(Function_signatureContext.prototype);
CaracteristicaTabelaContext.prototype.constructor = CaracteristicaTabelaContext;

LanguageParser.CaracteristicaTabelaContext = CaracteristicaTabelaContext;

CaracteristicaTabelaContext.prototype.CARACTERISTICA_TABELA = function() {
    return this.getToken(LanguageParser.CARACTERISTICA_TABELA, 0);
};

CaracteristicaTabelaContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

CaracteristicaTabelaContext.prototype.text = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(TextContext);
    } else {
        return this.getTypedRuleContext(TextContext,i);
    }
};

CaracteristicaTabelaContext.prototype.COMMA = function() {
    return this.getToken(LanguageParser.COMMA, 0);
};

CaracteristicaTabelaContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function CaracteristicaCodigoContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

CaracteristicaCodigoContext.prototype = Object.create(Function_signatureContext.prototype);
CaracteristicaCodigoContext.prototype.constructor = CaracteristicaCodigoContext;

LanguageParser.CaracteristicaCodigoContext = CaracteristicaCodigoContext;

CaracteristicaCodigoContext.prototype.CARACTERISTICA_CODIGO = function() {
    return this.getToken(LanguageParser.CARACTERISTICA_CODIGO, 0);
};

CaracteristicaCodigoContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

CaracteristicaCodigoContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

CaracteristicaCodigoContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


CaracteristicaCodigoContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function TodayFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

TodayFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
TodayFunctionContext.prototype.constructor = TodayFunctionContext;

LanguageParser.TodayFunctionContext = TodayFunctionContext;

TodayFunctionContext.prototype.TODAY = function() {
    return this.getToken(LanguageParser.TODAY, 0);
};

TodayFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

TodayFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function GetHourFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

GetHourFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
GetHourFunctionContext.prototype.constructor = GetHourFunctionContext;

LanguageParser.GetHourFunctionContext = GetHourFunctionContext;

GetHourFunctionContext.prototype.GET_HOUR = function() {
    return this.getToken(LanguageParser.GET_HOUR, 0);
};

GetHourFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

GetHourFunctionContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

GetHourFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function TernaryFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

TernaryFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
TernaryFunctionContext.prototype.constructor = TernaryFunctionContext;

LanguageParser.TernaryFunctionContext = TernaryFunctionContext;

TernaryFunctionContext.prototype.TERNARY = function() {
    return this.getToken(LanguageParser.TERNARY, 0);
};

TernaryFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

TernaryFunctionContext.prototype.comparison_expression = function() {
    return this.getTypedRuleContext(Comparison_expressionContext,0);
};

TernaryFunctionContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


TernaryFunctionContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

TernaryFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function AverageListLocalContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

AverageListLocalContext.prototype = Object.create(Function_signatureContext.prototype);
AverageListLocalContext.prototype.constructor = AverageListLocalContext;

LanguageParser.AverageListLocalContext = AverageListLocalContext;

AverageListLocalContext.prototype.AVERAGE = function() {
    return this.getToken(LanguageParser.AVERAGE, 0);
};

AverageListLocalContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

AverageListLocalContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


AverageListLocalContext.prototype.DOT = function() {
    return this.getToken(LanguageParser.DOT, 0);
};

AverageListLocalContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function IsNumberFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

IsNumberFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
IsNumberFunctionContext.prototype.constructor = IsNumberFunctionContext;

LanguageParser.IsNumberFunctionContext = IsNumberFunctionContext;

IsNumberFunctionContext.prototype.ISNUMBER = function() {
    return this.getToken(LanguageParser.ISNUMBER, 0);
};

IsNumberFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

IsNumberFunctionContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

IsNumberFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function GetYearFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

GetYearFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
GetYearFunctionContext.prototype.constructor = GetYearFunctionContext;

LanguageParser.GetYearFunctionContext = GetYearFunctionContext;

GetYearFunctionContext.prototype.GET_YEAR = function() {
    return this.getToken(LanguageParser.GET_YEAR, 0);
};

GetYearFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

GetYearFunctionContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

GetYearFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function LengthDatabaseContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

LengthDatabaseContext.prototype = Object.create(Function_signatureContext.prototype);
LengthDatabaseContext.prototype.constructor = LengthDatabaseContext;

LanguageParser.LengthDatabaseContext = LengthDatabaseContext;

LengthDatabaseContext.prototype.LENGTH = function() {
    return this.getToken(LanguageParser.LENGTH, 0);
};

LengthDatabaseContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

LengthDatabaseContext.prototype.VAR_PRIMARY = function() {
    return this.getToken(LanguageParser.VAR_PRIMARY, 0);
};

LengthDatabaseContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

LengthDatabaseContext.prototype.DOT = function() {
    return this.getToken(LanguageParser.DOT, 0);
};

LengthDatabaseContext.prototype.IDENTIFIER = function() {
    return this.getToken(LanguageParser.IDENTIFIER, 0);
};

function MaxDatabaseContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

MaxDatabaseContext.prototype = Object.create(Function_signatureContext.prototype);
MaxDatabaseContext.prototype.constructor = MaxDatabaseContext;

LanguageParser.MaxDatabaseContext = MaxDatabaseContext;

MaxDatabaseContext.prototype.MAX = function() {
    return this.getToken(LanguageParser.MAX, 0);
};

MaxDatabaseContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

MaxDatabaseContext.prototype.VAR_PRIMARY = function() {
    return this.getToken(LanguageParser.VAR_PRIMARY, 0);
};

MaxDatabaseContext.prototype.DOT = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.DOT);
    } else {
        return this.getToken(LanguageParser.DOT, i);
    }
};


MaxDatabaseContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


MaxDatabaseContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function SumIfRoteiroFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

SumIfRoteiroFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
SumIfRoteiroFunctionContext.prototype.constructor = SumIfRoteiroFunctionContext;

LanguageParser.SumIfRoteiroFunctionContext = SumIfRoteiroFunctionContext;

SumIfRoteiroFunctionContext.prototype.SUM_IF = function() {
    return this.getToken(LanguageParser.SUM_IF, 0);
};

SumIfRoteiroFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

SumIfRoteiroFunctionContext.prototype.VAR_PRIMARY = function() {
    return this.getToken(LanguageParser.VAR_PRIMARY, 0);
};

SumIfRoteiroFunctionContext.prototype.DOT = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.DOT);
    } else {
        return this.getToken(LanguageParser.DOT, i);
    }
};


SumIfRoteiroFunctionContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


SumIfRoteiroFunctionContext.prototype.COMMA = function() {
    return this.getToken(LanguageParser.COMMA, 0);
};

SumIfRoteiroFunctionContext.prototype.LAMBDA_SIGN = function() {
    return this.getToken(LanguageParser.LAMBDA_SIGN, 0);
};

SumIfRoteiroFunctionContext.prototype.if_expression = function() {
    return this.getTypedRuleContext(If_expressionContext,0);
};

SumIfRoteiroFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function IsNullFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

IsNullFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
IsNullFunctionContext.prototype.constructor = IsNullFunctionContext;

LanguageParser.IsNullFunctionContext = IsNullFunctionContext;

IsNullFunctionContext.prototype.ISNULL = function() {
    return this.getToken(LanguageParser.ISNULL, 0);
};

IsNullFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

IsNullFunctionContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

IsNullFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function SqrtFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

SqrtFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
SqrtFunctionContext.prototype.constructor = SqrtFunctionContext;

LanguageParser.SqrtFunctionContext = SqrtFunctionContext;

SqrtFunctionContext.prototype.SQRT = function() {
    return this.getToken(LanguageParser.SQRT, 0);
};

SqrtFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

SqrtFunctionContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

SqrtFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function FirstFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

FirstFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
FirstFunctionContext.prototype.constructor = FirstFunctionContext;

LanguageParser.FirstFunctionContext = FirstFunctionContext;

FirstFunctionContext.prototype.FIRST = function() {
    return this.getToken(LanguageParser.FIRST, 0);
};

FirstFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

FirstFunctionContext.prototype.VAR_PRIMARY = function() {
    return this.getToken(LanguageParser.VAR_PRIMARY, 0);
};

FirstFunctionContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


FirstFunctionContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


FirstFunctionContext.prototype.LAMBDA_SIGN = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.LAMBDA_SIGN);
    } else {
        return this.getToken(LanguageParser.LAMBDA_SIGN, i);
    }
};


FirstFunctionContext.prototype.if_expression = function() {
    return this.getTypedRuleContext(If_expressionContext,0);
};

FirstFunctionContext.prototype.LBRACE = function() {
    return this.getToken(LanguageParser.LBRACE, 0);
};

FirstFunctionContext.prototype.DOT = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.DOT);
    } else {
        return this.getToken(LanguageParser.DOT, i);
    }
};


FirstFunctionContext.prototype.RBRACE = function() {
    return this.getToken(LanguageParser.RBRACE, 0);
};

FirstFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function FilterFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

FilterFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
FilterFunctionContext.prototype.constructor = FilterFunctionContext;

LanguageParser.FilterFunctionContext = FilterFunctionContext;

FilterFunctionContext.prototype.FILTER = function() {
    return this.getToken(LanguageParser.FILTER, 0);
};

FilterFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

FilterFunctionContext.prototype.VAR_PRIMARY = function() {
    return this.getToken(LanguageParser.VAR_PRIMARY, 0);
};

FilterFunctionContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


FilterFunctionContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


FilterFunctionContext.prototype.LAMBDA_SIGN = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.LAMBDA_SIGN);
    } else {
        return this.getToken(LanguageParser.LAMBDA_SIGN, i);
    }
};


FilterFunctionContext.prototype.if_expression = function() {
    return this.getTypedRuleContext(If_expressionContext,0);
};

FilterFunctionContext.prototype.LBRACE = function() {
    return this.getToken(LanguageParser.LBRACE, 0);
};

FilterFunctionContext.prototype.DOT = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.DOT);
    } else {
        return this.getToken(LanguageParser.DOT, i);
    }
};


FilterFunctionContext.prototype.RBRACE = function() {
    return this.getToken(LanguageParser.RBRACE, 0);
};

FilterFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function CountIfFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

CountIfFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
CountIfFunctionContext.prototype.constructor = CountIfFunctionContext;

LanguageParser.CountIfFunctionContext = CountIfFunctionContext;

CountIfFunctionContext.prototype.COUNT_IF = function() {
    return this.getToken(LanguageParser.COUNT_IF, 0);
};

CountIfFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

CountIfFunctionContext.prototype.VAR_PRIMARY = function() {
    return this.getToken(LanguageParser.VAR_PRIMARY, 0);
};

CountIfFunctionContext.prototype.COMMA = function() {
    return this.getToken(LanguageParser.COMMA, 0);
};

CountIfFunctionContext.prototype.IDENTIFIER = function() {
    return this.getToken(LanguageParser.IDENTIFIER, 0);
};

CountIfFunctionContext.prototype.LAMBDA_SIGN = function() {
    return this.getToken(LanguageParser.LAMBDA_SIGN, 0);
};

CountIfFunctionContext.prototype.if_expression = function() {
    return this.getTypedRuleContext(If_expressionContext,0);
};

CountIfFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function AtividadeExercicioTabelaContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

AtividadeExercicioTabelaContext.prototype = Object.create(Function_signatureContext.prototype);
AtividadeExercicioTabelaContext.prototype.constructor = AtividadeExercicioTabelaContext;

LanguageParser.AtividadeExercicioTabelaContext = AtividadeExercicioTabelaContext;

AtividadeExercicioTabelaContext.prototype.ATIVIDADE_TABELA = function() {
    return this.getToken(LanguageParser.ATIVIDADE_TABELA, 0);
};

AtividadeExercicioTabelaContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

AtividadeExercicioTabelaContext.prototype.text = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(TextContext);
    } else {
        return this.getTypedRuleContext(TextContext,i);
    }
};

AtividadeExercicioTabelaContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


AtividadeExercicioTabelaContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

AtividadeExercicioTabelaContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function CaracteristicaContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

CaracteristicaContext.prototype = Object.create(Function_signatureContext.prototype);
CaracteristicaContext.prototype.constructor = CaracteristicaContext;

LanguageParser.CaracteristicaContext = CaracteristicaContext;

CaracteristicaContext.prototype.CARACTERISTICA = function() {
    return this.getToken(LanguageParser.CARACTERISTICA, 0);
};

CaracteristicaContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

CaracteristicaContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

CaracteristicaContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


CaracteristicaContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function AbsFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

AbsFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
AbsFunctionContext.prototype.constructor = AbsFunctionContext;

LanguageParser.AbsFunctionContext = AbsFunctionContext;

AbsFunctionContext.prototype.ABS = function() {
    return this.getToken(LanguageParser.ABS, 0);
};

AbsFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

AbsFunctionContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

AbsFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function ParametroContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ParametroContext.prototype = Object.create(Function_signatureContext.prototype);
ParametroContext.prototype.constructor = ParametroContext;

LanguageParser.ParametroContext = ParametroContext;

ParametroContext.prototype.PARAMETRO = function() {
    return this.getToken(LanguageParser.PARAMETRO, 0);
};

ParametroContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

ParametroContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

ParametroContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


ParametroContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function MaxListLocalContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

MaxListLocalContext.prototype = Object.create(Function_signatureContext.prototype);
MaxListLocalContext.prototype.constructor = MaxListLocalContext;

LanguageParser.MaxListLocalContext = MaxListLocalContext;

MaxListLocalContext.prototype.MAX = function() {
    return this.getToken(LanguageParser.MAX, 0);
};

MaxListLocalContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

MaxListLocalContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


MaxListLocalContext.prototype.DOT = function() {
    return this.getToken(LanguageParser.DOT, 0);
};

MaxListLocalContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function MinListLocalContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

MinListLocalContext.prototype = Object.create(Function_signatureContext.prototype);
MinListLocalContext.prototype.constructor = MinListLocalContext;

LanguageParser.MinListLocalContext = MinListLocalContext;

MinListLocalContext.prototype.MIN = function() {
    return this.getToken(LanguageParser.MIN, 0);
};

MinListLocalContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

MinListLocalContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


MinListLocalContext.prototype.DOT = function() {
    return this.getToken(LanguageParser.DOT, 0);
};

MinListLocalContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function SubstituteFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

SubstituteFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
SubstituteFunctionContext.prototype.constructor = SubstituteFunctionContext;

LanguageParser.SubstituteFunctionContext = SubstituteFunctionContext;

SubstituteFunctionContext.prototype.SUBSTITUTE = function() {
    return this.getToken(LanguageParser.SUBSTITUTE, 0);
};

SubstituteFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

SubstituteFunctionContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

SubstituteFunctionContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


SubstituteFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function NowFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

NowFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
NowFunctionContext.prototype.constructor = NowFunctionContext;

LanguageParser.NowFunctionContext = NowFunctionContext;

NowFunctionContext.prototype.NOW = function() {
    return this.getToken(LanguageParser.NOW, 0);
};

NowFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

NowFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function AddMonthFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

AddMonthFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
AddMonthFunctionContext.prototype.constructor = AddMonthFunctionContext;

LanguageParser.AddMonthFunctionContext = AddMonthFunctionContext;

AddMonthFunctionContext.prototype.ADD_MONTH = function() {
    return this.getToken(LanguageParser.ADD_MONTH, 0);
};

AddMonthFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

AddMonthFunctionContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

AddMonthFunctionContext.prototype.COMMA = function() {
    return this.getToken(LanguageParser.COMMA, 0);
};

AddMonthFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function TrimFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

TrimFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
TrimFunctionContext.prototype.constructor = TrimFunctionContext;

LanguageParser.TrimFunctionContext = TrimFunctionContext;

TrimFunctionContext.prototype.TRIM = function() {
    return this.getToken(LanguageParser.TRIM, 0);
};

TrimFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

TrimFunctionContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

TrimFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function AverageDatabaseContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

AverageDatabaseContext.prototype = Object.create(Function_signatureContext.prototype);
AverageDatabaseContext.prototype.constructor = AverageDatabaseContext;

LanguageParser.AverageDatabaseContext = AverageDatabaseContext;

AverageDatabaseContext.prototype.AVERAGE = function() {
    return this.getToken(LanguageParser.AVERAGE, 0);
};

AverageDatabaseContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

AverageDatabaseContext.prototype.VAR_PRIMARY = function() {
    return this.getToken(LanguageParser.VAR_PRIMARY, 0);
};

AverageDatabaseContext.prototype.DOT = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.DOT);
    } else {
        return this.getToken(LanguageParser.DOT, i);
    }
};


AverageDatabaseContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


AverageDatabaseContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function DateFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

DateFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
DateFunctionContext.prototype.constructor = DateFunctionContext;

LanguageParser.DateFunctionContext = DateFunctionContext;

DateFunctionContext.prototype.DATE_FUNCTION = function() {
    return this.getToken(LanguageParser.DATE_FUNCTION, 0);
};

DateFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

DateFunctionContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

DateFunctionContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


DateFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function FilterListContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

FilterListContext.prototype = Object.create(Function_signatureContext.prototype);
FilterListContext.prototype.constructor = FilterListContext;

LanguageParser.FilterListContext = FilterListContext;

FilterListContext.prototype.FILTER = function() {
    return this.getToken(LanguageParser.FILTER, 0);
};

FilterListContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

FilterListContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


FilterListContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


FilterListContext.prototype.LAMBDA_SIGN = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.LAMBDA_SIGN);
    } else {
        return this.getToken(LanguageParser.LAMBDA_SIGN, i);
    }
};


FilterListContext.prototype.if_expression = function() {
    return this.getTypedRuleContext(If_expressionContext,0);
};

FilterListContext.prototype.LBRACE = function() {
    return this.getToken(LanguageParser.LBRACE, 0);
};

FilterListContext.prototype.DOT = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.DOT);
    } else {
        return this.getToken(LanguageParser.DOT, i);
    }
};


FilterListContext.prototype.RBRACE = function() {
    return this.getToken(LanguageParser.RBRACE, 0);
};

FilterListContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function GetDayFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

GetDayFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
GetDayFunctionContext.prototype.constructor = GetDayFunctionContext;

LanguageParser.GetDayFunctionContext = GetDayFunctionContext;

GetDayFunctionContext.prototype.GET_DAY = function() {
    return this.getToken(LanguageParser.GET_DAY, 0);
};

GetDayFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

GetDayFunctionContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

GetDayFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function CountIfListLocalContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

CountIfListLocalContext.prototype = Object.create(Function_signatureContext.prototype);
CountIfListLocalContext.prototype.constructor = CountIfListLocalContext;

LanguageParser.CountIfListLocalContext = CountIfListLocalContext;

CountIfListLocalContext.prototype.COUNT_IF = function() {
    return this.getToken(LanguageParser.COUNT_IF, 0);
};

CountIfListLocalContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

CountIfListLocalContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


CountIfListLocalContext.prototype.COMMA = function() {
    return this.getToken(LanguageParser.COMMA, 0);
};

CountIfListLocalContext.prototype.LAMBDA_SIGN = function() {
    return this.getToken(LanguageParser.LAMBDA_SIGN, 0);
};

CountIfListLocalContext.prototype.if_expression = function() {
    return this.getTypedRuleContext(If_expressionContext,0);
};

CountIfListLocalContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function RoundFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

RoundFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
RoundFunctionContext.prototype.constructor = RoundFunctionContext;

LanguageParser.RoundFunctionContext = RoundFunctionContext;

RoundFunctionContext.prototype.ROUND = function() {
    return this.getToken(LanguageParser.ROUND, 0);
};

RoundFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

RoundFunctionContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

RoundFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

RoundFunctionContext.prototype.COMMA = function() {
    return this.getToken(LanguageParser.COMMA, 0);
};

function ConcatenateFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ConcatenateFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
ConcatenateFunctionContext.prototype.constructor = ConcatenateFunctionContext;

LanguageParser.ConcatenateFunctionContext = ConcatenateFunctionContext;

ConcatenateFunctionContext.prototype.CONCATENATE = function() {
    return this.getToken(LanguageParser.CONCATENATE, 0);
};

ConcatenateFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

ConcatenateFunctionContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

ConcatenateFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

ConcatenateFunctionContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


function SumListLocalContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

SumListLocalContext.prototype = Object.create(Function_signatureContext.prototype);
SumListLocalContext.prototype.constructor = SumListLocalContext;

LanguageParser.SumListLocalContext = SumListLocalContext;

SumListLocalContext.prototype.SUM = function() {
    return this.getToken(LanguageParser.SUM, 0);
};

SumListLocalContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

SumListLocalContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


SumListLocalContext.prototype.DOT = function() {
    return this.getToken(LanguageParser.DOT, 0);
};

SumListLocalContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function ModFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ModFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
ModFunctionContext.prototype.constructor = ModFunctionContext;

LanguageParser.ModFunctionContext = ModFunctionContext;

ModFunctionContext.prototype.MOD = function() {
    return this.getToken(LanguageParser.MOD, 0);
};

ModFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

ModFunctionContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

ModFunctionContext.prototype.COMMA = function() {
    return this.getToken(LanguageParser.COMMA, 0);
};

ModFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function IsArrayFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

IsArrayFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
IsArrayFunctionContext.prototype.constructor = IsArrayFunctionContext;

LanguageParser.IsArrayFunctionContext = IsArrayFunctionContext;

IsArrayFunctionContext.prototype.ISARRAY = function() {
    return this.getToken(LanguageParser.ISARRAY, 0);
};

IsArrayFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

IsArrayFunctionContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

IsArrayFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function DateDifFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

DateDifFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
DateDifFunctionContext.prototype.constructor = DateDifFunctionContext;

LanguageParser.DateDifFunctionContext = DateDifFunctionContext;

DateDifFunctionContext.prototype.DATE_DIF = function() {
    return this.getToken(LanguageParser.DATE_DIF, 0);
};

DateDifFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

DateDifFunctionContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

DateDifFunctionContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


DateDifFunctionContext.prototype.date_unit = function() {
    return this.getTypedRuleContext(Date_unitContext,0);
};

DateDifFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function SubstringFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

SubstringFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
SubstringFunctionContext.prototype.constructor = SubstringFunctionContext;

LanguageParser.SubstringFunctionContext = SubstringFunctionContext;

SubstringFunctionContext.prototype.SUBSTRING = function() {
    return this.getToken(LanguageParser.SUBSTRING, 0);
};

SubstringFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

SubstringFunctionContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

SubstringFunctionContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


SubstringFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function RetornoValorContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

RetornoValorContext.prototype = Object.create(Function_signatureContext.prototype);
RetornoValorContext.prototype.constructor = RetornoValorContext;

LanguageParser.RetornoValorContext = RetornoValorContext;

RetornoValorContext.prototype.RETORNO_VALOR = function() {
    return this.getToken(LanguageParser.RETORNO_VALOR, 0);
};

RetornoValorContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

RetornoValorContext.prototype.text = function() {
    return this.getTypedRuleContext(TextContext,0);
};

RetornoValorContext.prototype.COMMA = function() {
    return this.getToken(LanguageParser.COMMA, 0);
};

RetornoValorContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

RetornoValorContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function IsencaoContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

IsencaoContext.prototype = Object.create(Function_signatureContext.prototype);
IsencaoContext.prototype.constructor = IsencaoContext;

LanguageParser.IsencaoContext = IsencaoContext;

IsencaoContext.prototype.ISENCAO = function() {
    return this.getToken(LanguageParser.ISENCAO, 0);
};

IsencaoContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

IsencaoContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

IsencaoContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

IsencaoContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


function GetMonthFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

GetMonthFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
GetMonthFunctionContext.prototype.constructor = GetMonthFunctionContext;

LanguageParser.GetMonthFunctionContext = GetMonthFunctionContext;

GetMonthFunctionContext.prototype.GET_MONTH = function() {
    return this.getToken(LanguageParser.GET_MONTH, 0);
};

GetMonthFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

GetMonthFunctionContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

GetMonthFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function MoedaContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

MoedaContext.prototype = Object.create(Function_signatureContext.prototype);
MoedaContext.prototype.constructor = MoedaContext;

LanguageParser.MoedaContext = MoedaContext;

MoedaContext.prototype.MOEDA = function() {
    return this.getToken(LanguageParser.MOEDA, 0);
};

MoedaContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

MoedaContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

MoedaContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


MoedaContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function ParametroCodigoContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ParametroCodigoContext.prototype = Object.create(Function_signatureContext.prototype);
ParametroCodigoContext.prototype.constructor = ParametroCodigoContext;

LanguageParser.ParametroCodigoContext = ParametroCodigoContext;

ParametroCodigoContext.prototype.PARAMETRO_CODIGO = function() {
    return this.getToken(LanguageParser.PARAMETRO_CODIGO, 0);
};

ParametroCodigoContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

ParametroCodigoContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

ParametroCodigoContext.prototype.COMMA = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.COMMA);
    } else {
        return this.getToken(LanguageParser.COMMA, i);
    }
};


ParametroCodigoContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function SearchFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

SearchFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
SearchFunctionContext.prototype.constructor = SearchFunctionContext;

LanguageParser.SearchFunctionContext = SearchFunctionContext;

SearchFunctionContext.prototype.SEARCH = function() {
    return this.getToken(LanguageParser.SEARCH, 0);
};

SearchFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

SearchFunctionContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

SearchFunctionContext.prototype.COMMA = function() {
    return this.getToken(LanguageParser.COMMA, 0);
};

SearchFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function FactorialFunctionContext(parser, ctx) {
	Function_signatureContext.call(this, parser);
    Function_signatureContext.prototype.copyFrom.call(this, ctx);
    return this;
}

FactorialFunctionContext.prototype = Object.create(Function_signatureContext.prototype);
FactorialFunctionContext.prototype.constructor = FactorialFunctionContext;

LanguageParser.FactorialFunctionContext = FactorialFunctionContext;

FactorialFunctionContext.prototype.FACTORIAL = function() {
    return this.getToken(LanguageParser.FACTORIAL, 0);
};

FactorialFunctionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

FactorialFunctionContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

FactorialFunctionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};


LanguageParser.Function_signatureContext = Function_signatureContext;

LanguageParser.prototype.function_signature = function() {

    var localctx = new Function_signatureContext(this, this._ctx, this.state);
    this.enterRule(localctx, 34, LanguageParser.RULE_function_signature);
    var _la = 0; // Token type
    try {
        this.state = 872;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,43,this._ctx);
        switch(la_) {
        case 1:
            localctx = new RetornoValorContext(this, localctx);
            this.enterOuterAlt(localctx, 1);
            this.state = 260;
            this.match(LanguageParser.RETORNO_VALOR);
            this.state = 261;
            this.match(LanguageParser.LPAREN);
            this.state = 262;
            this.text();
            this.state = 263;
            this.match(LanguageParser.COMMA);
            this.state = 264;
            this.arithmetic_expression(0);
            this.state = 265;
            this.match(LanguageParser.RPAREN);
            break;

        case 2:
            localctx = new AtividadeExercicioTabelaContext(this, localctx);
            this.enterOuterAlt(localctx, 2);
            this.state = 267;
            this.match(LanguageParser.ATIVIDADE_TABELA);
            this.state = 268;
            this.match(LanguageParser.LPAREN);
            this.state = 269;
            this.text();
            this.state = 270;
            this.match(LanguageParser.COMMA);
            this.state = 271;
            this.text();
            this.state = 272;
            this.match(LanguageParser.COMMA);
            this.state = 273;
            this.arithmetic_expression(0);
            this.state = 274;
            this.match(LanguageParser.RPAREN);
            break;

        case 3:
            localctx = new AtividadeTabelaContext(this, localctx);
            this.enterOuterAlt(localctx, 3);
            this.state = 276;
            this.match(LanguageParser.ATIVIDADE_TABELA);
            this.state = 277;
            this.match(LanguageParser.LPAREN);
            this.state = 278;
            this.text();
            this.state = 279;
            this.match(LanguageParser.COMMA);
            this.state = 280;
            this.text();
            this.state = 281;
            this.match(LanguageParser.RPAREN);
            break;

        case 4:
            localctx = new CaracteristicaTabelaExercicioContext(this, localctx);
            this.enterOuterAlt(localctx, 4);
            this.state = 283;
            this.match(LanguageParser.CARACTERISTICA_TABELA);
            this.state = 284;
            this.match(LanguageParser.LPAREN);
            this.state = 285;
            this.text();
            this.state = 286;
            this.match(LanguageParser.COMMA);
            this.state = 287;
            this.text();
            this.state = 288;
            this.match(LanguageParser.COMMA);
            this.state = 289;
            this.arithmetic_expression(0);
            this.state = 290;
            this.match(LanguageParser.RPAREN);
            break;

        case 5:
            localctx = new CaracteristicaTabelaContext(this, localctx);
            this.enterOuterAlt(localctx, 5);
            this.state = 292;
            this.match(LanguageParser.CARACTERISTICA_TABELA);
            this.state = 293;
            this.match(LanguageParser.LPAREN);
            this.state = 294;
            this.text();
            this.state = 295;
            this.match(LanguageParser.COMMA);
            this.state = 296;
            this.text();
            this.state = 297;
            this.match(LanguageParser.RPAREN);
            break;

        case 6:
            localctx = new CaracteristicaContext(this, localctx);
            this.enterOuterAlt(localctx, 6);
            this.state = 299;
            this.match(LanguageParser.CARACTERISTICA);
            this.state = 300;
            this.match(LanguageParser.LPAREN);
            this.state = 301;
            this.arithmetic_expression(0);
            this.state = 302;
            this.match(LanguageParser.COMMA);
            this.state = 303;
            this.arithmetic_expression(0);
            this.state = 306;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===LanguageParser.COMMA) {
                this.state = 304;
                this.match(LanguageParser.COMMA);
                this.state = 305;
                this.arithmetic_expression(0);
            }

            this.state = 308;
            this.match(LanguageParser.RPAREN);
            break;

        case 7:
            localctx = new CaracteristicaCodigoContext(this, localctx);
            this.enterOuterAlt(localctx, 7);
            this.state = 310;
            this.match(LanguageParser.CARACTERISTICA_CODIGO);
            this.state = 311;
            this.match(LanguageParser.LPAREN);
            this.state = 312;
            this.arithmetic_expression(0);
            this.state = 313;
            this.match(LanguageParser.COMMA);
            this.state = 314;
            this.arithmetic_expression(0);
            this.state = 315;
            this.match(LanguageParser.COMMA);
            this.state = 316;
            this.arithmetic_expression(0);
            this.state = 319;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===LanguageParser.COMMA) {
                this.state = 317;
                this.match(LanguageParser.COMMA);
                this.state = 318;
                this.arithmetic_expression(0);
            }

            this.state = 321;
            this.match(LanguageParser.RPAREN);
            break;

        case 8:
            localctx = new ParametroContext(this, localctx);
            this.enterOuterAlt(localctx, 8);
            this.state = 323;
            this.match(LanguageParser.PARAMETRO);
            this.state = 324;
            this.match(LanguageParser.LPAREN);
            this.state = 325;
            this.arithmetic_expression(0);
            this.state = 326;
            this.match(LanguageParser.COMMA);
            this.state = 327;
            this.arithmetic_expression(0);
            this.state = 330;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===LanguageParser.COMMA) {
                this.state = 328;
                this.match(LanguageParser.COMMA);
                this.state = 329;
                this.arithmetic_expression(0);
            }

            this.state = 332;
            this.match(LanguageParser.RPAREN);
            break;

        case 9:
            localctx = new ParametroCodigoContext(this, localctx);
            this.enterOuterAlt(localctx, 9);
            this.state = 334;
            this.match(LanguageParser.PARAMETRO_CODIGO);
            this.state = 335;
            this.match(LanguageParser.LPAREN);
            this.state = 336;
            this.arithmetic_expression(0);
            this.state = 337;
            this.match(LanguageParser.COMMA);
            this.state = 338;
            this.arithmetic_expression(0);
            this.state = 339;
            this.match(LanguageParser.COMMA);
            this.state = 340;
            this.arithmetic_expression(0);
            this.state = 343;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===LanguageParser.COMMA) {
                this.state = 341;
                this.match(LanguageParser.COMMA);
                this.state = 342;
                this.arithmetic_expression(0);
            }

            this.state = 345;
            this.match(LanguageParser.RPAREN);
            break;

        case 10:
            localctx = new MoedaContext(this, localctx);
            this.enterOuterAlt(localctx, 10);
            this.state = 347;
            this.match(LanguageParser.MOEDA);
            this.state = 348;
            this.match(LanguageParser.LPAREN);
            this.state = 349;
            this.arithmetic_expression(0);
            this.state = 350;
            this.match(LanguageParser.COMMA);
            this.state = 351;
            this.arithmetic_expression(0);
            this.state = 352;
            this.match(LanguageParser.COMMA);
            this.state = 353;
            this.arithmetic_expression(0);
            this.state = 354;
            this.match(LanguageParser.RPAREN);
            break;

        case 11:
            localctx = new IsencaoContext(this, localctx);
            this.enterOuterAlt(localctx, 11);
            this.state = 356;
            this.match(LanguageParser.ISENCAO);
            this.state = 357;
            this.match(LanguageParser.LPAREN);
            this.state = 358;
            this.arithmetic_expression(0);
            this.state = 361;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,23,this._ctx);
            if(la_===1) {
                this.state = 359;
                this.match(LanguageParser.COMMA);
                this.state = 360;
                this.arithmetic_expression(0);

            }
            this.state = 365;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,24,this._ctx);
            if(la_===1) {
                this.state = 363;
                this.match(LanguageParser.COMMA);
                this.state = 364;
                this.arithmetic_expression(0);

            }
            this.state = 369;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===LanguageParser.COMMA) {
                this.state = 367;
                this.match(LanguageParser.COMMA);
                this.state = 368;
                this.arithmetic_expression(0);
            }

            this.state = 371;
            this.match(LanguageParser.RPAREN);
            break;

        case 12:
            localctx = new SumDatabaseContext(this, localctx);
            this.enterOuterAlt(localctx, 12);
            this.state = 373;
            this.match(LanguageParser.SUM);
            this.state = 374;
            this.match(LanguageParser.LPAREN);
            this.state = 375;
            this.match(LanguageParser.VAR_PRIMARY);
            this.state = 376;
            this.match(LanguageParser.DOT);
            this.state = 377;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 380;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===LanguageParser.DOT) {
                this.state = 378;
                this.match(LanguageParser.DOT);
                this.state = 379;
                this.match(LanguageParser.IDENTIFIER);
            }

            this.state = 382;
            this.match(LanguageParser.RPAREN);
            break;

        case 13:
            localctx = new SumListLocalContext(this, localctx);
            this.enterOuterAlt(localctx, 13);
            this.state = 383;
            this.match(LanguageParser.SUM);
            this.state = 384;
            this.match(LanguageParser.LPAREN);
            this.state = 385;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 386;
            this.match(LanguageParser.DOT);
            this.state = 387;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 388;
            this.match(LanguageParser.RPAREN);
            break;

        case 14:
            localctx = new MaxDatabaseContext(this, localctx);
            this.enterOuterAlt(localctx, 14);
            this.state = 389;
            this.match(LanguageParser.MAX);
            this.state = 390;
            this.match(LanguageParser.LPAREN);
            this.state = 391;
            this.match(LanguageParser.VAR_PRIMARY);
            this.state = 392;
            this.match(LanguageParser.DOT);
            this.state = 393;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 396;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===LanguageParser.DOT) {
                this.state = 394;
                this.match(LanguageParser.DOT);
                this.state = 395;
                this.match(LanguageParser.IDENTIFIER);
            }

            this.state = 398;
            this.match(LanguageParser.RPAREN);
            break;

        case 15:
            localctx = new MaxListLocalContext(this, localctx);
            this.enterOuterAlt(localctx, 15);
            this.state = 399;
            this.match(LanguageParser.MAX);
            this.state = 400;
            this.match(LanguageParser.LPAREN);
            this.state = 401;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 402;
            this.match(LanguageParser.DOT);
            this.state = 403;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 404;
            this.match(LanguageParser.RPAREN);
            break;

        case 16:
            localctx = new MinDatabaseContext(this, localctx);
            this.enterOuterAlt(localctx, 16);
            this.state = 405;
            this.match(LanguageParser.MIN);
            this.state = 406;
            this.match(LanguageParser.LPAREN);
            this.state = 407;
            this.match(LanguageParser.VAR_PRIMARY);
            this.state = 408;
            this.match(LanguageParser.DOT);
            this.state = 409;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 412;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===LanguageParser.DOT) {
                this.state = 410;
                this.match(LanguageParser.DOT);
                this.state = 411;
                this.match(LanguageParser.IDENTIFIER);
            }

            this.state = 414;
            this.match(LanguageParser.RPAREN);
            break;

        case 17:
            localctx = new MinListLocalContext(this, localctx);
            this.enterOuterAlt(localctx, 17);
            this.state = 415;
            this.match(LanguageParser.MIN);
            this.state = 416;
            this.match(LanguageParser.LPAREN);
            this.state = 417;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 418;
            this.match(LanguageParser.DOT);
            this.state = 419;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 420;
            this.match(LanguageParser.RPAREN);
            break;

        case 18:
            localctx = new AverageDatabaseContext(this, localctx);
            this.enterOuterAlt(localctx, 18);
            this.state = 421;
            this.match(LanguageParser.AVERAGE);
            this.state = 422;
            this.match(LanguageParser.LPAREN);
            this.state = 423;
            this.match(LanguageParser.VAR_PRIMARY);
            this.state = 424;
            this.match(LanguageParser.DOT);
            this.state = 425;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 428;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===LanguageParser.DOT) {
                this.state = 426;
                this.match(LanguageParser.DOT);
                this.state = 427;
                this.match(LanguageParser.IDENTIFIER);
            }

            this.state = 430;
            this.match(LanguageParser.RPAREN);
            break;

        case 19:
            localctx = new AverageListLocalContext(this, localctx);
            this.enterOuterAlt(localctx, 19);
            this.state = 431;
            this.match(LanguageParser.AVERAGE);
            this.state = 432;
            this.match(LanguageParser.LPAREN);
            this.state = 433;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 434;
            this.match(LanguageParser.DOT);
            this.state = 435;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 436;
            this.match(LanguageParser.RPAREN);
            break;

        case 20:
            localctx = new LengthDatabaseContext(this, localctx);
            this.enterOuterAlt(localctx, 20);
            this.state = 437;
            this.match(LanguageParser.LENGTH);
            this.state = 438;
            this.match(LanguageParser.LPAREN);
            this.state = 439;
            this.match(LanguageParser.VAR_PRIMARY);
            this.state = 442;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===LanguageParser.DOT) {
                this.state = 440;
                this.match(LanguageParser.DOT);
                this.state = 441;
                this.match(LanguageParser.IDENTIFIER);
            }

            this.state = 444;
            this.match(LanguageParser.RPAREN);
            break;

        case 21:
            localctx = new LengthVariableContext(this, localctx);
            this.enterOuterAlt(localctx, 21);
            this.state = 445;
            this.match(LanguageParser.LENGTH);
            this.state = 446;
            this.match(LanguageParser.LPAREN);
            this.state = 447;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 448;
            this.match(LanguageParser.RPAREN);
            break;

        case 22:
            localctx = new RoundFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 22);
            this.state = 449;
            this.match(LanguageParser.ROUND);
            this.state = 450;
            this.match(LanguageParser.LPAREN);
            this.state = 451;
            this.arithmetic_expression(0);
            this.state = 454;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===LanguageParser.COMMA) {
                this.state = 452;
                this.match(LanguageParser.COMMA);
                this.state = 453;
                this.arithmetic_expression(0);
            }

            this.state = 456;
            this.match(LanguageParser.RPAREN);
            break;

        case 23:
            localctx = new TruncateFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 23);
            this.state = 458;
            this.match(LanguageParser.TRUNCATE);
            this.state = 459;
            this.match(LanguageParser.LPAREN);
            this.state = 460;
            this.arithmetic_expression(0);
            this.state = 461;
            this.match(LanguageParser.RPAREN);
            break;

        case 24:
            localctx = new CoalesceFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 24);
            this.state = 463;
            this.match(LanguageParser.COALESCE);
            this.state = 464;
            this.match(LanguageParser.LPAREN);
            this.state = 465;
            this.arithmetic_expression(0);
            this.state = 468; 
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            do {
                this.state = 466;
                this.match(LanguageParser.COMMA);
                this.state = 467;
                this.arithmetic_expression(0);
                this.state = 470; 
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            } while(_la===LanguageParser.COMMA);
            this.state = 472;
            this.match(LanguageParser.RPAREN);
            break;

        case 25:
            localctx = new TernaryFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 25);
            this.state = 474;
            this.match(LanguageParser.TERNARY);
            this.state = 475;
            this.match(LanguageParser.LPAREN);
            this.state = 476;
            this.comparison_expression();
            this.state = 477;
            this.match(LanguageParser.COMMA);
            this.state = 478;
            this.arithmetic_expression(0);
            this.state = 479;
            this.match(LanguageParser.COMMA);
            this.state = 480;
            this.arithmetic_expression(0);
            this.state = 481;
            this.match(LanguageParser.RPAREN);
            break;

        case 26:
            localctx = new SqrtFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 26);
            this.state = 483;
            this.match(LanguageParser.SQRT);
            this.state = 484;
            this.match(LanguageParser.LPAREN);
            this.state = 485;
            this.arithmetic_expression(0);
            this.state = 486;
            this.match(LanguageParser.RPAREN);
            break;

        case 27:
            localctx = new AbsFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 27);
            this.state = 488;
            this.match(LanguageParser.ABS);
            this.state = 489;
            this.match(LanguageParser.LPAREN);
            this.state = 490;
            this.arithmetic_expression(0);
            this.state = 491;
            this.match(LanguageParser.RPAREN);
            break;

        case 28:
            localctx = new ModFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 28);
            this.state = 493;
            this.match(LanguageParser.MOD);
            this.state = 494;
            this.match(LanguageParser.LPAREN);
            this.state = 495;
            this.arithmetic_expression(0);
            this.state = 496;
            this.match(LanguageParser.COMMA);
            this.state = 497;
            this.arithmetic_expression(0);
            this.state = 498;
            this.match(LanguageParser.RPAREN);
            break;

        case 29:
            localctx = new PowFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 29);
            this.state = 500;
            this.match(LanguageParser.POW);
            this.state = 501;
            this.match(LanguageParser.LPAREN);
            this.state = 502;
            this.arithmetic_expression(0);
            this.state = 503;
            this.match(LanguageParser.COMMA);
            this.state = 504;
            this.arithmetic_expression(0);
            this.state = 505;
            this.match(LanguageParser.RPAREN);
            break;

        case 30:
            localctx = new FactorialFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 30);
            this.state = 507;
            this.match(LanguageParser.FACTORIAL);
            this.state = 508;
            this.match(LanguageParser.LPAREN);
            this.state = 509;
            this.arithmetic_expression(0);
            this.state = 510;
            this.match(LanguageParser.RPAREN);
            break;

        case 31:
            localctx = new FilterFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 31);
            this.state = 512;
            this.match(LanguageParser.FILTER);
            this.state = 513;
            this.match(LanguageParser.LPAREN);
            this.state = 514;
            this.match(LanguageParser.VAR_PRIMARY);
            this.state = 515;
            this.match(LanguageParser.COMMA);
            this.state = 516;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 517;
            this.match(LanguageParser.LAMBDA_SIGN);
            this.state = 518;
            this.if_expression(0);
            this.state = 519;
            this.match(LanguageParser.COMMA);
            this.state = 520;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 521;
            this.match(LanguageParser.LAMBDA_SIGN);
            this.state = 522;
            this.match(LanguageParser.LBRACE);
            this.state = 523;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 524;
            this.match(LanguageParser.DOT);
            this.state = 525;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 532;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===LanguageParser.COMMA) {
                this.state = 526;
                this.match(LanguageParser.COMMA);
                this.state = 527;
                this.match(LanguageParser.IDENTIFIER);
                this.state = 528;
                this.match(LanguageParser.DOT);
                this.state = 529;
                this.match(LanguageParser.IDENTIFIER);
                this.state = 534;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 535;
            this.match(LanguageParser.RBRACE);
            this.state = 536;
            this.match(LanguageParser.RPAREN);
            break;

        case 32:
            localctx = new FilterRoteiroFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 32);
            this.state = 538;
            this.match(LanguageParser.FILTER);
            this.state = 539;
            this.match(LanguageParser.LPAREN);
            this.state = 540;
            this.match(LanguageParser.VAR_PRIMARY);
            this.state = 541;
            this.match(LanguageParser.DOT);
            this.state = 542;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 543;
            this.match(LanguageParser.COMMA);
            this.state = 544;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 545;
            this.match(LanguageParser.LAMBDA_SIGN);
            this.state = 546;
            this.if_expression(0);
            this.state = 547;
            this.match(LanguageParser.COMMA);
            this.state = 548;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 549;
            this.match(LanguageParser.LAMBDA_SIGN);
            this.state = 550;
            this.match(LanguageParser.LBRACE);
            this.state = 551;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 552;
            this.match(LanguageParser.DOT);
            this.state = 553;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 560;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===LanguageParser.COMMA) {
                this.state = 554;
                this.match(LanguageParser.COMMA);
                this.state = 555;
                this.match(LanguageParser.IDENTIFIER);
                this.state = 556;
                this.match(LanguageParser.DOT);
                this.state = 557;
                this.match(LanguageParser.IDENTIFIER);
                this.state = 562;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 563;
            this.match(LanguageParser.RBRACE);
            this.state = 564;
            this.match(LanguageParser.RPAREN);
            break;

        case 33:
            localctx = new FilterListContext(this, localctx);
            this.enterOuterAlt(localctx, 33);
            this.state = 566;
            this.match(LanguageParser.FILTER);
            this.state = 567;
            this.match(LanguageParser.LPAREN);
            this.state = 568;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 569;
            this.match(LanguageParser.COMMA);
            this.state = 570;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 571;
            this.match(LanguageParser.LAMBDA_SIGN);
            this.state = 572;
            this.if_expression(0);
            this.state = 573;
            this.match(LanguageParser.COMMA);
            this.state = 574;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 575;
            this.match(LanguageParser.LAMBDA_SIGN);
            this.state = 576;
            this.match(LanguageParser.LBRACE);
            this.state = 577;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 578;
            this.match(LanguageParser.DOT);
            this.state = 579;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 586;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===LanguageParser.COMMA) {
                this.state = 580;
                this.match(LanguageParser.COMMA);
                this.state = 581;
                this.match(LanguageParser.IDENTIFIER);
                this.state = 582;
                this.match(LanguageParser.DOT);
                this.state = 583;
                this.match(LanguageParser.IDENTIFIER);
                this.state = 588;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 589;
            this.match(LanguageParser.RBRACE);
            this.state = 590;
            this.match(LanguageParser.RPAREN);
            break;

        case 34:
            localctx = new FirstFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 34);
            this.state = 592;
            this.match(LanguageParser.FIRST);
            this.state = 593;
            this.match(LanguageParser.LPAREN);
            this.state = 594;
            this.match(LanguageParser.VAR_PRIMARY);
            this.state = 595;
            this.match(LanguageParser.COMMA);
            this.state = 596;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 597;
            this.match(LanguageParser.LAMBDA_SIGN);
            this.state = 598;
            this.if_expression(0);
            this.state = 599;
            this.match(LanguageParser.COMMA);
            this.state = 600;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 601;
            this.match(LanguageParser.LAMBDA_SIGN);
            this.state = 602;
            this.match(LanguageParser.LBRACE);
            this.state = 603;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 604;
            this.match(LanguageParser.DOT);
            this.state = 605;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 612;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===LanguageParser.COMMA) {
                this.state = 606;
                this.match(LanguageParser.COMMA);
                this.state = 607;
                this.match(LanguageParser.IDENTIFIER);
                this.state = 608;
                this.match(LanguageParser.DOT);
                this.state = 609;
                this.match(LanguageParser.IDENTIFIER);
                this.state = 614;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 615;
            this.match(LanguageParser.RBRACE);
            this.state = 616;
            this.match(LanguageParser.RPAREN);
            break;

        case 35:
            localctx = new FirstRoteiroFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 35);
            this.state = 618;
            this.match(LanguageParser.FIRST);
            this.state = 619;
            this.match(LanguageParser.LPAREN);
            this.state = 620;
            this.match(LanguageParser.VAR_PRIMARY);
            this.state = 621;
            this.match(LanguageParser.DOT);
            this.state = 622;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 623;
            this.match(LanguageParser.COMMA);
            this.state = 624;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 625;
            this.match(LanguageParser.LAMBDA_SIGN);
            this.state = 626;
            this.if_expression(0);
            this.state = 627;
            this.match(LanguageParser.COMMA);
            this.state = 628;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 629;
            this.match(LanguageParser.LAMBDA_SIGN);
            this.state = 630;
            this.match(LanguageParser.LBRACE);
            this.state = 631;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 632;
            this.match(LanguageParser.DOT);
            this.state = 633;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 640;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===LanguageParser.COMMA) {
                this.state = 634;
                this.match(LanguageParser.COMMA);
                this.state = 635;
                this.match(LanguageParser.IDENTIFIER);
                this.state = 636;
                this.match(LanguageParser.DOT);
                this.state = 637;
                this.match(LanguageParser.IDENTIFIER);
                this.state = 642;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 643;
            this.match(LanguageParser.RBRACE);
            this.state = 644;
            this.match(LanguageParser.RPAREN);
            break;

        case 36:
            localctx = new FirstListContext(this, localctx);
            this.enterOuterAlt(localctx, 36);
            this.state = 646;
            this.match(LanguageParser.FIRST);
            this.state = 647;
            this.match(LanguageParser.LPAREN);
            this.state = 648;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 649;
            this.match(LanguageParser.COMMA);
            this.state = 650;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 651;
            this.match(LanguageParser.LAMBDA_SIGN);
            this.state = 652;
            this.if_expression(0);
            this.state = 653;
            this.match(LanguageParser.COMMA);
            this.state = 654;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 655;
            this.match(LanguageParser.LAMBDA_SIGN);
            this.state = 656;
            this.match(LanguageParser.LBRACE);
            this.state = 657;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 658;
            this.match(LanguageParser.DOT);
            this.state = 659;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 666;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            while(_la===LanguageParser.COMMA) {
                this.state = 660;
                this.match(LanguageParser.COMMA);
                this.state = 661;
                this.match(LanguageParser.IDENTIFIER);
                this.state = 662;
                this.match(LanguageParser.DOT);
                this.state = 663;
                this.match(LanguageParser.IDENTIFIER);
                this.state = 668;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            }
            this.state = 669;
            this.match(LanguageParser.RBRACE);
            this.state = 670;
            this.match(LanguageParser.RPAREN);
            break;

        case 37:
            localctx = new SumIfFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 37);
            this.state = 672;
            this.match(LanguageParser.SUM_IF);
            this.state = 673;
            this.match(LanguageParser.LPAREN);
            this.state = 674;
            this.match(LanguageParser.VAR_PRIMARY);
            this.state = 675;
            this.match(LanguageParser.DOT);
            this.state = 676;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 677;
            this.match(LanguageParser.COMMA);
            this.state = 678;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 679;
            this.match(LanguageParser.LAMBDA_SIGN);
            this.state = 680;
            this.if_expression(0);
            this.state = 681;
            this.match(LanguageParser.RPAREN);
            break;

        case 38:
            localctx = new SumIfRoteiroFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 38);
            this.state = 683;
            this.match(LanguageParser.SUM_IF);
            this.state = 684;
            this.match(LanguageParser.LPAREN);
            this.state = 685;
            this.match(LanguageParser.VAR_PRIMARY);
            this.state = 686;
            this.match(LanguageParser.DOT);
            this.state = 687;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 688;
            this.match(LanguageParser.DOT);
            this.state = 689;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 690;
            this.match(LanguageParser.COMMA);
            this.state = 691;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 692;
            this.match(LanguageParser.LAMBDA_SIGN);
            this.state = 693;
            this.if_expression(0);
            this.state = 694;
            this.match(LanguageParser.RPAREN);
            break;

        case 39:
            localctx = new SumIfListLocalContext(this, localctx);
            this.enterOuterAlt(localctx, 39);
            this.state = 696;
            this.match(LanguageParser.SUM_IF);
            this.state = 697;
            this.match(LanguageParser.LPAREN);
            this.state = 698;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 699;
            this.match(LanguageParser.DOT);
            this.state = 700;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 701;
            this.match(LanguageParser.COMMA);
            this.state = 702;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 703;
            this.match(LanguageParser.LAMBDA_SIGN);
            this.state = 704;
            this.if_expression(0);
            this.state = 705;
            this.match(LanguageParser.RPAREN);
            break;

        case 40:
            localctx = new CountIfFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 40);
            this.state = 707;
            this.match(LanguageParser.COUNT_IF);
            this.state = 708;
            this.match(LanguageParser.LPAREN);
            this.state = 709;
            this.match(LanguageParser.VAR_PRIMARY);
            this.state = 710;
            this.match(LanguageParser.COMMA);
            this.state = 711;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 712;
            this.match(LanguageParser.LAMBDA_SIGN);
            this.state = 713;
            this.if_expression(0);
            this.state = 714;
            this.match(LanguageParser.RPAREN);
            break;

        case 41:
            localctx = new CountIfRoteiroFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 41);
            this.state = 716;
            this.match(LanguageParser.COUNT_IF);
            this.state = 717;
            this.match(LanguageParser.LPAREN);
            this.state = 718;
            this.match(LanguageParser.VAR_PRIMARY);
            this.state = 719;
            this.match(LanguageParser.DOT);
            this.state = 720;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 721;
            this.match(LanguageParser.COMMA);
            this.state = 722;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 723;
            this.match(LanguageParser.LAMBDA_SIGN);
            this.state = 724;
            this.if_expression(0);
            this.state = 725;
            this.match(LanguageParser.RPAREN);
            break;

        case 42:
            localctx = new CountIfListLocalContext(this, localctx);
            this.enterOuterAlt(localctx, 42);
            this.state = 727;
            this.match(LanguageParser.COUNT_IF);
            this.state = 728;
            this.match(LanguageParser.LPAREN);
            this.state = 729;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 730;
            this.match(LanguageParser.COMMA);
            this.state = 731;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 732;
            this.match(LanguageParser.LAMBDA_SIGN);
            this.state = 733;
            this.if_expression(0);
            this.state = 734;
            this.match(LanguageParser.RPAREN);
            break;

        case 43:
            localctx = new IsArrayFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 43);
            this.state = 736;
            this.match(LanguageParser.ISARRAY);
            this.state = 737;
            this.match(LanguageParser.LPAREN);
            this.state = 738;
            this.arithmetic_expression(0);
            this.state = 739;
            this.match(LanguageParser.RPAREN);
            break;

        case 44:
            localctx = new IsNumberFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 44);
            this.state = 741;
            this.match(LanguageParser.ISNUMBER);
            this.state = 742;
            this.match(LanguageParser.LPAREN);
            this.state = 743;
            this.arithmetic_expression(0);
            this.state = 744;
            this.match(LanguageParser.RPAREN);
            break;

        case 45:
            localctx = new IsNullFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 45);
            this.state = 746;
            this.match(LanguageParser.ISNULL);
            this.state = 747;
            this.match(LanguageParser.LPAREN);
            this.state = 748;
            this.arithmetic_expression(0);
            this.state = 749;
            this.match(LanguageParser.RPAREN);
            break;

        case 46:
            localctx = new DateFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 46);
            this.state = 751;
            this.match(LanguageParser.DATE_FUNCTION);
            this.state = 752;
            this.match(LanguageParser.LPAREN);
            this.state = 753;
            this.arithmetic_expression(0);
            this.state = 754;
            this.match(LanguageParser.COMMA);
            this.state = 755;
            this.arithmetic_expression(0);
            this.state = 756;
            this.match(LanguageParser.COMMA);
            this.state = 757;
            this.arithmetic_expression(0);
            this.state = 760;
            this._errHandler.sync(this);
            var la_ = this._interp.adaptivePredict(this._input,39,this._ctx);
            if(la_===1) {
                this.state = 758;
                this.match(LanguageParser.COMMA);
                this.state = 759;
                this.arithmetic_expression(0);

            }
            this.state = 764;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===LanguageParser.COMMA) {
                this.state = 762;
                this.match(LanguageParser.COMMA);
                this.state = 763;
                this.arithmetic_expression(0);
            }

            this.state = 766;
            this.match(LanguageParser.RPAREN);
            break;

        case 47:
            localctx = new TodayFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 47);
            this.state = 768;
            this.match(LanguageParser.TODAY);
            this.state = 769;
            this.match(LanguageParser.LPAREN);
            this.state = 770;
            this.match(LanguageParser.RPAREN);
            break;

        case 48:
            localctx = new NowFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 48);
            this.state = 771;
            this.match(LanguageParser.NOW);
            this.state = 772;
            this.match(LanguageParser.LPAREN);
            this.state = 773;
            this.match(LanguageParser.RPAREN);
            break;

        case 49:
            localctx = new DateDifFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 49);
            this.state = 774;
            this.match(LanguageParser.DATE_DIF);
            this.state = 775;
            this.match(LanguageParser.LPAREN);
            this.state = 776;
            this.arithmetic_expression(0);
            this.state = 777;
            this.match(LanguageParser.COMMA);
            this.state = 778;
            this.arithmetic_expression(0);
            this.state = 779;
            this.match(LanguageParser.COMMA);
            this.state = 780;
            this.date_unit();
            this.state = 781;
            this.match(LanguageParser.RPAREN);
            break;

        case 50:
            localctx = new GetYearFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 50);
            this.state = 783;
            this.match(LanguageParser.GET_YEAR);
            this.state = 784;
            this.match(LanguageParser.LPAREN);
            this.state = 785;
            this.arithmetic_expression(0);
            this.state = 786;
            this.match(LanguageParser.RPAREN);
            break;

        case 51:
            localctx = new GetMonthFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 51);
            this.state = 788;
            this.match(LanguageParser.GET_MONTH);
            this.state = 789;
            this.match(LanguageParser.LPAREN);
            this.state = 790;
            this.arithmetic_expression(0);
            this.state = 791;
            this.match(LanguageParser.RPAREN);
            break;

        case 52:
            localctx = new GetDayFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 52);
            this.state = 793;
            this.match(LanguageParser.GET_DAY);
            this.state = 794;
            this.match(LanguageParser.LPAREN);
            this.state = 795;
            this.arithmetic_expression(0);
            this.state = 796;
            this.match(LanguageParser.RPAREN);
            break;

        case 53:
            localctx = new GetHourFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 53);
            this.state = 798;
            this.match(LanguageParser.GET_HOUR);
            this.state = 799;
            this.match(LanguageParser.LPAREN);
            this.state = 800;
            this.arithmetic_expression(0);
            this.state = 801;
            this.match(LanguageParser.RPAREN);
            break;

        case 54:
            localctx = new GetMinuteFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 54);
            this.state = 803;
            this.match(LanguageParser.GET_MINUTE);
            this.state = 804;
            this.match(LanguageParser.LPAREN);
            this.state = 805;
            this.arithmetic_expression(0);
            this.state = 806;
            this.match(LanguageParser.RPAREN);
            break;

        case 55:
            localctx = new AddYearFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 55);
            this.state = 808;
            this.match(LanguageParser.ADD_YEAR);
            this.state = 809;
            this.match(LanguageParser.LPAREN);
            this.state = 810;
            this.arithmetic_expression(0);
            this.state = 811;
            this.match(LanguageParser.COMMA);
            this.state = 812;
            this.arithmetic_expression(0);
            this.state = 813;
            this.match(LanguageParser.RPAREN);
            break;

        case 56:
            localctx = new AddMonthFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 56);
            this.state = 815;
            this.match(LanguageParser.ADD_MONTH);
            this.state = 816;
            this.match(LanguageParser.LPAREN);
            this.state = 817;
            this.arithmetic_expression(0);
            this.state = 818;
            this.match(LanguageParser.COMMA);
            this.state = 819;
            this.arithmetic_expression(0);
            this.state = 820;
            this.match(LanguageParser.RPAREN);
            break;

        case 57:
            localctx = new AddDayFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 57);
            this.state = 822;
            this.match(LanguageParser.ADD_DAY);
            this.state = 823;
            this.match(LanguageParser.LPAREN);
            this.state = 824;
            this.arithmetic_expression(0);
            this.state = 825;
            this.match(LanguageParser.COMMA);
            this.state = 826;
            this.arithmetic_expression(0);
            this.state = 827;
            this.match(LanguageParser.RPAREN);
            break;

        case 58:
            localctx = new TrimFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 58);
            this.state = 829;
            this.match(LanguageParser.TRIM);
            this.state = 830;
            this.match(LanguageParser.LPAREN);
            this.state = 831;
            this.arithmetic_expression(0);
            this.state = 832;
            this.match(LanguageParser.RPAREN);
            break;

        case 59:
            localctx = new SubstringFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 59);
            this.state = 834;
            this.match(LanguageParser.SUBSTRING);
            this.state = 835;
            this.match(LanguageParser.LPAREN);
            this.state = 836;
            this.arithmetic_expression(0);
            this.state = 837;
            this.match(LanguageParser.COMMA);
            this.state = 838;
            this.arithmetic_expression(0);
            this.state = 841;
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            if(_la===LanguageParser.COMMA) {
                this.state = 839;
                this.match(LanguageParser.COMMA);
                this.state = 840;
                this.arithmetic_expression(0);
            }

            this.state = 843;
            this.match(LanguageParser.RPAREN);
            break;

        case 60:
            localctx = new SubstituteFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 60);
            this.state = 845;
            this.match(LanguageParser.SUBSTITUTE);
            this.state = 846;
            this.match(LanguageParser.LPAREN);
            this.state = 847;
            this.arithmetic_expression(0);
            this.state = 848;
            this.match(LanguageParser.COMMA);
            this.state = 849;
            this.arithmetic_expression(0);
            this.state = 850;
            this.match(LanguageParser.COMMA);
            this.state = 851;
            this.arithmetic_expression(0);
            this.state = 852;
            this.match(LanguageParser.RPAREN);
            break;

        case 61:
            localctx = new ConcatenateFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 61);
            this.state = 854;
            this.match(LanguageParser.CONCATENATE);
            this.state = 855;
            this.match(LanguageParser.LPAREN);
            this.state = 856;
            this.arithmetic_expression(0);
            this.state = 859; 
            this._errHandler.sync(this);
            _la = this._input.LA(1);
            do {
                this.state = 857;
                this.match(LanguageParser.COMMA);
                this.state = 858;
                this.arithmetic_expression(0);
                this.state = 861; 
                this._errHandler.sync(this);
                _la = this._input.LA(1);
            } while(_la===LanguageParser.COMMA);
            this.state = 863;
            this.match(LanguageParser.RPAREN);
            break;

        case 62:
            localctx = new SearchFunctionContext(this, localctx);
            this.enterOuterAlt(localctx, 62);
            this.state = 865;
            this.match(LanguageParser.SEARCH);
            this.state = 866;
            this.match(LanguageParser.LPAREN);
            this.state = 867;
            this.arithmetic_expression(0);
            this.state = 868;
            this.match(LanguageParser.COMMA);
            this.state = 869;
            this.arithmetic_expression(0);
            this.state = 870;
            this.match(LanguageParser.RPAREN);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function High_precedence_operatorContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_high_precedence_operator;
    return this;
}

High_precedence_operatorContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
High_precedence_operatorContext.prototype.constructor = High_precedence_operatorContext;

High_precedence_operatorContext.prototype.MULT = function() {
    return this.getToken(LanguageParser.MULT, 0);
};

High_precedence_operatorContext.prototype.DIV = function() {
    return this.getToken(LanguageParser.DIV, 0);
};




LanguageParser.High_precedence_operatorContext = High_precedence_operatorContext;

LanguageParser.prototype.high_precedence_operator = function() {

    var localctx = new High_precedence_operatorContext(this, this._ctx, this.state);
    this.enterRule(localctx, 36, LanguageParser.RULE_high_precedence_operator);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 874;
        _la = this._input.LA(1);
        if(!(_la===LanguageParser.MULT || _la===LanguageParser.DIV)) {
        this._errHandler.recoverInline(this);
        }
        else {
        	this._errHandler.reportMatch(this);
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Low_precedence_operatorContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_low_precedence_operator;
    return this;
}

Low_precedence_operatorContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Low_precedence_operatorContext.prototype.constructor = Low_precedence_operatorContext;

Low_precedence_operatorContext.prototype.PLUS = function() {
    return this.getToken(LanguageParser.PLUS, 0);
};

Low_precedence_operatorContext.prototype.MINUS = function() {
    return this.getToken(LanguageParser.MINUS, 0);
};




LanguageParser.Low_precedence_operatorContext = Low_precedence_operatorContext;

LanguageParser.prototype.low_precedence_operator = function() {

    var localctx = new Low_precedence_operatorContext(this, this._ctx, this.state);
    this.enterRule(localctx, 38, LanguageParser.RULE_low_precedence_operator);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 876;
        _la = this._input.LA(1);
        if(!(_la===LanguageParser.PLUS || _la===LanguageParser.MINUS)) {
        this._errHandler.recoverInline(this);
        }
        else {
        	this._errHandler.reportMatch(this);
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Arithmetic_expressionContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_arithmetic_expression;
    return this;
}

Arithmetic_expressionContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Arithmetic_expressionContext.prototype.constructor = Arithmetic_expressionContext;


 
Arithmetic_expressionContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};

function HighPrecedenceExpressionContext(parser, ctx) {
	Arithmetic_expressionContext.call(this, parser);
    Arithmetic_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

HighPrecedenceExpressionContext.prototype = Object.create(Arithmetic_expressionContext.prototype);
HighPrecedenceExpressionContext.prototype.constructor = HighPrecedenceExpressionContext;

LanguageParser.HighPrecedenceExpressionContext = HighPrecedenceExpressionContext;

HighPrecedenceExpressionContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

HighPrecedenceExpressionContext.prototype.high_precedence_operator = function() {
    return this.getTypedRuleContext(High_precedence_operatorContext,0);
};

function LowPrecedenceExpressionContext(parser, ctx) {
	Arithmetic_expressionContext.call(this, parser);
    Arithmetic_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

LowPrecedenceExpressionContext.prototype = Object.create(Arithmetic_expressionContext.prototype);
LowPrecedenceExpressionContext.prototype.constructor = LowPrecedenceExpressionContext;

LanguageParser.LowPrecedenceExpressionContext = LowPrecedenceExpressionContext;

LowPrecedenceExpressionContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

LowPrecedenceExpressionContext.prototype.low_precedence_operator = function() {
    return this.getTypedRuleContext(Low_precedence_operatorContext,0);
};

function ParenthesisExpressionContext(parser, ctx) {
	Arithmetic_expressionContext.call(this, parser);
    Arithmetic_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ParenthesisExpressionContext.prototype = Object.create(Arithmetic_expressionContext.prototype);
ParenthesisExpressionContext.prototype.constructor = ParenthesisExpressionContext;

LanguageParser.ParenthesisExpressionContext = ParenthesisExpressionContext;

ParenthesisExpressionContext.prototype.LPAREN = function() {
    return this.getToken(LanguageParser.LPAREN, 0);
};

ParenthesisExpressionContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

ParenthesisExpressionContext.prototype.RPAREN = function() {
    return this.getToken(LanguageParser.RPAREN, 0);
};

function IfFunctionSignatureContext(parser, ctx) {
	Arithmetic_expressionContext.call(this, parser);
    Arithmetic_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

IfFunctionSignatureContext.prototype = Object.create(Arithmetic_expressionContext.prototype);
IfFunctionSignatureContext.prototype.constructor = IfFunctionSignatureContext;

LanguageParser.IfFunctionSignatureContext = IfFunctionSignatureContext;

IfFunctionSignatureContext.prototype.function_signature = function() {
    return this.getTypedRuleContext(Function_signatureContext,0);
};

function IncrementExpressionContext(parser, ctx) {
	Arithmetic_expressionContext.call(this, parser);
    Arithmetic_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

IncrementExpressionContext.prototype = Object.create(Arithmetic_expressionContext.prototype);
IncrementExpressionContext.prototype.constructor = IncrementExpressionContext;

LanguageParser.IncrementExpressionContext = IncrementExpressionContext;

IncrementExpressionContext.prototype.increment = function() {
    return this.getTypedRuleContext(IncrementContext,0);
};

function DecrementExpressionContext(parser, ctx) {
	Arithmetic_expressionContext.call(this, parser);
    Arithmetic_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

DecrementExpressionContext.prototype = Object.create(Arithmetic_expressionContext.prototype);
DecrementExpressionContext.prototype.constructor = DecrementExpressionContext;

LanguageParser.DecrementExpressionContext = DecrementExpressionContext;

DecrementExpressionContext.prototype.decrement = function() {
    return this.getTypedRuleContext(DecrementContext,0);
};

function EntityExpressionContext(parser, ctx) {
	Arithmetic_expressionContext.call(this, parser);
    Arithmetic_expressionContext.prototype.copyFrom.call(this, ctx);
    return this;
}

EntityExpressionContext.prototype = Object.create(Arithmetic_expressionContext.prototype);
EntityExpressionContext.prototype.constructor = EntityExpressionContext;

LanguageParser.EntityExpressionContext = EntityExpressionContext;

EntityExpressionContext.prototype.entity = function() {
    return this.getTypedRuleContext(EntityContext,0);
};


LanguageParser.prototype.arithmetic_expression = function(_p) {
	if(_p===undefined) {
	    _p = 0;
	}
    var _parentctx = this._ctx;
    var _parentState = this.state;
    var localctx = new Arithmetic_expressionContext(this, this._ctx, _parentState);
    var _prevctx = localctx;
    var _startState = 40;
    this.enterRecursionRule(localctx, 40, LanguageParser.RULE_arithmetic_expression, _p);
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 887;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,44,this._ctx);
        switch(la_) {
        case 1:
            localctx = new ParenthesisExpressionContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;

            this.state = 879;
            this.match(LanguageParser.LPAREN);
            this.state = 880;
            this.arithmetic_expression(0);
            this.state = 881;
            this.match(LanguageParser.RPAREN);
            break;

        case 2:
            localctx = new IfFunctionSignatureContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 883;
            this.function_signature();
            break;

        case 3:
            localctx = new IncrementExpressionContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 884;
            this.increment();
            break;

        case 4:
            localctx = new DecrementExpressionContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 885;
            this.decrement();
            break;

        case 5:
            localctx = new EntityExpressionContext(this, localctx);
            this._ctx = localctx;
            _prevctx = localctx;
            this.state = 886;
            this.entity();
            break;

        }
        this._ctx.stop = this._input.LT(-1);
        this.state = 899;
        this._errHandler.sync(this);
        var _alt = this._interp.adaptivePredict(this._input,46,this._ctx)
        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
            if(_alt===1) {
                if(this._parseListeners!==null) {
                    this.triggerExitRuleEvent();
                }
                _prevctx = localctx;
                this.state = 897;
                this._errHandler.sync(this);
                var la_ = this._interp.adaptivePredict(this._input,45,this._ctx);
                switch(la_) {
                case 1:
                    localctx = new HighPrecedenceExpressionContext(this, new Arithmetic_expressionContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, LanguageParser.RULE_arithmetic_expression);
                    this.state = 889;
                    if (!( this.precpred(this._ctx, 7))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 7)");
                    }
                    this.state = 890;
                    this.high_precedence_operator();
                    this.state = 891;
                    this.arithmetic_expression(8);
                    break;

                case 2:
                    localctx = new LowPrecedenceExpressionContext(this, new Arithmetic_expressionContext(this, _parentctx, _parentState));
                    this.pushNewRecursionContext(localctx, _startState, LanguageParser.RULE_arithmetic_expression);
                    this.state = 893;
                    if (!( this.precpred(this._ctx, 6))) {
                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 6)");
                    }
                    this.state = 894;
                    this.low_precedence_operator();
                    this.state = 895;
                    this.arithmetic_expression(7);
                    break;

                } 
            }
            this.state = 901;
            this._errHandler.sync(this);
            _alt = this._interp.adaptivePredict(this._input,46,this._ctx);
        }

    } catch( error) {
        if(error instanceof antlr4.error.RecognitionException) {
	        localctx.exception = error;
	        this._errHandler.reportError(this, error);
	        this._errHandler.recover(this, error);
	    } else {
	    	throw error;
	    }
    } finally {
        this.unrollRecursionContexts(_parentctx)
    }
    return localctx;
};


function IncrementContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_increment;
    return this;
}

IncrementContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
IncrementContext.prototype.constructor = IncrementContext;


 
IncrementContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function PostIncrementContext(parser, ctx) {
	IncrementContext.call(this, parser);
    IncrementContext.prototype.copyFrom.call(this, ctx);
    return this;
}

PostIncrementContext.prototype = Object.create(IncrementContext.prototype);
PostIncrementContext.prototype.constructor = PostIncrementContext;

LanguageParser.PostIncrementContext = PostIncrementContext;

PostIncrementContext.prototype.IDENTIFIER = function() {
    return this.getToken(LanguageParser.IDENTIFIER, 0);
};

PostIncrementContext.prototype.PLUS = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.PLUS);
    } else {
        return this.getToken(LanguageParser.PLUS, i);
    }
};


function PreIncrementContext(parser, ctx) {
	IncrementContext.call(this, parser);
    IncrementContext.prototype.copyFrom.call(this, ctx);
    return this;
}

PreIncrementContext.prototype = Object.create(IncrementContext.prototype);
PreIncrementContext.prototype.constructor = PreIncrementContext;

LanguageParser.PreIncrementContext = PreIncrementContext;

PreIncrementContext.prototype.PLUS = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.PLUS);
    } else {
        return this.getToken(LanguageParser.PLUS, i);
    }
};


PreIncrementContext.prototype.IDENTIFIER = function() {
    return this.getToken(LanguageParser.IDENTIFIER, 0);
};


LanguageParser.IncrementContext = IncrementContext;

LanguageParser.prototype.increment = function() {

    var localctx = new IncrementContext(this, this._ctx, this.state);
    this.enterRule(localctx, 42, LanguageParser.RULE_increment);
    try {
        this.state = 908;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case LanguageParser.IDENTIFIER:
            localctx = new PostIncrementContext(this, localctx);
            this.enterOuterAlt(localctx, 1);
            this.state = 902;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 903;
            this.match(LanguageParser.PLUS);
            this.state = 904;
            this.match(LanguageParser.PLUS);
            break;
        case LanguageParser.PLUS:
            localctx = new PreIncrementContext(this, localctx);
            this.enterOuterAlt(localctx, 2);
            this.state = 905;
            this.match(LanguageParser.PLUS);
            this.state = 906;
            this.match(LanguageParser.PLUS);
            this.state = 907;
            this.match(LanguageParser.IDENTIFIER);
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function DecrementContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_decrement;
    return this;
}

DecrementContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
DecrementContext.prototype.constructor = DecrementContext;


 
DecrementContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function PreDecrementContext(parser, ctx) {
	DecrementContext.call(this, parser);
    DecrementContext.prototype.copyFrom.call(this, ctx);
    return this;
}

PreDecrementContext.prototype = Object.create(DecrementContext.prototype);
PreDecrementContext.prototype.constructor = PreDecrementContext;

LanguageParser.PreDecrementContext = PreDecrementContext;

PreDecrementContext.prototype.MINUS = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.MINUS);
    } else {
        return this.getToken(LanguageParser.MINUS, i);
    }
};


PreDecrementContext.prototype.IDENTIFIER = function() {
    return this.getToken(LanguageParser.IDENTIFIER, 0);
};

function PostDecrementContext(parser, ctx) {
	DecrementContext.call(this, parser);
    DecrementContext.prototype.copyFrom.call(this, ctx);
    return this;
}

PostDecrementContext.prototype = Object.create(DecrementContext.prototype);
PostDecrementContext.prototype.constructor = PostDecrementContext;

LanguageParser.PostDecrementContext = PostDecrementContext;

PostDecrementContext.prototype.IDENTIFIER = function() {
    return this.getToken(LanguageParser.IDENTIFIER, 0);
};

PostDecrementContext.prototype.MINUS = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.MINUS);
    } else {
        return this.getToken(LanguageParser.MINUS, i);
    }
};



LanguageParser.DecrementContext = DecrementContext;

LanguageParser.prototype.decrement = function() {

    var localctx = new DecrementContext(this, this._ctx, this.state);
    this.enterRule(localctx, 44, LanguageParser.RULE_decrement);
    try {
        this.state = 916;
        this._errHandler.sync(this);
        switch(this._input.LA(1)) {
        case LanguageParser.IDENTIFIER:
            localctx = new PostDecrementContext(this, localctx);
            this.enterOuterAlt(localctx, 1);
            this.state = 910;
            this.match(LanguageParser.IDENTIFIER);
            this.state = 911;
            this.match(LanguageParser.MINUS);
            this.state = 912;
            this.match(LanguageParser.MINUS);
            break;
        case LanguageParser.MINUS:
            localctx = new PreDecrementContext(this, localctx);
            this.enterOuterAlt(localctx, 2);
            this.state = 913;
            this.match(LanguageParser.MINUS);
            this.state = 914;
            this.match(LanguageParser.MINUS);
            this.state = 915;
            this.match(LanguageParser.IDENTIFIER);
            break;
        default:
            throw new antlr4.error.NoViableAltException(this);
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function EntityContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_entity;
    return this;
}

EntityContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
EntityContext.prototype.constructor = EntityContext;


 
EntityContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function ListMemoryGlobalEntityContext(parser, ctx) {
	EntityContext.call(this, parser);
    EntityContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ListMemoryGlobalEntityContext.prototype = Object.create(EntityContext.prototype);
ListMemoryGlobalEntityContext.prototype.constructor = ListMemoryGlobalEntityContext;

LanguageParser.ListMemoryGlobalEntityContext = ListMemoryGlobalEntityContext;

ListMemoryGlobalEntityContext.prototype.listMemoryGlobal = function() {
    return this.getTypedRuleContext(ListMemoryGlobalContext,0);
};

function BoolEntityContext(parser, ctx) {
	EntityContext.call(this, parser);
    EntityContext.prototype.copyFrom.call(this, ctx);
    return this;
}

BoolEntityContext.prototype = Object.create(EntityContext.prototype);
BoolEntityContext.prototype.constructor = BoolEntityContext;

LanguageParser.BoolEntityContext = BoolEntityContext;

BoolEntityContext.prototype.TRUE = function() {
    return this.getToken(LanguageParser.TRUE, 0);
};

BoolEntityContext.prototype.FALSE = function() {
    return this.getToken(LanguageParser.FALSE, 0);
};

function NumberDecimalEntityContext(parser, ctx) {
	EntityContext.call(this, parser);
    EntityContext.prototype.copyFrom.call(this, ctx);
    return this;
}

NumberDecimalEntityContext.prototype = Object.create(EntityContext.prototype);
NumberDecimalEntityContext.prototype.constructor = NumberDecimalEntityContext;

LanguageParser.NumberDecimalEntityContext = NumberDecimalEntityContext;

NumberDecimalEntityContext.prototype.number_decimal = function() {
    return this.getTypedRuleContext(Number_decimalContext,0);
};

function ExercicioEntityContext(parser, ctx) {
	EntityContext.call(this, parser);
    EntityContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ExercicioEntityContext.prototype = Object.create(EntityContext.prototype);
ExercicioEntityContext.prototype.constructor = ExercicioEntityContext;

LanguageParser.ExercicioEntityContext = ExercicioEntityContext;

ExercicioEntityContext.prototype.EXERCICIO = function() {
    return this.getToken(LanguageParser.EXERCICIO, 0);
};

function ListEntityContext(parser, ctx) {
	EntityContext.call(this, parser);
    EntityContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ListEntityContext.prototype = Object.create(EntityContext.prototype);
ListEntityContext.prototype.constructor = ListEntityContext;

LanguageParser.ListEntityContext = ListEntityContext;

ListEntityContext.prototype.list = function() {
    return this.getTypedRuleContext(ListContext,0);
};

function NumberIntegerEntityContext(parser, ctx) {
	EntityContext.call(this, parser);
    EntityContext.prototype.copyFrom.call(this, ctx);
    return this;
}

NumberIntegerEntityContext.prototype = Object.create(EntityContext.prototype);
NumberIntegerEntityContext.prototype.constructor = NumberIntegerEntityContext;

LanguageParser.NumberIntegerEntityContext = NumberIntegerEntityContext;

NumberIntegerEntityContext.prototype.number_integer = function() {
    return this.getTypedRuleContext(Number_integerContext,0);
};

function StringEntityContext(parser, ctx) {
	EntityContext.call(this, parser);
    EntityContext.prototype.copyFrom.call(this, ctx);
    return this;
}

StringEntityContext.prototype = Object.create(EntityContext.prototype);
StringEntityContext.prototype.constructor = StringEntityContext;

LanguageParser.StringEntityContext = StringEntityContext;

StringEntityContext.prototype.text = function() {
    return this.getTypedRuleContext(TextContext,0);
};

function DateEntityContext(parser, ctx) {
	EntityContext.call(this, parser);
    EntityContext.prototype.copyFrom.call(this, ctx);
    return this;
}

DateEntityContext.prototype = Object.create(EntityContext.prototype);
DateEntityContext.prototype.constructor = DateEntityContext;

LanguageParser.DateEntityContext = DateEntityContext;

DateEntityContext.prototype.DATE = function() {
    return this.getToken(LanguageParser.DATE, 0);
};

function VarMemoryEntityContext(parser, ctx) {
	EntityContext.call(this, parser);
    EntityContext.prototype.copyFrom.call(this, ctx);
    return this;
}

VarMemoryEntityContext.prototype = Object.create(EntityContext.prototype);
VarMemoryEntityContext.prototype.constructor = VarMemoryEntityContext;

LanguageParser.VarMemoryEntityContext = VarMemoryEntityContext;

VarMemoryEntityContext.prototype.varMemory = function() {
    return this.getTypedRuleContext(VarMemoryContext,0);
};

function DataCalculoEntityContext(parser, ctx) {
	EntityContext.call(this, parser);
    EntityContext.prototype.copyFrom.call(this, ctx);
    return this;
}

DataCalculoEntityContext.prototype = Object.create(EntityContext.prototype);
DataCalculoEntityContext.prototype.constructor = DataCalculoEntityContext;

LanguageParser.DataCalculoEntityContext = DataCalculoEntityContext;

DataCalculoEntityContext.prototype.DATA_CALCULO = function() {
    return this.getToken(LanguageParser.DATA_CALCULO, 0);
};

function VarPrimaryEntityContext(parser, ctx) {
	EntityContext.call(this, parser);
    EntityContext.prototype.copyFrom.call(this, ctx);
    return this;
}

VarPrimaryEntityContext.prototype = Object.create(EntityContext.prototype);
VarPrimaryEntityContext.prototype.constructor = VarPrimaryEntityContext;

LanguageParser.VarPrimaryEntityContext = VarPrimaryEntityContext;

VarPrimaryEntityContext.prototype.VAR_PRIMARY = function() {
    return this.getToken(LanguageParser.VAR_PRIMARY, 0);
};

function NullEntityContext(parser, ctx) {
	EntityContext.call(this, parser);
    EntityContext.prototype.copyFrom.call(this, ctx);
    return this;
}

NullEntityContext.prototype = Object.create(EntityContext.prototype);
NullEntityContext.prototype.constructor = NullEntityContext;

LanguageParser.NullEntityContext = NullEntityContext;

NullEntityContext.prototype.NULL = function() {
    return this.getToken(LanguageParser.NULL, 0);
};

function VariableEntityContext(parser, ctx) {
	EntityContext.call(this, parser);
    EntityContext.prototype.copyFrom.call(this, ctx);
    return this;
}

VariableEntityContext.prototype = Object.create(EntityContext.prototype);
VariableEntityContext.prototype.constructor = VariableEntityContext;

LanguageParser.VariableEntityContext = VariableEntityContext;

VariableEntityContext.prototype.IDENTIFIER = function() {
    return this.getToken(LanguageParser.IDENTIFIER, 0);
};

function ObjectDictionartEntityContext(parser, ctx) {
	EntityContext.call(this, parser);
    EntityContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ObjectDictionartEntityContext.prototype = Object.create(EntityContext.prototype);
ObjectDictionartEntityContext.prototype.constructor = ObjectDictionartEntityContext;

LanguageParser.ObjectDictionartEntityContext = ObjectDictionartEntityContext;

ObjectDictionartEntityContext.prototype.object_dictionary = function() {
    return this.getTypedRuleContext(Object_dictionaryContext,0);
};

function ListMemoryEntityContext(parser, ctx) {
	EntityContext.call(this, parser);
    EntityContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ListMemoryEntityContext.prototype = Object.create(EntityContext.prototype);
ListMemoryEntityContext.prototype.constructor = ListMemoryEntityContext;

LanguageParser.ListMemoryEntityContext = ListMemoryEntityContext;

ListMemoryEntityContext.prototype.listMemory = function() {
    return this.getTypedRuleContext(ListMemoryContext,0);
};

function ObjectValueEntityContext(parser, ctx) {
	EntityContext.call(this, parser);
    EntityContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ObjectValueEntityContext.prototype = Object.create(EntityContext.prototype);
ObjectValueEntityContext.prototype.constructor = ObjectValueEntityContext;

LanguageParser.ObjectValueEntityContext = ObjectValueEntityContext;

ObjectValueEntityContext.prototype.object_value = function() {
    return this.getTypedRuleContext(Object_valueContext,0);
};

function ListDictionaryEntityContext(parser, ctx) {
	EntityContext.call(this, parser);
    EntityContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ListDictionaryEntityContext.prototype = Object.create(EntityContext.prototype);
ListDictionaryEntityContext.prototype.constructor = ListDictionaryEntityContext;

LanguageParser.ListDictionaryEntityContext = ListDictionaryEntityContext;

ListDictionaryEntityContext.prototype.list_dictionary = function() {
    return this.getTypedRuleContext(List_dictionaryContext,0);
};


LanguageParser.EntityContext = EntityContext;

LanguageParser.prototype.entity = function() {

    var localctx = new EntityContext(this, this._ctx, this.state);
    this.enterRule(localctx, 46, LanguageParser.RULE_entity);
    var _la = 0; // Token type
    try {
        this.state = 935;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,49,this._ctx);
        switch(la_) {
        case 1:
            localctx = new BoolEntityContext(this, localctx);
            this.enterOuterAlt(localctx, 1);
            this.state = 918;
            _la = this._input.LA(1);
            if(!(_la===LanguageParser.TRUE || _la===LanguageParser.FALSE)) {
            this._errHandler.recoverInline(this);
            }
            else {
            	this._errHandler.reportMatch(this);
                this.consume();
            }
            break;

        case 2:
            localctx = new ExercicioEntityContext(this, localctx);
            this.enterOuterAlt(localctx, 2);
            this.state = 919;
            this.match(LanguageParser.EXERCICIO);
            break;

        case 3:
            localctx = new DataCalculoEntityContext(this, localctx);
            this.enterOuterAlt(localctx, 3);
            this.state = 920;
            this.match(LanguageParser.DATA_CALCULO);
            break;

        case 4:
            localctx = new NumberDecimalEntityContext(this, localctx);
            this.enterOuterAlt(localctx, 4);
            this.state = 921;
            this.number_decimal();
            break;

        case 5:
            localctx = new NumberIntegerEntityContext(this, localctx);
            this.enterOuterAlt(localctx, 5);
            this.state = 922;
            this.number_integer();
            break;

        case 6:
            localctx = new StringEntityContext(this, localctx);
            this.enterOuterAlt(localctx, 6);
            this.state = 923;
            this.text();
            break;

        case 7:
            localctx = new DateEntityContext(this, localctx);
            this.enterOuterAlt(localctx, 7);
            this.state = 924;
            this.match(LanguageParser.DATE);
            break;

        case 8:
            localctx = new VariableEntityContext(this, localctx);
            this.enterOuterAlt(localctx, 8);
            this.state = 925;
            this.match(LanguageParser.IDENTIFIER);
            break;

        case 9:
            localctx = new ObjectDictionartEntityContext(this, localctx);
            this.enterOuterAlt(localctx, 9);
            this.state = 926;
            this.object_dictionary();
            break;

        case 10:
            localctx = new ListEntityContext(this, localctx);
            this.enterOuterAlt(localctx, 10);
            this.state = 927;
            this.list();
            break;

        case 11:
            localctx = new ListDictionaryEntityContext(this, localctx);
            this.enterOuterAlt(localctx, 11);
            this.state = 928;
            this.list_dictionary();
            break;

        case 12:
            localctx = new VarPrimaryEntityContext(this, localctx);
            this.enterOuterAlt(localctx, 12);
            this.state = 929;
            this.match(LanguageParser.VAR_PRIMARY);
            break;

        case 13:
            localctx = new VarMemoryEntityContext(this, localctx);
            this.enterOuterAlt(localctx, 13);
            this.state = 930;
            this.varMemory();
            break;

        case 14:
            localctx = new ListMemoryEntityContext(this, localctx);
            this.enterOuterAlt(localctx, 14);
            this.state = 931;
            this.listMemory();
            break;

        case 15:
            localctx = new ListMemoryGlobalEntityContext(this, localctx);
            this.enterOuterAlt(localctx, 15);
            this.state = 932;
            this.listMemoryGlobal();
            break;

        case 16:
            localctx = new ObjectValueEntityContext(this, localctx);
            this.enterOuterAlt(localctx, 16);
            this.state = 933;
            this.object_value();
            break;

        case 17:
            localctx = new NullEntityContext(this, localctx);
            this.enterOuterAlt(localctx, 17);
            this.state = 934;
            this.match(LanguageParser.NULL);
            break;

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function VarMemoryContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_varMemory;
    return this;
}

VarMemoryContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
VarMemoryContext.prototype.constructor = VarMemoryContext;


 
VarMemoryContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function VarMemoryValueContext(parser, ctx) {
	VarMemoryContext.call(this, parser);
    VarMemoryContext.prototype.copyFrom.call(this, ctx);
    return this;
}

VarMemoryValueContext.prototype = Object.create(VarMemoryContext.prototype);
VarMemoryValueContext.prototype.constructor = VarMemoryValueContext;

LanguageParser.VarMemoryValueContext = VarMemoryValueContext;

VarMemoryValueContext.prototype.VAR_PRIMARY = function() {
    return this.getToken(LanguageParser.VAR_PRIMARY, 0);
};

VarMemoryValueContext.prototype.DOT = function() {
    return this.getToken(LanguageParser.DOT, 0);
};

VarMemoryValueContext.prototype.IDENTIFIER = function() {
    return this.getToken(LanguageParser.IDENTIFIER, 0);
};


LanguageParser.VarMemoryContext = VarMemoryContext;

LanguageParser.prototype.varMemory = function() {

    var localctx = new VarMemoryContext(this, this._ctx, this.state);
    this.enterRule(localctx, 48, LanguageParser.RULE_varMemory);
    try {
        localctx = new VarMemoryValueContext(this, localctx);
        this.enterOuterAlt(localctx, 1);
        this.state = 937;
        this.match(LanguageParser.VAR_PRIMARY);
        this.state = 938;
        this.match(LanguageParser.DOT);
        this.state = 939;
        this.match(LanguageParser.IDENTIFIER);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Object_valueContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_object_value;
    return this;
}

Object_valueContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Object_valueContext.prototype.constructor = Object_valueContext;


 
Object_valueContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function ObjectValueContext(parser, ctx) {
	Object_valueContext.call(this, parser);
    Object_valueContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ObjectValueContext.prototype = Object.create(Object_valueContext.prototype);
ObjectValueContext.prototype.constructor = ObjectValueContext;

LanguageParser.ObjectValueContext = ObjectValueContext;

ObjectValueContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


ObjectValueContext.prototype.DOT = function() {
    return this.getToken(LanguageParser.DOT, 0);
};


LanguageParser.Object_valueContext = Object_valueContext;

LanguageParser.prototype.object_value = function() {

    var localctx = new Object_valueContext(this, this._ctx, this.state);
    this.enterRule(localctx, 50, LanguageParser.RULE_object_value);
    try {
        localctx = new ObjectValueContext(this, localctx);
        this.enterOuterAlt(localctx, 1);
        this.state = 941;
        this.match(LanguageParser.IDENTIFIER);
        this.state = 942;
        this.match(LanguageParser.DOT);
        this.state = 943;
        this.match(LanguageParser.IDENTIFIER);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function ListMemoryGlobalContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_listMemoryGlobal;
    return this;
}

ListMemoryGlobalContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ListMemoryGlobalContext.prototype.constructor = ListMemoryGlobalContext;


 
ListMemoryGlobalContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function ListMemoryGlobalValueContext(parser, ctx) {
	ListMemoryGlobalContext.call(this, parser);
    ListMemoryGlobalContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ListMemoryGlobalValueContext.prototype = Object.create(ListMemoryGlobalContext.prototype);
ListMemoryGlobalValueContext.prototype.constructor = ListMemoryGlobalValueContext;

LanguageParser.ListMemoryGlobalValueContext = ListMemoryGlobalValueContext;

ListMemoryGlobalValueContext.prototype.VAR_PRIMARY = function() {
    return this.getToken(LanguageParser.VAR_PRIMARY, 0);
};

ListMemoryGlobalValueContext.prototype.LBRACKET = function() {
    return this.getToken(LanguageParser.LBRACKET, 0);
};

ListMemoryGlobalValueContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

ListMemoryGlobalValueContext.prototype.RBRACKET = function() {
    return this.getToken(LanguageParser.RBRACKET, 0);
};

ListMemoryGlobalValueContext.prototype.DOT = function() {
    return this.getToken(LanguageParser.DOT, 0);
};

ListMemoryGlobalValueContext.prototype.IDENTIFIER = function() {
    return this.getToken(LanguageParser.IDENTIFIER, 0);
};


LanguageParser.ListMemoryGlobalContext = ListMemoryGlobalContext;

LanguageParser.prototype.listMemoryGlobal = function() {

    var localctx = new ListMemoryGlobalContext(this, this._ctx, this.state);
    this.enterRule(localctx, 52, LanguageParser.RULE_listMemoryGlobal);
    try {
        localctx = new ListMemoryGlobalValueContext(this, localctx);
        this.enterOuterAlt(localctx, 1);
        this.state = 945;
        this.match(LanguageParser.VAR_PRIMARY);
        this.state = 946;
        this.match(LanguageParser.LBRACKET);
        this.state = 947;
        this.arithmetic_expression(0);
        this.state = 948;
        this.match(LanguageParser.RBRACKET);
        this.state = 949;
        this.match(LanguageParser.DOT);
        this.state = 950;
        this.match(LanguageParser.IDENTIFIER);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function ListMemoryContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_listMemory;
    return this;
}

ListMemoryContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ListMemoryContext.prototype.constructor = ListMemoryContext;


 
ListMemoryContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function ListMemoryValueContext(parser, ctx) {
	ListMemoryContext.call(this, parser);
    ListMemoryContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ListMemoryValueContext.prototype = Object.create(ListMemoryContext.prototype);
ListMemoryValueContext.prototype.constructor = ListMemoryValueContext;

LanguageParser.ListMemoryValueContext = ListMemoryValueContext;

ListMemoryValueContext.prototype.VAR_PRIMARY = function() {
    return this.getToken(LanguageParser.VAR_PRIMARY, 0);
};

ListMemoryValueContext.prototype.DOT = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.DOT);
    } else {
        return this.getToken(LanguageParser.DOT, i);
    }
};


ListMemoryValueContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


ListMemoryValueContext.prototype.LBRACKET = function() {
    return this.getToken(LanguageParser.LBRACKET, 0);
};

ListMemoryValueContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

ListMemoryValueContext.prototype.RBRACKET = function() {
    return this.getToken(LanguageParser.RBRACKET, 0);
};


LanguageParser.ListMemoryContext = ListMemoryContext;

LanguageParser.prototype.listMemory = function() {

    var localctx = new ListMemoryContext(this, this._ctx, this.state);
    this.enterRule(localctx, 54, LanguageParser.RULE_listMemory);
    try {
        localctx = new ListMemoryValueContext(this, localctx);
        this.enterOuterAlt(localctx, 1);
        this.state = 952;
        this.match(LanguageParser.VAR_PRIMARY);
        this.state = 953;
        this.match(LanguageParser.DOT);
        this.state = 954;
        this.match(LanguageParser.IDENTIFIER);
        this.state = 955;
        this.match(LanguageParser.LBRACKET);
        this.state = 956;
        this.arithmetic_expression(0);
        this.state = 957;
        this.match(LanguageParser.RBRACKET);
        this.state = 958;
        this.match(LanguageParser.DOT);
        this.state = 959;
        this.match(LanguageParser.IDENTIFIER);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Object_dictionaryContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_object_dictionary;
    return this;
}

Object_dictionaryContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Object_dictionaryContext.prototype.constructor = Object_dictionaryContext;


 
Object_dictionaryContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function ObjectDictionaryValueContext(parser, ctx) {
	Object_dictionaryContext.call(this, parser);
    Object_dictionaryContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ObjectDictionaryValueContext.prototype = Object.create(Object_dictionaryContext.prototype);
ObjectDictionaryValueContext.prototype.constructor = ObjectDictionaryValueContext;

LanguageParser.ObjectDictionaryValueContext = ObjectDictionaryValueContext;

ObjectDictionaryValueContext.prototype.IDENTIFIER = function() {
    return this.getToken(LanguageParser.IDENTIFIER, 0);
};

ObjectDictionaryValueContext.prototype.LBRACKET = function() {
    return this.getToken(LanguageParser.LBRACKET, 0);
};

ObjectDictionaryValueContext.prototype.text = function() {
    return this.getTypedRuleContext(TextContext,0);
};

ObjectDictionaryValueContext.prototype.RBRACKET = function() {
    return this.getToken(LanguageParser.RBRACKET, 0);
};


LanguageParser.Object_dictionaryContext = Object_dictionaryContext;

LanguageParser.prototype.object_dictionary = function() {

    var localctx = new Object_dictionaryContext(this, this._ctx, this.state);
    this.enterRule(localctx, 56, LanguageParser.RULE_object_dictionary);
    try {
        localctx = new ObjectDictionaryValueContext(this, localctx);
        this.enterOuterAlt(localctx, 1);
        this.state = 961;
        this.match(LanguageParser.IDENTIFIER);
        this.state = 962;
        this.match(LanguageParser.LBRACKET);
        this.state = 963;
        this.text();
        this.state = 964;
        this.match(LanguageParser.RBRACKET);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function ListContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_list;
    return this;
}

ListContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
ListContext.prototype.constructor = ListContext;


 
ListContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function ListValueContext(parser, ctx) {
	ListContext.call(this, parser);
    ListContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ListValueContext.prototype = Object.create(ListContext.prototype);
ListValueContext.prototype.constructor = ListValueContext;

LanguageParser.ListValueContext = ListValueContext;

ListValueContext.prototype.IDENTIFIER = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.IDENTIFIER);
    } else {
        return this.getToken(LanguageParser.IDENTIFIER, i);
    }
};


ListValueContext.prototype.LBRACKET = function() {
    return this.getToken(LanguageParser.LBRACKET, 0);
};

ListValueContext.prototype.arithmetic_expression = function() {
    return this.getTypedRuleContext(Arithmetic_expressionContext,0);
};

ListValueContext.prototype.RBRACKET = function() {
    return this.getToken(LanguageParser.RBRACKET, 0);
};

ListValueContext.prototype.DOT = function() {
    return this.getToken(LanguageParser.DOT, 0);
};


LanguageParser.ListContext = ListContext;

LanguageParser.prototype.list = function() {

    var localctx = new ListContext(this, this._ctx, this.state);
    this.enterRule(localctx, 58, LanguageParser.RULE_list);
    try {
        localctx = new ListValueContext(this, localctx);
        this.enterOuterAlt(localctx, 1);
        this.state = 966;
        this.match(LanguageParser.IDENTIFIER);
        this.state = 967;
        this.match(LanguageParser.LBRACKET);
        this.state = 968;
        this.arithmetic_expression(0);
        this.state = 969;
        this.match(LanguageParser.RBRACKET);
        this.state = 972;
        this._errHandler.sync(this);
        var la_ = this._interp.adaptivePredict(this._input,50,this._ctx);
        if(la_===1) {
            this.state = 970;
            this.match(LanguageParser.DOT);
            this.state = 971;
            this.match(LanguageParser.IDENTIFIER);

        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function List_dictionaryContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_list_dictionary;
    return this;
}

List_dictionaryContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
List_dictionaryContext.prototype.constructor = List_dictionaryContext;


 
List_dictionaryContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function ListDictionaryValueContext(parser, ctx) {
	List_dictionaryContext.call(this, parser);
    List_dictionaryContext.prototype.copyFrom.call(this, ctx);
    return this;
}

ListDictionaryValueContext.prototype = Object.create(List_dictionaryContext.prototype);
ListDictionaryValueContext.prototype.constructor = ListDictionaryValueContext;

LanguageParser.ListDictionaryValueContext = ListDictionaryValueContext;

ListDictionaryValueContext.prototype.IDENTIFIER = function() {
    return this.getToken(LanguageParser.IDENTIFIER, 0);
};

ListDictionaryValueContext.prototype.LBRACKET = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.LBRACKET);
    } else {
        return this.getToken(LanguageParser.LBRACKET, i);
    }
};


ListDictionaryValueContext.prototype.arithmetic_expression = function(i) {
    if(i===undefined) {
        i = null;
    }
    if(i===null) {
        return this.getTypedRuleContexts(Arithmetic_expressionContext);
    } else {
        return this.getTypedRuleContext(Arithmetic_expressionContext,i);
    }
};

ListDictionaryValueContext.prototype.RBRACKET = function(i) {
	if(i===undefined) {
		i = null;
	}
    if(i===null) {
        return this.getTokens(LanguageParser.RBRACKET);
    } else {
        return this.getToken(LanguageParser.RBRACKET, i);
    }
};



LanguageParser.List_dictionaryContext = List_dictionaryContext;

LanguageParser.prototype.list_dictionary = function() {

    var localctx = new List_dictionaryContext(this, this._ctx, this.state);
    this.enterRule(localctx, 60, LanguageParser.RULE_list_dictionary);
    try {
        localctx = new ListDictionaryValueContext(this, localctx);
        this.enterOuterAlt(localctx, 1);
        this.state = 974;
        this.match(LanguageParser.IDENTIFIER);
        this.state = 975;
        this.match(LanguageParser.LBRACKET);
        this.state = 976;
        this.arithmetic_expression(0);
        this.state = 977;
        this.match(LanguageParser.RBRACKET);
        this.state = 978;
        this.match(LanguageParser.LBRACKET);
        this.state = 979;
        this.arithmetic_expression(0);
        this.state = 980;
        this.match(LanguageParser.RBRACKET);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function TextContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_text;
    return this;
}

TextContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
TextContext.prototype.constructor = TextContext;


 
TextContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function StringContext(parser, ctx) {
	TextContext.call(this, parser);
    TextContext.prototype.copyFrom.call(this, ctx);
    return this;
}

StringContext.prototype = Object.create(TextContext.prototype);
StringContext.prototype.constructor = StringContext;

LanguageParser.StringContext = StringContext;

StringContext.prototype.TEXT = function() {
    return this.getToken(LanguageParser.TEXT, 0);
};


LanguageParser.TextContext = TextContext;

LanguageParser.prototype.text = function() {

    var localctx = new TextContext(this, this._ctx, this.state);
    this.enterRule(localctx, 62, LanguageParser.RULE_text);
    try {
        localctx = new StringContext(this, localctx);
        this.enterOuterAlt(localctx, 1);
        this.state = 982;
        this.match(LanguageParser.TEXT);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Number_integerContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_number_integer;
    return this;
}

Number_integerContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Number_integerContext.prototype.constructor = Number_integerContext;


 
Number_integerContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function NumberIntegerContext(parser, ctx) {
	Number_integerContext.call(this, parser);
    Number_integerContext.prototype.copyFrom.call(this, ctx);
    return this;
}

NumberIntegerContext.prototype = Object.create(Number_integerContext.prototype);
NumberIntegerContext.prototype.constructor = NumberIntegerContext;

LanguageParser.NumberIntegerContext = NumberIntegerContext;

NumberIntegerContext.prototype.NUMBER = function() {
    return this.getToken(LanguageParser.NUMBER, 0);
};


LanguageParser.Number_integerContext = Number_integerContext;

LanguageParser.prototype.number_integer = function() {

    var localctx = new Number_integerContext(this, this._ctx, this.state);
    this.enterRule(localctx, 64, LanguageParser.RULE_number_integer);
    try {
        localctx = new NumberIntegerContext(this, localctx);
        this.enterOuterAlt(localctx, 1);
        this.state = 984;
        this.match(LanguageParser.NUMBER);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Number_decimalContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_number_decimal;
    return this;
}

Number_decimalContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Number_decimalContext.prototype.constructor = Number_decimalContext;


 
Number_decimalContext.prototype.copyFrom = function(ctx) {
    antlr4.ParserRuleContext.prototype.copyFrom.call(this, ctx);
};


function NumberDecimalContext(parser, ctx) {
	Number_decimalContext.call(this, parser);
    Number_decimalContext.prototype.copyFrom.call(this, ctx);
    return this;
}

NumberDecimalContext.prototype = Object.create(Number_decimalContext.prototype);
NumberDecimalContext.prototype.constructor = NumberDecimalContext;

LanguageParser.NumberDecimalContext = NumberDecimalContext;

NumberDecimalContext.prototype.DECIMAL = function() {
    return this.getToken(LanguageParser.DECIMAL, 0);
};


LanguageParser.Number_decimalContext = Number_decimalContext;

LanguageParser.prototype.number_decimal = function() {

    var localctx = new Number_decimalContext(this, this._ctx, this.state);
    this.enterRule(localctx, 66, LanguageParser.RULE_number_decimal);
    try {
        localctx = new NumberDecimalContext(this, localctx);
        this.enterOuterAlt(localctx, 1);
        this.state = 986;
        this.match(LanguageParser.DECIMAL);
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


function Date_unitContext(parser, parent, invokingState) {
	if(parent===undefined) {
	    parent = null;
	}
	if(invokingState===undefined || invokingState===null) {
		invokingState = -1;
	}
	antlr4.ParserRuleContext.call(this, parent, invokingState);
    this.parser = parser;
    this.ruleIndex = LanguageParser.RULE_date_unit;
    return this;
}

Date_unitContext.prototype = Object.create(antlr4.ParserRuleContext.prototype);
Date_unitContext.prototype.constructor = Date_unitContext;

Date_unitContext.prototype.YEAR = function() {
    return this.getToken(LanguageParser.YEAR, 0);
};

Date_unitContext.prototype.MONTH = function() {
    return this.getToken(LanguageParser.MONTH, 0);
};

Date_unitContext.prototype.DAY = function() {
    return this.getToken(LanguageParser.DAY, 0);
};




LanguageParser.Date_unitContext = Date_unitContext;

LanguageParser.prototype.date_unit = function() {

    var localctx = new Date_unitContext(this, this._ctx, this.state);
    this.enterRule(localctx, 68, LanguageParser.RULE_date_unit);
    var _la = 0; // Token type
    try {
        this.enterOuterAlt(localctx, 1);
        this.state = 988;
        _la = this._input.LA(1);
        if(!(((((_la - 79)) & ~0x1f) == 0 && ((1 << (_la - 79)) & ((1 << (LanguageParser.YEAR - 79)) | (1 << (LanguageParser.MONTH - 79)) | (1 << (LanguageParser.DAY - 79)))) !== 0))) {
        this._errHandler.recoverInline(this);
        }
        else {
        	this._errHandler.reportMatch(this);
            this.consume();
        }
    } catch (re) {
    	if(re instanceof antlr4.error.RecognitionException) {
	        localctx.exception = re;
	        this._errHandler.reportError(this, re);
	        this._errHandler.recover(this, re);
	    } else {
	    	throw re;
	    }
    } finally {
        this.exitRule();
    }
    return localctx;
};


LanguageParser.prototype.sempred = function(localctx, ruleIndex, predIndex) {
	switch(ruleIndex) {
	case 8:
			return this.if_expression_sempred(localctx, predIndex);
	case 20:
			return this.arithmetic_expression_sempred(localctx, predIndex);
    default:
        throw "No predicate with index:" + ruleIndex;
   }
};

LanguageParser.prototype.if_expression_sempred = function(localctx, predIndex) {
	switch(predIndex) {
		case 0:
			return this.precpred(this._ctx, 7);
		case 1:
			return this.precpred(this._ctx, 6);
		default:
			throw "No predicate with index:" + predIndex;
	}
};

LanguageParser.prototype.arithmetic_expression_sempred = function(localctx, predIndex) {
	switch(predIndex) {
		case 2:
			return this.precpred(this._ctx, 7);
		case 3:
			return this.precpred(this._ctx, 6);
		default:
			throw "No predicate with index:" + predIndex;
	}
};


exports.LanguageParser = LanguageParser;
